var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g2, _g3, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _g4, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _g5, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 401,
    height: 303,
    viewBox: "0 0 401 303",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_807_97)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1,
    d: "M318.197 98.9827V101.491C353.504 121.35 375.703 149.998 375.703 181.8C375.703 213.601 353.504 242.25 318.197 262.109V264.617C354.829 244.31 377.961 214.717 377.961 181.8C377.961 148.882 354.829 119.279 318.197 98.9827Z",
    fill: "url(#paint0_radial_807_97)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M24.1912 180.661C24.2258 151.379 42.9107 124.18 76.8131 104.057C106.062 86.6946 144.722 76.0864 185.674 74.188L185.582 72.186C144.307 74.096 105.313 84.8077 75.7879 102.331C41.2519 122.834 22.2214 150.643 22.1753 180.661H24.1797H24.1912Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M201.548 290.908C158.154 290.908 116.349 281.381 83.8402 264.099C83.5177 263.927 83.3103 263.593 83.3103 263.225C83.3103 262.857 83.5061 262.512 83.8287 262.339L165.492 217.352V217.697C165.492 217.341 165.688 217.007 165.987 216.834L201.157 197.804L202.17 199.542L167.496 218.284V217.951C167.496 218.319 167.3 218.652 166.978 218.825L86.4321 263.202C118.411 279.793 159.213 288.917 201.56 288.917C226.408 288.917 250.323 285.88 272.671 279.897C273.166 279.77 286.759 275.191 287.255 275.053L287.785 276.986C287.347 277.101 273.8 281.669 273.362 281.784C250.795 287.847 226.638 290.919 201.56 290.919L201.548 290.908Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M192.528 195.308L77.0781 257.979C55.9049 245.322 40.6644 229.951 32.1398 213.095L30.1584 213.67C38.9019 231.136 54.6378 246.991 76.5367 259.992C76.698 260.084 76.8707 260.13 77.0551 260.13C77.2163 260.13 77.3776 260.096 77.5274 260.015L193.392 197.114L192.528 195.296V195.308Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M299.719 269.599L298.959 267.735C307.91 264.111 316.388 259.935 324.141 255.332C332.573 250.327 340.176 244.805 346.731 238.925L348.079 240.421C341.42 246.392 333.714 251.984 325.166 257.058C317.321 261.706 308.762 265.929 299.719 269.599Z",
    fill: "url(#paint1_linear_807_97)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.3,
    d: "M309.499 293.623L308.739 291.759C317.69 288.135 326.168 283.958 333.921 279.356C342.353 274.351 349.956 268.828 356.511 262.949L357.859 264.445C351.2 270.416 343.494 276.008 334.946 281.082C327.101 285.73 318.542 289.953 309.499 293.623Z",
    fill: "url(#paint2_radial_807_97)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M323.392 101.123C297.496 85.7512 265.033 75.6953 229.518 72.025L229.725 70.0231C265.529 73.7164 298.279 83.8758 324.417 99.3854L323.392 101.111V101.123Z",
    fill: "url(#paint3_linear_807_97)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1912 177.29C24.2258 148.008 42.9107 120.809 76.8131 100.685C106.062 83.3235 144.722 72.7153 185.674 70.8169L185.582 68.8149C144.307 70.7249 105.313 81.4366 75.7879 98.9596C41.2519 119.463 22.2214 147.272 22.1753 177.29H24.1797H24.1912Z",
    fill: "url(#paint4_linear_807_97)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.3,
    d: "M2.00442 163.771C2.03898 134.489 20.7239 107.29 54.6263 87.1664C83.8748 69.8045 122.535 59.1963 163.487 57.2979L163.395 55.2959C122.12 57.2058 83.126 67.9175 53.6011 85.4406C19.0766 105.944 0.034559 133.753 0 163.771H2.00442Z",
    fill: "url(#paint5_radial_807_97)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.3,
    d: "M53.8775 192.489C53.9121 163.207 72.597 136.008 106.499 115.884C135.748 98.5224 174.408 87.9142 215.36 86.0158L215.268 84.0138C173.993 85.9237 134.999 96.6354 105.474 114.158C70.9382 134.661 51.9077 162.47 51.8616 192.489H53.866H53.8775Z",
    fill: "url(#paint6_radial_807_97)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.3,
    d: "M387.775 161.895C387.741 132.613 369.056 105.414 335.153 85.2909C305.905 67.929 267.245 57.3208 226.292 55.4224L226.385 53.4204C267.66 55.3303 306.654 66.0421 336.179 83.5651C370.715 104.068 389.745 131.877 389.791 161.895H387.787H387.775Z",
    fill: "url(#paint7_radial_807_97)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.3,
    d: "M338.149 188.358C338.114 159.076 319.429 131.877 285.527 111.754C256.278 94.3919 217.618 83.7837 176.666 81.8853L176.758 79.8833C218.033 81.7932 257.027 92.5049 286.552 110.028C321.088 130.531 340.118 158.34 340.165 188.358H338.16H338.149Z",
    fill: "url(#paint8_radial_807_97)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.3,
    d: "M389.457 158.513C389.423 129.231 370.738 102.032 336.835 81.9084C307.587 64.5464 268.927 53.9382 227.974 52.0398L228.067 50.0378C269.342 51.9478 308.336 62.6595 337.861 80.1825C372.397 100.685 391.427 128.495 391.473 158.513H389.469H389.457Z",
    fill: "url(#paint9_radial_807_97)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M284.882 66.2952C286.483 65.3747 288.51 64.8685 290.538 64.8915C291.356 64.8915 292.128 65.0066 292.853 65.1791C293.637 65.3632 294.535 65.7314 295.157 66.0881L344.404 94.4839C346.097 95.4619 346.984 97.0036 346.881 98.6949C346.858 99.1667 346.742 99.6269 346.57 100.076C346.132 101.272 344.922 102.538 343.551 103.332L315.893 119.278C315.559 119.474 315.121 119.693 314.752 119.842C313.404 120.406 311.872 120.717 310.317 120.728C308.566 120.728 306.965 120.36 305.721 119.635L256.278 91.1243C254.585 90.1463 253.698 88.593 253.813 86.9132C253.836 86.5105 253.928 86.1078 254.055 85.7166C254.458 84.451 255.714 83.0934 257.165 82.265L284.893 66.2722L284.882 66.2952Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M285.008 66.5139C286.61 65.5934 288.637 65.1102 290.641 65.1562C291.459 65.1792 292.231 65.3058 292.934 65.4784C293.637 65.6509 294.65 66.0882 295.215 66.4103L344.277 94.7026C345.959 95.6691 346.754 97.2108 346.546 98.8561C346.489 99.3048 346.339 99.742 346.166 100.179C345.74 101.238 344.346 102.595 343.114 103.309L315.847 119.037C315.547 119.21 315.052 119.463 314.718 119.601C313.393 120.164 311.884 120.487 310.363 120.51C308.647 120.533 307.057 120.164 305.824 119.451L256.382 90.9403C254.689 89.9623 253.905 88.409 254.124 86.7752C254.182 86.384 254.297 86.0159 254.435 85.6362C254.838 84.5086 256.29 83.0704 257.592 82.3226L284.985 66.5254L285.008 66.5139Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M285.135 66.7209C286.736 65.8004 288.775 65.3287 290.757 65.3977C291.575 65.4323 292.335 65.5818 293.038 65.7544C293.66 65.9155 294.789 66.4333 295.295 66.7209L344.173 94.9096C345.855 95.8761 346.558 97.4063 346.247 99.0056C346.166 99.4313 345.982 99.8455 345.798 100.26C345.394 101.192 343.805 102.618 342.71 103.251L315.847 118.749C315.582 118.899 315.029 119.186 314.741 119.313C313.45 119.877 311.964 120.21 310.455 120.233C308.762 120.256 307.195 119.911 305.986 119.209L256.555 90.6986C254.861 89.7206 254.17 88.1788 254.516 86.5796C254.596 86.2114 254.746 85.8662 254.884 85.498C255.276 84.5085 256.935 82.9783 258.098 82.311L285.158 66.7094L285.135 66.7209Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M285.262 66.9396C286.852 66.0191 288.902 65.5704 290.86 65.6624C291.667 65.6969 292.427 65.8695 293.118 66.0651C293.66 66.2147 294.915 66.8015 295.353 67.0546L344.047 95.1283C345.717 96.0947 346.339 97.6135 345.913 99.1667C345.798 99.5694 345.59 99.9491 345.395 100.363C345.014 101.169 343.229 102.664 342.273 103.228L315.8 118.496C315.57 118.634 314.96 118.956 314.706 119.06C313.439 119.612 311.976 119.969 310.501 119.992C308.843 120.026 307.287 119.693 306.101 119.002L256.67 90.4915C254.988 89.525 254.378 87.9833 254.838 86.4185C254.942 86.0734 255.126 85.7397 255.276 85.383C255.645 84.5316 257.534 82.9208 258.536 82.334L285.273 66.9165L285.262 66.9396Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M285.377 67.1466C286.967 66.2262 289.029 65.8005 290.964 65.904C291.77 65.95 292.519 66.1456 293.21 66.3412C293.671 66.4793 295.042 67.1466 295.422 67.3652L343.92 95.3354C345.579 96.2903 346.12 97.7975 345.59 99.3163C345.452 99.7075 345.21 100.053 345.003 100.444C344.657 101.123 342.664 102.699 341.847 103.171L315.766 118.208C315.57 118.324 314.902 118.68 314.683 118.772C313.439 119.325 311.999 119.681 310.548 119.727C308.912 119.773 307.38 119.451 306.216 118.784L256.785 90.2729C255.103 89.3064 254.585 87.7762 255.161 86.2459C255.288 85.9123 255.495 85.6131 255.668 85.2679C256.013 84.5546 258.121 82.8518 258.985 82.357L285.389 67.1351L285.377 67.1466Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M285.504 67.3653C287.093 66.4563 289.155 66.0306 291.079 66.1687C291.886 66.2262 292.623 66.4448 293.302 66.6519C293.683 66.767 295.169 67.5149 295.48 67.6989L343.793 95.5655C345.441 96.5205 345.901 98.0162 345.256 99.4889C345.095 99.8571 344.888 100.214 344.6 100.559C344.404 101.157 342.088 102.757 341.409 103.159L315.731 117.967C315.57 118.059 314.844 118.45 314.671 118.531C313.45 119.083 312.045 119.451 310.617 119.497C309.015 119.555 307.495 119.244 306.343 118.588L256.912 90.0773C255.241 89.1109 254.804 87.5806 255.506 86.0964C255.656 85.7857 255.829 85.4751 256.082 85.1759C256.267 84.5316 258.732 82.8173 259.458 82.4031L285.527 67.3653H285.504Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M285.63 67.5838C287.209 66.6749 289.294 66.2722 291.183 66.4217C291.989 66.4908 292.715 66.7324 293.383 66.9395C293.683 67.0315 295.284 67.8714 295.537 68.0095L343.667 95.761C345.314 96.7045 345.694 98.2002 344.934 99.6269C344.749 99.9721 344.519 100.306 344.208 100.628C344.047 101.111 341.524 102.779 340.982 103.102L315.697 117.679C315.559 117.76 314.798 118.185 314.648 118.243C313.45 118.795 312.068 119.175 310.663 119.232C309.084 119.29 307.587 119.002 306.458 118.358L257.027 89.8471C255.357 88.8807 255 87.3619 255.829 85.9122C256.002 85.6131 256.198 85.3254 256.463 85.0493C256.612 84.5431 259.308 82.7482 259.884 82.4145L285.63 67.5723V67.5838Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M285.757 67.791C287.335 66.882 289.42 66.4908 291.298 66.6749C292.104 66.7555 292.819 67.0086 293.487 67.2387C293.717 67.3192 295.434 68.2282 295.618 68.3432L343.563 95.9912C345.199 96.9346 345.51 98.4189 344.623 99.811C344.415 100.133 344.162 100.455 343.828 100.743C343.713 101.1 340.971 102.837 340.568 103.079L315.674 117.438C315.57 117.495 314.752 117.955 314.649 118.001C313.474 118.554 312.114 118.945 310.743 119.002C309.2 119.071 307.702 118.795 306.608 118.162L257.177 89.6516C255.518 88.6966 255.218 87.1664 256.186 85.7627C256.382 85.4866 256.601 85.2104 256.889 84.9573C256.993 84.5776 259.93 82.7022 260.368 82.4491L285.78 67.791H285.757Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M285.872 68.0095C287.439 67.1006 289.547 66.7324 291.39 66.928C292.185 67.02 292.899 67.2961 293.556 67.5263C293.706 67.5838 295.537 68.5848 295.664 68.6538L343.425 96.1867C345.049 97.1187 345.302 98.6144 344.289 99.949C344.058 100.248 343.782 100.547 343.425 100.823C343.344 101.065 340.395 102.871 340.13 103.033L315.639 117.161C315.57 117.196 314.695 117.691 314.625 117.725C313.473 118.266 312.149 118.68 310.789 118.749C309.269 118.83 307.794 118.565 306.723 117.944L257.292 89.4329C255.633 88.478 255.414 86.9477 256.52 85.5901C256.728 85.3254 256.981 85.0723 257.292 84.8307C257.361 84.5776 260.529 82.6331 260.829 82.4605L285.907 67.998L285.872 68.0095Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M285.999 68.2166C287.566 67.3077 289.674 66.951 291.505 67.1811C292.3 67.2847 293.003 67.5838 293.648 67.8254C293.717 67.8484 295.664 68.9415 295.733 68.9875L343.298 96.4168C344.911 97.3488 345.095 98.833 343.954 100.122C343.701 100.398 343.39 100.674 343.021 100.927C342.987 101.042 339.819 102.917 339.692 102.998L315.593 116.897C315.593 116.897 314.625 117.449 314.591 117.461C313.462 118.001 312.16 118.416 310.835 118.496C309.349 118.588 307.886 118.335 306.838 117.725L257.407 89.2143C255.748 88.2594 255.599 86.7176 256.843 85.4175C257.073 85.1759 257.35 84.9342 257.672 84.7156C257.707 84.5891 261.116 82.5641 261.255 82.4836L285.999 68.2166Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.953 117.518L257.522 89.0073C255.576 87.8798 255.818 85.9123 258.064 84.6122L286.126 68.4353C288.384 67.1352 291.793 66.9971 293.74 68.1246L343.171 96.6355C345.118 97.7631 344.876 99.7305 342.63 101.031L314.568 117.208C312.31 118.508 308.9 118.646 306.953 117.518Z",
    fill: "black"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M306.953 117.472L257.522 88.9613C256.647 88.455 256.221 87.7877 256.209 87.0859C256.209 87.0629 256.209 84.6582 256.209 84.6352C256.221 83.7838 256.854 85.268 258.075 84.5661L286.137 68.3893C288.395 67.0891 291.805 66.9511 293.752 68.0786L343.183 96.5895C343.839 96.9692 344.312 95.3699 344.473 95.8762C344.531 96.0487 344.496 98.2808 344.496 98.4534C344.519 99.3278 343.885 100.26 342.63 100.973L314.568 117.15C312.31 118.45 308.9 118.588 306.953 117.461V117.472Z",
    fill: "url(#paint10_linear_807_97)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M306.953 115.067L257.522 86.5566C255.576 85.4291 255.818 83.4616 258.064 82.1615L286.126 65.9846C288.384 64.6845 291.793 64.5464 293.74 65.674L343.171 94.1848C345.118 95.3124 344.876 97.2798 342.63 98.58L314.568 114.757C312.31 116.057 308.9 116.195 306.953 115.067Z",
    fill: "url(#paint11_linear_807_97)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M310.271 114.837C309.154 114.837 308.163 114.619 307.46 114.205L258.018 85.6936C257.707 85.521 257.188 85.1414 257.188 84.6351C257.188 84.1289 257.695 83.4961 258.559 83.0013L286.61 66.8244C287.647 66.2262 289.04 65.881 290.423 65.881C291.54 65.881 292.531 66.0996 293.234 66.5138L342.664 95.0247C342.976 95.1972 343.494 95.5769 343.494 96.0832C343.494 96.5894 342.987 97.2222 342.123 97.717L314.073 113.894C313.036 114.492 311.642 114.837 310.26 114.837H310.271Z",
    fill: "url(#paint12_linear_807_97)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M342.63 98.1657L314.568 114.343C312.31 115.643 308.9 115.781 306.953 114.653L257.522 86.1423C256.716 85.6706 256.29 85.0608 256.221 84.4165C256.117 85.2104 256.543 85.9928 257.522 86.5565L306.953 115.067C308.9 116.195 312.31 116.057 314.568 114.757L342.63 98.5799C343.955 97.8205 344.577 96.831 344.485 95.9106C344.381 96.7045 343.759 97.5214 342.63 98.1657Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M327.931 109.694C330.177 115.148 325.327 122.293 317.102 125.676C308.877 129.047 300.399 127.367 298.164 121.913C295.929 116.46 300.767 109.315 308.992 105.932C317.217 102.561 325.696 104.241 327.931 109.694Z",
    fill: "url(#paint13_radial_807_97)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M296.678 72.2321C297.991 76.029 293.821 80.9073 287.381 83.1279C280.942 85.337 274.652 84.0599 273.339 80.2515C272.026 76.4547 276.196 71.5763 282.635 69.3557C289.075 67.1466 295.365 68.4238 296.678 72.2321Z",
    fill: "url(#paint14_radial_807_97)"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M315.743 104.563L275.597 81.4136C274.79 80.9534 274.894 80.1365 275.827 79.6072L290.895 70.9205C291.828 70.3797 293.222 70.3222 294.028 70.7939L334.174 93.9432C334.981 94.4034 334.877 95.2203 333.944 95.7496L318.876 104.436C317.943 104.977 316.549 105.035 315.743 104.563Z",
    fill: "url(#paint15_linear_807_97)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M291.77 72.6118L294.339 74.096C294.662 74.2801 295.192 74.2801 295.526 74.096C295.848 73.912 295.848 73.6013 295.526 73.4172L292.957 71.933C292.634 71.7489 292.104 71.7489 291.77 71.933C291.448 72.1171 291.448 72.4277 291.77 72.6118ZM296.171 75.1546L297.392 75.8564C297.715 76.0405 298.244 76.0405 298.579 75.8564C298.901 75.6723 298.901 75.3617 298.579 75.1776L297.357 74.4757C297.035 74.2916 296.505 74.2916 296.171 74.4757C295.848 74.6598 295.848 74.9705 296.171 75.1546ZM299.224 76.9149L300.445 77.6168C300.767 77.8008 301.297 77.8008 301.631 77.6168C301.954 77.4327 301.954 77.122 301.631 76.9379L300.41 76.2361C300.088 76.052 299.558 76.052 299.224 76.2361C298.901 76.4202 298.901 76.7308 299.224 76.9149ZM302.276 78.6753L303.497 79.3771C303.82 79.5612 304.35 79.5612 304.684 79.3771C305.007 79.193 305.007 78.8824 304.684 78.6983L303.463 77.9964C303.14 77.8124 302.61 77.8124 302.276 77.9964C301.954 78.1805 301.954 78.4912 302.276 78.6753ZM305.329 80.4356L306.55 81.1375C306.873 81.3216 307.403 81.3216 307.737 81.1375C308.059 80.9534 308.059 80.6427 307.737 80.4586L306.516 79.7568C306.193 79.5727 305.663 79.5727 305.329 79.7568C305.007 79.9409 305.007 80.2515 305.329 80.4356ZM308.382 82.196L309.603 82.8978C309.925 83.0819 310.455 83.0819 310.789 82.8978C311.112 82.7137 311.112 82.4031 310.789 82.219L309.568 81.5172C309.246 81.3331 308.716 81.3331 308.382 81.5172C308.059 81.7012 308.059 82.0119 308.382 82.196ZM311.435 83.9563L312.656 84.6582C312.978 84.8423 313.508 84.8423 313.842 84.6582C314.165 84.4741 314.165 84.1634 313.842 83.9794L312.621 83.2775C312.298 83.0934 311.769 83.0934 311.435 83.2775C311.112 83.4616 311.112 83.7723 311.435 83.9563ZM314.487 85.7167L315.708 86.4185C316.031 86.6026 316.561 86.6026 316.895 86.4185C317.217 86.2345 317.217 85.9238 316.895 85.7397L315.674 85.0379C315.351 84.8538 314.821 84.8538 314.487 85.0379C314.165 85.222 314.165 85.5326 314.487 85.7167ZM317.54 87.4771L318.761 88.1789C319.084 88.363 319.613 88.363 319.948 88.1789C320.27 87.9948 320.27 87.6842 319.948 87.5001L318.726 86.7982C318.404 86.6141 317.874 86.6141 317.54 86.7982C317.217 86.9823 317.217 87.293 317.54 87.4771ZM320.593 89.2374L321.814 89.9393C322.136 90.1233 322.666 90.1233 323 89.9393C323.323 89.7552 323.323 89.4445 323 89.2604L321.779 88.5586C321.457 88.3745 320.927 88.3745 320.593 88.5586C320.27 88.7427 320.27 89.0533 320.593 89.2374ZM323.645 90.9978L324.866 91.6996C325.189 91.8837 325.719 91.8837 326.053 91.6996C326.376 91.5155 326.376 91.2049 326.053 91.0208L324.832 90.3189C324.509 90.1349 323.979 90.1349 323.645 90.3189C323.323 90.503 323.323 90.8137 323.645 90.9978ZM326.698 92.7581L327.919 93.46C328.242 93.6441 328.772 93.6441 329.106 93.46C329.428 93.2759 329.428 92.9652 329.106 92.7811L327.885 92.0793C327.562 91.8952 327.032 91.8952 326.698 92.0793C326.376 92.2634 326.376 92.574 326.698 92.7581ZM329.808 94.553L331.029 95.2548C331.352 95.4389 331.882 95.4389 332.216 95.2548C332.539 95.0708 332.539 94.7601 332.216 94.576L330.995 93.8742C330.672 93.6901 330.142 93.6901 329.808 93.8742C329.486 94.0583 329.486 94.3689 329.808 94.553ZM289.04 74.3031L290.1 74.9129C290.469 75.1315 291.079 75.1315 291.448 74.9129L292.496 74.3031C292.865 74.0845 292.865 73.7394 292.496 73.5323L291.436 72.9225C291.068 72.7039 290.457 72.7039 290.089 72.9225L289.04 73.5323C288.672 73.7509 288.672 74.096 289.04 74.3031ZM294.489 76.6733L295.537 76.0635C295.906 75.8449 295.906 75.4997 295.537 75.2926L294.478 74.6828C294.109 74.4642 293.498 74.4642 293.13 74.6828L292.081 75.2926C291.713 75.5112 291.713 75.8564 292.081 76.0635L293.141 76.6733C293.51 76.8919 294.12 76.8919 294.489 76.6733ZM295.146 77.8239L296.205 78.4337C296.574 78.6523 297.185 78.6523 297.553 78.4337L298.602 77.8239C298.97 77.6052 298.97 77.2601 298.602 77.053L297.542 76.4432C297.173 76.2246 296.563 76.2246 296.194 76.4432L295.146 77.053C294.777 77.2716 294.777 77.6168 295.146 77.8239ZM298.198 79.5842L299.258 80.194C299.627 80.4126 300.237 80.4126 300.606 80.194L301.654 79.5842C302.023 79.3656 302.023 79.0204 301.654 78.8133L300.594 78.2035C300.226 77.9849 299.615 77.9849 299.247 78.2035L298.198 78.8133C297.83 79.0319 297.83 79.3771 298.198 79.5842ZM304.695 80.5737L303.636 79.9639C303.267 79.7453 302.657 79.7453 302.288 79.9639L301.24 80.5737C300.871 80.7923 300.871 81.1375 301.24 81.3446L302.299 81.9544C302.668 82.173 303.279 82.173 303.647 81.9544L304.695 81.3446C305.064 81.126 305.064 80.7808 304.695 80.5737ZM307.748 82.334L306.688 81.7243C306.32 81.5056 305.709 81.5056 305.341 81.7243L304.292 82.334C303.924 82.5527 303.924 82.8978 304.292 83.1049L305.352 83.7147C305.721 83.9333 306.331 83.9333 306.7 83.7147L307.748 83.1049C308.117 82.8863 308.117 82.5412 307.748 82.334ZM310.801 84.0944L309.741 83.4846C309.372 83.266 308.762 83.266 308.393 83.4846L307.345 84.0944C306.976 84.313 306.976 84.6582 307.345 84.8653L308.405 85.4751C308.773 85.6937 309.384 85.6937 309.753 85.4751L310.801 84.8653C311.17 84.6467 311.17 84.3015 310.801 84.0944ZM313.854 85.8548L312.794 85.245C312.425 85.0264 311.815 85.0264 311.446 85.245L310.398 85.8548C310.029 86.0734 310.029 86.4185 310.398 86.6256L311.458 87.2354C311.826 87.454 312.437 87.454 312.805 87.2354L313.854 86.6256C314.222 86.407 314.222 86.0619 313.854 85.8548ZM316.906 87.6151L315.847 87.0053C315.478 86.7867 314.867 86.7867 314.499 87.0053L313.45 87.6151C313.082 87.8337 313.082 88.1789 313.45 88.386L314.51 88.9958C314.879 89.2144 315.489 89.2144 315.858 88.9958L316.906 88.386C317.275 88.1674 317.275 87.8222 316.906 87.6151ZM319.959 89.3755L318.899 88.7657C318.531 88.5471 317.92 88.5471 317.551 88.7657L316.503 89.3755C316.135 89.5941 316.135 89.9393 316.503 90.1464L317.563 90.7562C317.932 90.9748 318.542 90.9748 318.911 90.7562L319.959 90.1464C320.328 89.9277 320.328 89.5826 319.959 89.3755ZM319.567 91.9067L320.627 92.5165C320.996 92.7351 321.606 92.7351 321.975 92.5165L323.023 91.9067C323.392 91.6881 323.392 91.3429 323.023 91.1358L321.963 90.526C321.595 90.3074 320.984 90.3074 320.616 90.526L319.567 91.1358C319.199 91.3544 319.199 91.6996 319.567 91.9067ZM326.064 92.8962L325.005 92.2864C324.636 92.0678 324.026 92.0678 323.657 92.2864L322.609 92.8962C322.24 93.1148 322.24 93.46 322.609 93.6671L323.668 94.2769C324.037 94.4955 324.648 94.4955 325.016 94.2769L326.064 93.6671C326.433 93.4485 326.433 93.1033 326.064 92.8962ZM330.534 95.4735L328.127 94.0813C327.758 93.8627 327.147 93.8627 326.779 94.0813L325.73 94.6911C325.362 94.9097 325.362 95.2548 325.73 95.4619L328.138 96.8541C328.507 97.0727 329.117 97.0727 329.486 96.8541L330.534 96.2443C330.903 96.0257 330.903 95.6806 330.534 95.4735ZM286.241 75.9484L288.649 77.3406C289.017 77.5592 289.628 77.5592 289.996 77.3406L291.045 76.7308C291.413 76.5122 291.413 76.167 291.045 75.9599L288.637 74.5678C288.268 74.3492 287.658 74.3492 287.289 74.5678L286.241 75.1776C285.872 75.3962 285.872 75.7413 286.241 75.9484ZM290.641 78.4912L291.701 79.101C292.07 79.3196 292.68 79.3196 293.049 79.101L294.097 78.4912C294.466 78.2726 294.466 77.9274 294.097 77.7203L293.038 77.1105C292.669 76.8919 292.058 76.8919 291.69 77.1105L290.641 77.7203C290.273 77.9389 290.273 78.2841 290.641 78.4912ZM294.742 80.8613C295.111 81.0799 295.722 81.0799 296.09 80.8613L297.139 80.2515C297.507 80.0329 297.507 79.6878 297.139 79.4807L296.079 78.8709C295.71 78.6523 295.1 78.6523 294.731 78.8709L293.683 79.4807C293.314 79.6993 293.314 80.0444 293.683 80.2515L294.742 80.8613ZM297.795 82.6217C298.164 82.8403 298.774 82.8403 299.143 82.6217L300.191 82.0119C300.56 81.7933 300.56 81.4481 300.191 81.241L299.132 80.6312C298.763 80.4126 298.152 80.4126 297.784 80.6312L296.735 81.241C296.367 81.4596 296.367 81.8048 296.735 82.0119L297.795 82.6217ZM300.836 82.3916L299.788 83.0014C299.419 83.22 299.419 83.5651 299.788 83.7722L300.848 84.382C301.217 84.6007 301.827 84.6007 302.196 84.382L303.244 83.7722C303.613 83.5536 303.613 83.2085 303.244 83.0014L302.184 82.3916C301.816 82.173 301.205 82.173 300.836 82.3916ZM303.947 84.1174L302.772 84.7962C302.438 84.9918 302.438 85.3025 302.772 85.4981L303.958 86.1769C304.292 86.3725 304.834 86.3725 305.168 86.1769L306.343 85.4981C306.677 85.3025 306.677 84.9918 306.343 84.7962L305.156 84.1174C304.822 83.9218 304.281 83.9218 303.947 84.1174ZM306.999 85.8778L305.824 86.5566C305.49 86.7522 305.49 87.0628 305.824 87.2584L307.011 87.9373C307.345 88.1329 307.886 88.1329 308.221 87.9373L309.396 87.2584C309.73 87.0628 309.73 86.7522 309.396 86.5566L308.209 85.8778C307.875 85.6822 307.334 85.6822 306.999 85.8778ZM310.052 87.6381L308.877 88.317C308.543 88.5126 308.543 88.8232 308.877 89.0188L310.064 89.6976C310.398 89.8932 310.939 89.8932 311.273 89.6976L312.448 89.0188C312.782 88.8232 312.782 88.5126 312.448 88.317L311.262 87.6381C310.928 87.4425 310.386 87.4425 310.052 87.6381ZM313.105 89.3985L311.93 90.0773C311.596 90.2729 311.596 90.5836 311.93 90.7792L313.116 91.458C313.45 91.6536 313.992 91.6536 314.326 91.458L315.501 90.7792C315.835 90.5836 315.835 90.2729 315.501 90.0773L314.314 89.3985C313.98 89.2029 313.439 89.2029 313.105 89.3985ZM316.158 91.1589L314.983 91.8377C314.648 92.0333 314.648 92.3439 314.983 92.5395L316.169 93.2183C316.503 93.4139 317.045 93.4139 317.379 93.2183L318.554 92.5395C318.888 92.3439 318.888 92.0333 318.554 91.8377L317.367 91.1589C317.033 90.9633 316.492 90.9633 316.158 91.1589ZM320.431 94.9787L321.606 94.2999C321.94 94.1043 321.94 93.7936 321.606 93.598L320.42 92.9192C320.086 92.7236 319.544 92.7236 319.21 92.9192L318.035 93.598C317.701 93.7936 317.701 94.1043 318.035 94.2999L319.222 94.9787C319.556 95.1743 320.097 95.1743 320.431 94.9787ZM323.484 96.7391L324.659 96.0602C324.993 95.8646 324.993 95.554 324.659 95.3584L323.473 94.6796C323.138 94.484 322.597 94.484 322.263 94.6796L321.088 95.3584C320.754 95.554 320.754 95.8646 321.088 96.0602L322.275 96.7391C322.609 96.9347 323.15 96.9347 323.484 96.7391ZM327.769 97.1533L326.583 96.4744C326.249 96.2788 325.707 96.2788 325.373 96.4744L324.198 97.1533C323.864 97.3489 323.864 97.6595 324.198 97.8551L325.385 98.5339C325.719 98.7295 326.26 98.7295 326.594 98.5339L327.769 97.8551C328.103 97.6595 328.103 97.3489 327.769 97.1533ZM283.35 77.5477L287.174 79.7568C287.508 79.9524 288.05 79.9524 288.384 79.7568L289.559 79.078C289.893 78.8824 289.893 78.5717 289.559 78.3761L285.734 76.167C285.4 75.9715 284.859 75.9715 284.525 76.167L283.35 76.8459C283.015 77.0415 283.015 77.3521 283.35 77.5477ZM289.04 80.8268L290.227 81.5056C290.561 81.7012 291.102 81.7012 291.436 81.5056L292.611 80.8268C292.945 80.6312 292.945 80.3206 292.611 80.125L291.425 79.4461C291.091 79.2506 290.549 79.2506 290.215 79.4461L289.04 80.125C288.706 80.3206 288.706 80.6312 289.04 80.8268ZM292.093 82.5872L293.279 83.266C293.614 83.4616 294.155 83.4616 294.489 83.266L295.664 82.5872C295.998 82.3916 295.998 82.0809 295.664 81.8853L294.478 81.2065C294.143 81.0109 293.602 81.0109 293.268 81.2065L292.093 81.8853C291.759 82.0809 291.759 82.3916 292.093 82.5872ZM295.146 84.3475L296.332 85.0264C296.666 85.222 297.208 85.222 297.542 85.0264L298.717 84.3475C299.051 84.1519 299.051 83.8413 298.717 83.6457L297.53 82.9669C297.196 82.7713 296.655 82.7713 296.321 82.9669L295.146 83.6457C294.812 83.8413 294.812 84.1519 295.146 84.3475ZM300.594 86.7867L301.769 86.1079C302.104 85.9123 302.104 85.6016 301.769 85.4061L300.583 84.7272C300.249 84.5316 299.707 84.5316 299.373 84.7272L298.198 85.4061C297.864 85.6016 297.864 85.9123 298.198 86.1079L299.385 86.7867C299.719 86.9823 300.26 86.9823 300.594 86.7867ZM303.647 88.5471L304.822 87.8682C305.156 87.6727 305.156 87.362 304.822 87.1664L303.636 86.4876C303.302 86.292 302.76 86.292 302.426 86.4876L301.251 87.1664C300.917 87.362 300.917 87.6727 301.251 87.8682L302.438 88.5471C302.772 88.7427 303.313 88.7427 303.647 88.5471ZM306.7 90.3074L307.875 89.6286C308.209 89.433 308.209 89.1224 307.875 88.9268L306.688 88.2479C306.354 88.0523 305.813 88.0523 305.479 88.2479L304.304 88.9268C303.97 89.1224 303.97 89.433 304.304 89.6286L305.49 90.3074C305.824 90.503 306.366 90.503 306.7 90.3074ZM309.753 92.0678L310.928 91.389C311.262 91.1934 311.262 90.8827 310.928 90.6871L309.741 90.0083C309.407 89.8127 308.866 89.8127 308.532 90.0083L307.357 90.6871C307.022 90.8827 307.022 91.1934 307.357 91.389L308.543 92.0678C308.877 92.2634 309.419 92.2634 309.753 92.0678ZM312.805 93.8282L313.98 93.1493C314.314 92.9537 314.314 92.6431 313.98 92.4475L312.794 91.7686C312.46 91.5731 311.918 91.5731 311.584 91.7686L310.409 92.4475C310.075 92.6431 310.075 92.9537 310.409 93.1493L311.596 93.8282C311.93 94.0237 312.471 94.0237 312.805 93.8282ZM315.858 95.5885L317.033 94.9097C317.367 94.7141 317.367 94.4034 317.033 94.2078L315.847 93.529C315.512 93.3334 314.971 93.3334 314.637 93.529L313.462 94.2078C313.128 94.4034 313.128 94.7141 313.462 94.9097L314.649 95.5885C314.983 95.7841 315.524 95.7841 315.858 95.5885ZM316.515 96.6585L317.701 97.3374C318.035 97.533 318.577 97.533 318.911 97.3374L320.086 96.6585C320.42 96.4629 320.42 96.1523 320.086 95.9567L318.899 95.2779C318.565 95.0823 318.024 95.0823 317.69 95.2779L316.515 95.9567C316.181 96.1523 316.181 96.4629 316.515 96.6585ZM324.97 98.7756L321.952 97.0382C321.618 96.8426 321.076 96.8426 320.742 97.0382L319.567 97.717C319.233 97.9126 319.233 98.2233 319.567 98.4189L322.586 100.156C322.92 100.352 323.461 100.352 323.795 100.156L324.97 99.4774C325.304 99.2818 325.304 98.9712 324.97 98.7756ZM280.562 79.2505L285.988 82.3801C286.368 82.5987 286.978 82.5987 287.358 82.3801L288.384 81.7933C288.764 81.5747 288.764 81.218 288.384 80.9994L282.958 77.8699C282.578 77.6513 281.967 77.6513 281.587 77.8699L280.562 78.4567C280.182 78.6753 280.182 79.0319 280.562 79.2505ZM288.015 83.5421L289.04 84.1289C289.42 84.3475 290.031 84.3475 290.411 84.1289L291.436 83.5421C291.817 83.3235 291.817 82.9669 291.436 82.7483L290.411 82.1615C290.031 81.9429 289.42 81.9429 289.04 82.1615L288.015 82.7483C287.635 82.9669 287.635 83.3235 288.015 83.5421ZM291.068 85.3025L292.093 85.8893C292.473 86.1079 293.084 86.1079 293.464 85.8893L294.489 85.3025C294.869 85.0839 294.869 84.7272 294.489 84.5086L293.464 83.9218C293.084 83.7032 292.473 83.7032 292.093 83.9218L291.068 84.5086C290.688 84.7272 290.688 85.0839 291.068 85.3025ZM294.12 87.0629L295.146 87.6496C295.526 87.8682 296.136 87.8682 296.517 87.6496L297.542 87.0629C297.922 86.8442 297.922 86.4876 297.542 86.269L296.517 85.6822C296.136 85.4636 295.526 85.4636 295.146 85.6822L294.12 86.269C293.74 86.4876 293.74 86.8442 294.12 87.0629ZM297.173 88.8232L298.198 89.41C298.579 89.6286 299.189 89.6286 299.569 89.41L300.594 88.8232C300.975 88.6046 300.975 88.2479 300.594 88.0293L299.569 87.4425C299.189 87.2239 298.579 87.2239 298.198 87.4425L297.173 88.0293C296.793 88.2479 296.793 88.6046 297.173 88.8232ZM300.226 90.5836L301.251 91.1704C301.631 91.389 302.242 91.389 302.622 91.1704L303.647 90.5836C304.027 90.365 304.027 90.0083 303.647 89.7897L302.622 89.2029C302.242 88.9843 301.631 88.9843 301.251 89.2029L300.226 89.7897C299.846 90.0083 299.846 90.365 300.226 90.5836ZM303.279 92.3439L304.304 92.9307C304.684 93.1493 305.295 93.1493 305.675 92.9307L306.7 92.3439C307.08 92.1253 307.08 91.7686 306.7 91.55L305.675 90.9633C305.295 90.7446 304.684 90.7446 304.304 90.9633L303.279 91.55C302.898 91.7686 302.898 92.1253 303.279 92.3439ZM306.331 94.1043L307.357 94.6911C307.737 94.9097 308.347 94.9097 308.727 94.6911L309.753 94.1043C310.133 93.8857 310.133 93.529 309.753 93.3104L308.727 92.7236C308.347 92.505 307.737 92.505 307.357 92.7236L306.331 93.3104C305.951 93.529 305.951 93.8857 306.331 94.1043ZM309.384 95.8646L310.409 96.4514C310.789 96.67 311.4 96.67 311.78 96.4514L312.805 95.8646C313.186 95.646 313.186 95.2894 312.805 95.0708L311.78 94.484C311.4 94.2654 310.789 94.2654 310.409 94.484L309.384 95.0708C309.004 95.2894 309.004 95.646 309.384 95.8646ZM312.437 97.625L313.462 98.2118C313.842 98.4304 314.453 98.4304 314.833 98.2118L315.858 97.625C316.238 97.4064 316.238 97.0497 315.858 96.8311L314.833 96.2443C314.453 96.0257 313.842 96.0257 313.462 96.2443L312.437 96.8311C312.057 97.0497 312.057 97.4064 312.437 97.625ZM315.489 99.3854L316.515 99.9721C316.895 100.191 317.505 100.191 317.886 99.9721L318.911 99.3854C319.291 99.1667 319.291 98.8101 318.911 98.5915L317.886 98.0047C317.505 97.7861 316.895 97.7861 316.515 98.0047L315.489 98.5915C315.109 98.8101 315.109 99.1667 315.489 99.3854ZM322.021 100.398L320.996 99.8111C320.616 99.5925 320.005 99.5925 319.625 99.8111L318.6 100.398C318.22 100.616 318.22 100.973 318.6 101.192L319.625 101.779C320.005 101.997 320.616 101.997 320.996 101.779L322.021 101.192C322.401 100.973 322.401 100.616 322.021 100.398ZM282.52 80.8843L280.136 79.5152C279.755 79.2966 279.145 79.2966 278.765 79.5152L277.739 80.102C277.359 80.3206 277.359 80.6772 277.739 80.8958L280.124 82.265C280.504 82.4836 281.115 82.4836 281.495 82.265L282.52 81.6782C282.9 81.4596 282.9 81.103 282.52 80.8843ZM285.573 82.6447L284.548 82.0579C284.167 81.8393 283.557 81.8393 283.177 82.0579L282.151 82.6447C281.771 82.8633 281.771 83.22 282.151 83.4386L283.177 84.0254C283.557 84.244 284.167 84.244 284.548 84.0254L285.573 83.4386C285.953 83.22 285.953 82.8633 285.573 82.6447ZM288.626 84.4051L287.6 83.8183C287.22 83.5997 286.61 83.5997 286.229 83.8183L285.204 84.4051C284.824 84.6237 284.824 84.9803 285.204 85.199L286.229 85.7857C286.61 86.0043 287.22 86.0043 287.6 85.7857L288.626 85.199C289.006 84.9803 289.006 84.6237 288.626 84.4051ZM309.983 96.7161L290.653 85.5671C290.273 85.3485 289.662 85.3485 289.282 85.5671L288.257 86.1539C287.877 86.3725 287.877 86.7292 288.257 86.9478L307.587 98.0967C307.967 98.3153 308.578 98.3153 308.958 98.0967L309.983 97.5099C310.363 97.2913 310.363 96.9347 309.983 96.7161ZM313.036 98.4764L312.01 97.8896C311.63 97.671 311.02 97.671 310.64 97.8896L309.614 98.4764C309.234 98.695 309.234 99.0517 309.614 99.2703L310.64 99.8571C311.02 100.076 311.63 100.076 312.01 99.8571L313.036 99.2703C313.416 99.0517 313.416 98.695 313.036 98.4764ZM316.088 100.237L315.063 99.65C314.683 99.4314 314.073 99.4314 313.692 99.65L312.667 100.237C312.287 100.455 312.287 100.812 312.667 101.031L313.692 101.617C314.073 101.836 314.683 101.836 315.063 101.617L316.088 101.031C316.469 100.812 316.469 100.455 316.088 100.237ZM319.199 102.032L318.174 101.445C317.793 101.226 317.183 101.226 316.803 101.445L315.777 102.032C315.397 102.25 315.397 102.607 315.777 102.826L316.803 103.412C317.183 103.631 317.793 103.631 318.174 103.412L319.199 102.826C319.579 102.607 319.579 102.25 319.199 102.032Z",
    fill: "url(#paint16_linear_807_97)"
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M342.399 93.805L294.766 66.3181C292.922 65.2596 291.425 62.4062 291.425 59.944V22.6313C291.425 20.1807 292.922 19.0416 294.766 20.1116L342.399 47.5985C344.243 48.657 345.74 51.5104 345.74 53.9726V91.2968C345.74 93.7475 344.243 94.8865 342.399 93.8165V93.805Z",
    fill: "url(#paint17_linear_807_97)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M342.826 91.8837L295.699 64.6959C294.213 63.7525 293.291 61.877 293.291 59.9441V22.4474C293.291 21.9871 293.786 21.711 294.178 21.9411C294.224 21.9641 294.259 21.9871 294.282 21.9986L341.443 49.2094C343.206 50.2219 343.839 52.0283 343.839 53.9612V91.3774C343.839 91.8721 343.309 92.1713 342.883 91.9297C342.849 91.9067 342.826 91.8952 342.803 91.8837H342.826Z",
    fill: "url(#paint18_linear_807_97)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M341.455 49.2093L294.293 21.9985C294.293 21.9985 294.236 21.964 294.19 21.941C293.798 21.7109 293.302 21.9985 293.302 22.4473V59.944C293.302 61.8654 294.224 63.7524 295.71 64.6958L342.837 91.8836C342.837 91.8836 342.883 91.9066 342.918 91.9296C343.344 92.1712 343.874 91.8605 343.874 91.3773V53.9611C343.874 52.0397 343.24 50.2333 341.478 49.2093H341.455ZM343.482 91.3773C343.482 91.5384 343.344 91.6419 343.217 91.6419C343.171 91.6419 343.125 91.6304 343.091 91.6074L295.894 64.3737C294.558 63.5223 293.683 61.7849 293.683 59.944V22.4473C293.683 22.3092 293.798 22.2287 293.902 22.2287C293.936 22.2287 293.971 22.2287 294.005 22.2632L341.27 49.543C343.102 50.6015 343.482 52.5344 343.482 53.9726V91.3888V91.3773Z",
    fill: "url(#paint19_linear_807_97)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M343.344 47.0808L295.71 19.5939C294.984 19.1682 294.305 19.0992 293.752 19.3063C293.683 19.3293 292.75 19.824 292.68 19.8586C293.245 19.5824 293.971 19.6399 294.754 20.0887L342.388 47.5755C344.231 48.6341 345.729 51.4874 345.729 53.9496V91.2738C345.729 92.8041 345.141 93.8166 344.266 94.1157C344.335 94.1157 344.427 94.0927 344.554 94.0121C344.6 93.9891 345.602 93.4139 345.648 93.3908C346.281 92.9421 346.673 92.0332 346.673 90.7791V53.4549C346.673 51.0042 345.176 48.1508 343.332 47.0808H343.344Z",
    fill: "url(#paint20_linear_807_97)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M342.549 47.5065L294.915 20.0196C294.155 19.5824 293.464 19.5248 292.899 19.7665C293.372 19.6859 293.925 19.801 294.512 20.1461L342.146 47.633C343.989 48.6915 345.487 51.5449 345.487 54.0071V91.3313C345.487 92.781 344.968 93.759 344.162 94.1041C345.187 93.9431 345.89 92.8845 345.89 91.2047V53.8806C345.89 51.4299 344.392 48.5765 342.549 47.5065Z",
    fill: "url(#paint21_radial_807_97)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M346.546 53.6735C345.325 54.1797 343.724 53.0867 342.975 51.2573C342.215 49.4164 342.595 47.5295 343.816 47.0233C345.037 46.517 346.639 47.6101 347.387 49.4394C348.136 51.2688 347.767 53.1673 346.546 53.6735Z",
    fill: "url(#paint22_radial_807_97)"
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M332.009 106.059C332.009 106.599 332.193 106.979 332.492 107.163C332.492 107.163 333.045 107.485 333.057 107.485C333.368 107.658 333.172 107.267 333.644 106.991C334.6 106.438 335.384 105.092 335.384 103.999C335.384 103.458 335.891 103.447 335.58 103.274C335.58 103.274 334.969 102.941 334.958 102.941C334.647 102.768 334.22 102.803 333.748 103.079C332.792 103.631 332.009 104.977 332.009 106.07V106.059Z",
    fill: "url(#paint23_linear_807_97)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M332.608 106.392C332.608 107.497 333.391 107.934 334.347 107.382C335.303 106.829 336.087 105.483 336.087 104.39C336.087 103.297 335.303 102.849 334.347 103.401C333.391 103.953 332.608 105.299 332.608 106.392Z",
    fill: "url(#paint24_linear_807_97)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M333.034 106.323C333.034 106.783 333.195 107.106 333.449 107.267C333.449 107.267 334.278 107.761 334.29 107.761C334.555 107.911 334.382 107.566 334.796 107.336C335.614 106.864 336.282 105.713 336.282 104.77C336.282 104.298 336.709 104.298 336.455 104.149L335.568 103.642C335.303 103.493 334.935 103.527 334.531 103.757C333.714 104.229 333.045 105.38 333.045 106.323H333.034Z",
    fill: "url(#paint25_linear_807_97)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M333.909 106.83C333.909 107.773 334.577 108.153 335.395 107.681C336.213 107.209 336.881 106.059 336.881 105.115C336.881 104.172 336.213 103.792 335.395 104.264C334.577 104.735 333.909 105.886 333.909 106.83Z",
    fill: "url(#paint26_linear_807_97)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M334.266 103.366C334.727 103.102 335.142 103.067 335.453 103.217C335.165 103.136 334.808 103.194 334.416 103.424C333.46 103.976 332.677 105.322 332.677 106.415C332.677 106.991 332.884 107.382 333.23 107.554C332.803 107.439 332.527 107.014 332.527 106.358C332.527 105.253 333.31 103.919 334.266 103.366Z",
    fill: "#E6E7E8"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M335.338 104.218C335.729 103.988 336.098 103.953 336.363 104.091C336.109 104.022 335.798 104.068 335.464 104.264C334.635 104.736 333.967 105.898 333.967 106.841C333.967 107.336 334.151 107.669 334.439 107.819C334.071 107.715 333.84 107.359 333.84 106.795C333.84 105.852 334.508 104.689 335.338 104.218Z",
    fill: "url(#paint27_radial_807_97)"
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M334.612 106.588C334.612 107.129 334.992 107.347 335.476 107.083C335.948 106.806 336.34 106.139 336.34 105.598C336.34 105.058 335.96 104.839 335.476 105.104C335.004 105.38 334.612 106.036 334.612 106.588Z",
    fill: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M308.166 40.3233C315.619 31.9264 314.846 19.0844 306.439 11.6398C298.032 4.19523 285.174 4.96718 277.721 13.364C270.267 21.7609 271.04 34.6029 279.447 42.0475C287.854 49.4921 300.712 48.7201 308.166 40.3233Z",
    fill: "url(#paint28_radial_807_97)"
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M352.629 208.988C347.825 206.215 339.243 206.652 333.506 209.966C327.769 213.279 327.009 218.215 331.813 220.988L370.496 243.297C375.3 246.07 383.882 245.633 389.618 242.319C395.355 239.006 396.116 234.07 391.312 231.297L352.629 208.988Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M352.871 209.632C348.24 206.963 339.98 207.365 334.486 210.541C328.979 213.716 328.276 218.468 332.907 221.149L370.22 242.665C374.851 245.334 383.099 244.931 388.605 241.756C394.111 238.58 394.814 233.828 390.183 231.147L352.871 209.632Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M353.113 210.288C348.643 207.711 340.729 208.09 335.453 211.128C330.177 214.165 329.521 218.733 333.99 221.31L369.943 242.043C374.413 244.621 382.327 244.241 387.603 241.203C392.879 238.166 393.524 233.598 389.066 231.021L353.113 210.288Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M353.355 210.932C349.058 208.458 341.466 208.804 336.432 211.703C331.398 214.614 330.788 218.986 335.084 221.46L369.666 241.399C373.963 243.873 381.555 243.528 386.589 240.617C391.623 237.717 392.234 233.334 387.937 230.86L353.355 210.921V210.932Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M353.597 211.588C349.473 209.206 342.204 209.528 337.4 212.301C332.596 215.074 332.043 219.262 336.167 221.644L369.379 240.789C373.503 243.171 380.772 242.849 385.575 240.076C390.379 237.303 390.932 233.115 386.808 230.733L353.597 211.588Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M353.839 212.232C349.887 209.954 342.941 210.242 338.379 212.877C333.806 215.511 333.311 219.515 337.262 221.793L369.102 240.156C373.053 242.434 379.988 242.147 384.562 239.512C389.135 236.877 389.63 232.873 385.679 230.595L353.839 212.232Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.13,
    d: "M354.08 212.888C350.29 210.702 343.69 210.967 339.347 213.463C335.004 215.96 334.554 219.78 338.344 221.954L368.814 239.523C372.604 241.71 379.205 241.445 383.548 238.948C387.891 236.451 388.34 232.632 384.55 230.457L354.08 212.888Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M354.322 213.532C350.705 211.45 344.427 211.68 340.326 214.05C336.225 216.42 335.822 220.045 339.439 222.127L368.538 238.914C372.155 240.996 378.433 240.766 382.534 238.396C386.635 236.026 387.038 232.402 383.421 230.319L354.322 213.532Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M354.564 214.188C351.12 212.198 345.164 212.405 341.293 214.637C337.423 216.869 337.077 220.298 340.522 222.288L368.25 238.281C371.694 240.271 377.65 240.064 381.52 237.832C385.391 235.6 385.736 232.171 382.292 230.181L354.564 214.188Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M354.806 214.833C351.534 212.946 345.901 213.118 342.273 215.212C338.632 217.306 338.333 220.551 341.616 222.438L367.985 237.637C371.256 239.524 376.889 239.351 380.518 237.257C384.158 235.163 384.458 231.918 381.175 230.031L354.806 214.833Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M355.048 215.488C351.938 213.693 346.65 213.843 343.24 215.799C339.831 217.766 339.589 220.815 342.699 222.61L367.697 237.027C370.796 238.822 376.095 238.672 379.504 236.716C382.914 234.749 383.156 231.7 380.046 229.905L355.048 215.488Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M355.29 216.133C352.352 214.441 347.387 214.556 344.219 216.386C341.052 218.215 340.856 221.08 343.782 222.771L367.409 236.394C370.346 238.085 375.311 237.97 378.479 236.141C381.647 234.311 381.843 231.447 378.917 229.755L355.29 216.133Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M355.532 216.789C352.767 215.189 348.125 215.281 345.187 216.973C342.25 218.664 342.1 221.345 344.865 222.932L367.121 235.761C369.886 237.361 374.528 237.268 377.465 235.577C380.403 233.886 380.553 231.205 377.788 229.617L355.532 216.789Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M355.774 217.433C353.182 215.937 348.862 215.995 346.155 217.548C343.448 219.113 343.356 221.598 345.948 223.094L366.833 235.14C369.425 236.636 373.745 236.578 376.452 235.025C379.159 233.46 379.251 230.975 376.659 229.479L355.774 217.433Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M356.016 218.089C353.597 216.685 349.611 216.708 347.134 218.135C344.657 219.561 344.623 221.862 347.042 223.255L366.556 234.507C368.975 235.899 372.961 235.876 375.438 234.461C377.915 233.034 377.949 230.733 375.53 229.341L356.016 218.089Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M356.258 218.733C354 217.433 350.348 217.421 348.102 218.721C345.867 220.01 345.879 222.127 348.125 223.427L366.268 233.897C368.526 235.197 372.178 235.209 374.424 233.909C376.659 232.62 376.648 230.503 374.401 229.215L356.258 218.744V218.733Z",
    fill: "black"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M87.2272 76.052L69.7979 86.2575C69.7979 86.2575 69.6136 86.361 69.6136 86.3725C68.2427 87.1779 67.6322 88.4435 67.7013 89.8127C67.7819 91.2049 68.8187 92.7466 70.3278 93.6095L84.4624 107.083C85.8102 107.865 87.5382 108.245 89.1855 108.164C90.4872 108.164 91.9502 107.715 92.8833 107.186L118.803 92.1483C120.127 91.389 120.876 90.1924 120.865 88.8692C120.865 87.4195 119.955 86.0619 118.365 85.1414L95.5213 76.3627C95.0721 76.1095 94.4385 75.8449 93.9201 75.6723C92.9985 75.3617 91.9963 75.1891 90.9711 75.1776C89.5426 75.1661 88.2409 75.4652 87.2272 76.052Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M87.3194 76.2246L69.8671 86.4416C69.8671 86.4416 69.6943 86.5451 69.6828 86.5566C68.3119 87.3735 67.8742 88.6391 68.0355 89.9968C68.1852 91.2394 69.3257 92.9077 70.685 93.6786L84.5662 106.91C85.9601 107.715 87.7917 108.072 89.4275 107.911C90.6025 107.911 92.2153 107.336 93.0562 106.852L118.699 91.9758C119.966 91.2509 120.669 90.1118 120.657 88.8577C120.646 87.4886 119.782 86.1999 118.25 85.3255L95.556 76.6043C95.1528 76.3742 94.427 76.075 93.9662 75.9254C93.0562 75.6148 92.0655 75.4192 91.0518 75.3962C89.6464 75.3732 88.3331 75.6608 87.3309 76.2476L87.3194 76.2246Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M87.4229 76.3971L69.959 86.6141C69.959 86.6141 69.7863 86.7177 69.7632 86.7292C68.3924 87.5576 67.897 88.8807 68.3693 90.1693C68.3693 91.2854 69.8323 93.0573 71.0304 93.7476L84.6582 106.737C86.0981 107.566 88.0334 107.899 89.6692 107.658C90.7175 107.658 92.48 106.956 93.2288 106.519L118.607 91.8031C119.816 91.1013 120.484 90.0313 120.473 88.8462C120.45 87.5576 119.632 86.338 118.169 85.4981L95.6134 76.8344C95.2563 76.6273 94.4268 76.3051 94.0237 76.1555C93.1251 75.8449 92.1459 75.6263 91.1322 75.5917C89.7383 75.5572 88.4251 75.8334 87.4344 76.4087L87.4229 76.3971Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M87.5266 76.5698L70.0397 86.7982C70.0397 86.7982 69.8669 86.9018 69.8439 86.9133C68.4846 87.7532 68.0699 89.0993 68.7035 90.342C68.7035 91.3199 70.3393 93.1953 71.3875 93.8051L84.7504 106.553C86.2364 107.416 88.2754 107.715 89.8997 107.382C90.8097 107.382 92.7335 106.553 93.3901 106.174L118.492 91.6191C119.643 90.9518 120.277 89.9278 120.254 88.8117C120.231 87.6036 119.448 86.4531 118.054 85.6477L95.6365 77.0415C95.3254 76.8574 94.4039 76.5007 94.0467 76.3742C93.1597 76.052 92.1921 75.8219 91.1899 75.7874C89.8075 75.7298 88.4943 76.006 87.5151 76.5698H87.5266Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M87.6189 76.7423L70.1205 86.9823C70.1205 86.9823 69.9592 87.0858 69.9247 87.0974C68.5653 87.9488 68.2543 89.3064 69.0377 90.526C69.0377 91.3544 70.8347 93.3564 71.7448 93.8857L84.8542 106.381C86.3863 107.267 88.529 107.543 90.1532 107.129C90.9366 107.129 93.0101 106.174 93.5746 105.84L118.399 91.435C119.505 90.8022 120.093 89.8357 120.058 88.7887C120.024 87.6611 119.286 86.5681 117.95 85.8087L95.6827 77.2486C95.4177 77.099 94.404 76.7078 94.093 76.5927C93.2175 76.2706 92.2613 76.0175 91.2706 75.9714C89.8998 75.9024 88.5981 76.1555 87.6189 76.7193V76.7423Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M87.7225 76.9148L70.2011 87.1663C70.2011 87.1663 70.0398 87.2584 70.0052 87.2929C68.6459 88.1558 68.4386 89.5365 69.3832 90.7216C69.3832 91.4119 71.353 93.5289 72.1133 93.9661L84.9693 106.22C86.559 107.129 88.7938 107.382 90.4066 106.887C91.0632 106.887 93.2865 105.794 93.7588 105.529L118.319 91.2853C119.367 90.687 119.908 89.7781 119.874 88.8001C119.839 87.7531 119.137 86.7291 117.87 86.0043L95.7402 77.5016C95.5213 77.3751 94.4154 76.9494 94.162 76.8573C93.298 76.5237 92.3534 76.259 91.3627 76.2015C90.0034 76.121 88.7017 76.3626 87.734 76.9264L87.7225 76.9148Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M87.8262 77.0875L70.2933 87.3505C70.2933 87.3505 70.132 87.4425 70.0859 87.477C68.7266 88.3514 68.6114 89.7551 69.7173 90.9057C69.7173 91.458 71.86 93.69 72.459 94.0467L85.0615 106.059C86.6973 107.002 89.0358 107.221 90.637 106.645C91.1554 106.645 93.54 105.426 93.9086 105.207L118.192 91.1243C119.183 90.549 119.69 89.7091 119.655 88.8002C119.609 87.8222 118.952 86.8787 117.754 86.1884L95.7633 77.7433C95.579 77.6397 94.3809 77.1795 94.1851 77.099C93.3326 76.7653 92.3996 76.4777 91.4204 76.4086C90.0726 76.3166 88.7709 76.5467 87.8147 77.099L87.8262 77.0875Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M87.9183 77.26L70.3623 87.5345C70.3623 87.5345 70.201 87.6266 70.1549 87.6611C68.8071 88.547 68.7841 89.9737 70.0397 91.0783C70.0397 91.4925 72.3552 93.8396 72.8045 94.1042L85.142 105.863C86.8239 106.829 89.2661 107.025 90.8673 106.369C91.259 106.369 93.7933 105.023 94.0698 104.862L118.077 90.9287C119.01 90.3879 119.482 89.6055 119.436 88.7656C119.39 87.8682 118.768 86.9938 117.639 86.338L95.7977 77.9504C95.6595 77.8698 94.3693 77.3866 94.2195 77.3176C93.3786 76.9724 92.457 76.6733 91.4894 76.5927C90.1531 76.4892 88.8514 76.7078 87.9068 77.2485L87.9183 77.26Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M88.0221 77.4327L70.4545 87.7072C70.3969 87.7417 70.3048 87.7992 70.2472 87.8337C68.8994 88.7312 68.9685 90.1809 70.3854 91.2509C70.3854 91.527 72.8737 93.9892 73.1732 94.1618L85.2573 105.679C86.9853 106.68 89.5311 106.841 91.1208 106.093C91.3858 106.093 94.0699 104.62 94.2542 104.505L117.996 90.7331C118.883 90.2269 119.309 89.502 119.252 88.7312C119.194 87.9143 118.618 87.1089 117.547 86.4991L95.8439 78.1575C95.7518 78.1115 94.3694 77.5822 94.2657 77.5362C93.4363 77.191 92.5262 76.8689 91.5701 76.7768C90.2569 76.6618 88.9436 76.8689 88.0105 77.4097L88.0221 77.4327Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M88.1258 77.6052L70.5467 87.8912C70.4776 87.9257 70.397 87.9833 70.3394 88.0178C68.9916 88.9267 69.1644 90.3995 70.7426 91.435C70.7426 91.573 73.4036 94.1503 73.5534 94.2423L85.3841 105.518C87.1581 106.542 89.8076 106.68 91.3973 105.851C91.5241 105.851 94.3694 104.241 94.4616 104.195L117.927 90.5835C118.757 90.1118 119.137 89.4445 119.091 88.7426C119.033 88.0063 118.492 87.2699 117.489 86.6946L95.9361 78.4106C95.9361 78.4106 94.4155 77.8238 94.3694 77.8008C93.5515 77.4441 92.6415 77.1105 91.6969 77.0069C90.3951 76.8804 89.0819 77.076 88.1603 77.6052H88.1258Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6162 105.61L117.8 90.4224C119.379 89.5135 119.183 87.9257 117.363 86.8787L94.3809 78.0539C92.5608 77.0069 89.8076 76.8918 88.2294 77.8008L70.6273 88.0983C69.0491 89.0072 69.245 90.595 71.0651 91.642L85.4647 105.368C87.2848 106.415 90.038 106.53 91.6162 105.621V105.61Z",
    fill: "black"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6162 106.703L117.8 91.5155C118.503 91.1128 118.849 90.572 118.86 90.0083C118.86 89.9852 118.86 86.9247 118.86 86.9017C118.849 86.2114 118.342 87.408 117.351 86.8442L94.3694 79.1355C92.5493 78.0884 89.7961 77.9734 88.2179 78.8823L70.6158 88.0523C70.0859 88.3514 69.7057 87.0628 69.5675 87.477C69.5214 87.6151 69.556 90.549 69.5445 90.6871C69.533 91.3889 70.0398 92.1368 71.0536 92.7236L85.4532 106.45C87.2733 107.497 90.0265 107.612 91.6047 106.703H91.6162Z",
    fill: "url(#paint29_linear_807_97)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6162 103.631L117.8 88.4435C119.379 87.5346 119.183 85.9468 117.363 84.8998L94.3809 76.075C92.5608 75.028 89.8076 74.913 88.2294 75.8219L70.6273 86.1194C69.0491 87.0284 69.245 88.6161 71.0651 89.6631L85.4647 103.389C87.2848 104.436 90.038 104.551 91.6162 103.642V103.631Z",
    fill: "url(#paint30_linear_807_97)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.82,
    d: "M70.6159 86.1078L88.2179 75.8103C89.7961 74.9014 92.5493 75.0164 94.3694 76.0634L105.947 80.5161C105.843 80.6081 105.716 80.6887 105.59 80.7692L79.4054 95.9566C79.0368 96.1637 78.6105 96.3133 78.1497 96.4168L71.0536 89.6631C69.2335 88.616 69.0377 87.0283 70.6159 86.1193V86.1078Z",
    fill: "url(#paint31_linear_807_97)"
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0651 89.3294L85.4647 103.056C87.2848 104.103 90.038 104.218 91.6162 103.309L117.8 88.1213C118.457 87.7416 118.803 87.2469 118.849 86.7291C118.929 87.3734 118.584 87.9947 117.8 88.455L91.6162 103.642C90.038 104.551 87.2848 104.436 85.4647 103.389L71.0651 89.6631C70.0053 89.0533 69.4984 88.2479 69.5675 87.5115C69.6481 88.1558 70.155 88.8116 71.0651 89.3294Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M77.0783 101.399C75.6729 104.827 78.714 109.326 83.8864 111.455C89.0587 113.583 94.3923 112.513 95.8092 109.085C97.2146 105.656 94.1735 101.157 89.0011 99.0286C83.8288 96.9001 78.4952 97.9701 77.0783 101.399Z",
    fill: "url(#paint32_radial_807_97)"
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M57.391 103.711L121.705 66.5944C124.988 64.696 127.661 59.6105 127.661 55.2268V6.10943C127.661 1.7258 125 -0.287681 121.705 1.61074L57.391 38.7278C54.1079 40.6262 51.4353 45.7117 51.4353 50.0953V99.2243C51.4353 103.608 54.0963 105.621 57.391 103.723V103.711Z",
    fill: "url(#paint33_linear_807_97)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6307 100.294L120.047 63.7065C122.696 62.0267 124.332 58.6671 124.332 55.2384V5.78731C124.332 4.97041 123.445 4.46417 122.742 4.87837C122.662 4.92439 122.592 4.95891 122.558 4.98192L59.0729 41.6158C55.928 43.4336 54.7876 46.6552 54.7876 50.0839V99.3854C54.7876 100.26 55.7322 100.801 56.4925 100.375C56.5501 100.34 56.5962 100.317 56.6307 100.294Z",
    fill: "url(#paint34_linear_807_97)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7876 50.0954V99.3969C54.7876 100.271 55.7322 100.812 56.4925 100.386C56.5501 100.352 56.5962 100.329 56.6307 100.306L120.047 63.718C122.696 62.0382 124.332 58.6786 124.332 55.2499V5.78731C124.332 4.97041 123.445 4.46417 122.742 4.87837C122.662 4.92439 122.592 4.95891 122.558 4.98192L59.0729 41.6157C55.928 43.4336 54.7876 46.6552 54.7876 50.0839V50.0954ZM55.4557 50.0954C55.4557 47.5296 56.1354 44.078 59.407 42.2025L123.076 5.45365C123.134 5.41913 123.203 5.39612 123.272 5.39612C123.456 5.39612 123.664 5.54569 123.664 5.78731V55.2384C123.664 58.506 122.109 61.6125 119.712 63.1312L56.17 99.7996C56.1008 99.8456 56.0202 99.8686 55.9396 99.8686C55.7092 99.8686 55.4673 99.6845 55.4673 99.3969V50.0954H55.4557Z",
    fill: "#BCBEC0"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7091 37.8304L120.024 0.713307C121.325 -0.0345565 122.523 -0.172624 123.502 0.207061C123.629 0.253083 125.288 1.13901 125.403 1.19654C124.389 0.713307 123.099 0.805352 121.694 1.61074L57.3795 38.7278C54.0964 40.6262 51.4238 45.7117 51.4238 50.0953V99.2243C51.4238 101.963 52.4606 103.769 54.0388 104.287C53.9121 104.287 53.7508 104.241 53.5204 104.114C53.4398 104.068 51.6427 103.056 51.5736 103.01C50.4446 102.216 49.7419 100.593 49.7419 98.3383V49.2094C49.7419 44.8258 52.403 39.7403 55.6976 37.8419L55.7091 37.8304Z",
    fill: "url(#paint35_linear_807_97)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M57.1146 38.5898L121.429 1.46123C122.777 0.678846 124.021 0.575296 125.012 1.001C124.159 0.862936 123.18 1.07004 122.143 1.66833L57.8288 38.7854C54.5457 40.6838 51.8732 45.7693 51.8732 50.1529V99.2818C51.8732 101.871 52.8062 103.619 54.2462 104.241C52.4146 103.953 51.1589 102.066 51.1589 99.0747V49.9458C51.1589 45.5622 53.82 40.4767 57.1146 38.5783V38.5898Z",
    fill: "url(#paint36_radial_807_97)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M49.9954 49.5661C52.1726 50.4636 55.0295 48.5306 56.3773 45.2515C57.7251 41.9839 57.0569 38.6013 54.8797 37.7039C52.7025 36.8064 49.8456 38.7394 48.4978 42.0185C47.15 45.2861 47.8182 48.6687 49.9954 49.5661Z",
    fill: "url(#paint37_radial_807_97)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M54.0389 78.2955C72.9344 78.2955 88.2523 62.9964 88.2523 44.1239C88.2523 25.2514 72.9344 9.95227 54.0389 9.95227C35.1433 9.95227 19.8254 25.2514 19.8254 44.1239C19.8254 62.9964 35.1433 78.2955 54.0389 78.2955Z",
    fill: "url(#paint38_radial_807_97)"
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3499 99.4198C80.3499 99.9951 80.1541 100.409 79.8315 100.605L79.2325 100.95C78.8984 101.134 79.1058 100.708 78.5989 100.421C77.5737 99.8225 76.7327 98.3843 76.7327 97.2107C76.7327 96.624 76.1913 96.624 76.5254 96.4284C76.5254 96.4284 77.182 96.0717 77.1935 96.0717C77.5276 95.8876 77.9884 95.9221 78.4952 96.2098C79.5205 96.8081 80.3614 98.2463 80.3614 99.4198H80.3499Z",
    fill: "url(#paint39_linear_807_97)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7048 99.7765C79.7048 100.962 78.8639 101.433 77.8386 100.835C76.8134 100.237 75.9724 98.7985 75.9724 97.6249C75.9724 96.4513 76.8134 95.9681 77.8386 96.5664C78.8639 97.1647 79.7048 98.6029 79.7048 99.7765Z",
    fill: "url(#paint40_linear_807_97)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2441 99.696C79.2441 100.191 79.0713 100.547 78.7949 100.709L77.8963 101.238C77.5968 101.399 77.7811 101.042 77.3434 100.789C76.4564 100.283 75.7421 99.0402 75.7421 98.0277C75.7421 97.5215 75.2813 97.5215 75.5578 97.3604C75.5578 97.3604 76.5024 96.8196 76.514 96.8196C76.8019 96.6585 77.1936 96.6931 77.6314 96.9462C78.5184 97.4524 79.2326 98.695 79.2326 99.7075L79.2441 99.696Z",
    fill: "url(#paint41_linear_807_97)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2994 100.248C78.2994 101.261 77.5852 101.675 76.6982 101.157C75.8111 100.651 75.0969 99.4083 75.0969 98.3958C75.0969 97.3833 75.8111 96.9692 76.6982 97.4869C77.5852 97.9932 78.2994 99.2357 78.2994 100.248Z",
    fill: "url(#paint42_linear_807_97)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9308 96.5204C77.4354 96.2328 76.9862 96.1983 76.6521 96.3593C76.9631 96.2673 77.3548 96.3363 77.7695 96.578C78.7948 97.1762 79.6357 98.6145 79.6357 99.788C79.6357 100.398 79.4053 100.824 79.0482 101.008C79.509 100.881 79.797 100.432 79.797 99.7305C79.797 98.5454 78.956 97.1072 77.9308 96.5204Z",
    fill: "#E6E7E8"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M76.7787 97.4409C76.3525 97.1993 75.9608 97.1647 75.6729 97.3028C75.9378 97.2223 76.2719 97.2798 76.6405 97.4869C77.5275 98.0046 78.2533 99.2472 78.2533 100.26C78.2533 100.789 78.0574 101.157 77.7464 101.307C78.1381 101.192 78.3915 100.812 78.3915 100.202C78.3915 99.1782 77.6658 97.9356 76.7787 97.4294V97.4409Z",
    fill: "url(#paint43_radial_807_97)"
  }), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5507 99.9836C77.5507 100.57 77.136 100.8 76.6291 100.513C76.1222 100.214 75.7075 99.5003 75.7075 98.9251C75.7075 98.3498 76.1222 98.1081 76.6291 98.3958C77.136 98.6949 77.5507 99.4083 77.5507 99.9836Z",
    fill: "#2AF6FF"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M305.847 242.722C307.506 241.767 309.603 241.249 311.699 241.272C312.621 241.272 313.496 241.41 314.291 241.606C315.029 241.79 315.881 242.158 316.48 242.503L335.292 253.963C335.292 253.963 335.937 254.354 335.948 254.366C337.676 255.401 338.46 257.012 338.367 258.761C338.275 260.544 336.962 262.385 335.027 263.501L309.084 278.504C309.084 278.504 307.022 279.69 306.976 279.701C305.352 280.61 303.336 281.105 301.297 281.105C299.523 281.105 297.91 280.714 296.632 279.977L277.256 268.172C277.256 268.172 277.025 268.034 277.014 268.023C275.251 266.987 274.456 265.354 274.56 263.605C274.664 261.821 275.942 259.992 277.878 258.876L305.813 242.722H305.847Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M305.053 243.47C306.712 242.515 308.808 242.02 310.882 242.055C311.803 242.078 312.667 242.216 313.451 242.434C314.107 242.607 315.075 243.044 315.616 243.355L334.313 254.745C334.313 254.745 334.935 255.125 334.969 255.16C336.663 256.207 337.216 257.817 337.031 259.532C336.859 261.131 335.442 262.995 333.702 263.996L308.762 278.47C308.681 278.516 306.815 279.575 306.723 279.609C305.145 280.472 303.21 280.932 301.251 280.921C299.546 280.909 297.991 280.53 296.758 279.828L277.359 268.011C277.359 268.011 277.129 267.873 277.117 267.862C275.355 266.815 274.79 265.181 274.998 263.444C275.182 261.844 276.541 260.004 278.292 259.003L305.041 243.481L305.053 243.47Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M304.258 244.206C305.905 243.251 308.002 242.768 310.052 242.837C310.962 242.872 311.815 243.033 312.598 243.251C313.185 243.412 314.245 243.919 314.729 244.195L333.322 255.528C333.38 255.562 333.921 255.896 333.967 255.942C335.614 257.012 335.96 258.588 335.672 260.28C335.43 261.683 333.898 263.582 332.354 264.468L308.428 278.412C308.313 278.481 306.596 279.448 306.47 279.494C304.937 280.299 303.071 280.725 301.205 280.713C299.569 280.69 298.072 280.334 296.897 279.655L277.486 267.827C277.486 267.827 277.267 267.689 277.244 267.678C275.493 266.608 274.848 264.916 275.447 263.26C275.447 261.833 277.163 259.992 278.707 259.106L304.281 244.206H304.258Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M303.463 244.943C305.099 243.999 307.207 243.527 309.234 243.608C310.144 243.642 310.985 243.838 311.757 244.057C312.264 244.206 313.439 244.782 313.865 245.023L332.343 256.287C332.423 256.333 332.919 256.644 332.988 256.701C334.601 257.783 335.084 259.44 334.336 261.016C334.336 262.27 332.377 264.145 331.029 264.928L308.105 278.343C307.944 278.435 306.389 279.31 306.216 279.367C304.73 280.127 302.944 280.518 301.159 280.495C299.592 280.472 298.152 280.127 297.023 279.471L277.59 267.62C277.59 267.62 277.371 267.482 277.336 267.471C275.585 266.389 275.067 264.675 275.873 263.064C275.873 261.81 277.751 259.98 279.11 259.198L303.497 244.931L303.463 244.943Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M302.657 245.69C304.292 244.747 306.4 244.298 308.393 244.402C309.292 244.448 310.133 244.655 310.893 244.897C311.331 245.035 312.61 245.69 312.967 245.898L331.329 257.092C331.433 257.15 331.882 257.438 331.963 257.507C333.541 258.6 333.886 260.28 332.953 261.798C332.953 262.868 330.811 264.767 329.659 265.434L307.737 278.32C307.541 278.435 306.135 279.206 305.917 279.287C304.477 279.989 302.76 280.357 301.055 280.322C299.558 280.288 298.175 279.954 297.104 279.333L277.647 267.471C277.647 267.471 277.428 267.344 277.394 267.309C275.643 266.216 275.251 264.468 276.265 262.903C276.265 261.833 278.304 259.992 279.467 259.325L302.68 245.69H302.657Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M301.862 246.427C303.486 245.495 305.594 245.058 307.564 245.173C308.462 245.23 309.292 245.46 310.029 245.702C310.386 245.817 311.769 246.553 312.068 246.726L330.315 257.852C330.442 257.921 330.857 258.186 330.949 258.266C332.481 259.382 332.711 261.062 331.571 262.535C331.571 263.432 329.244 265.342 328.276 265.894L307.356 278.251C307.126 278.389 305.882 279.068 305.606 279.16C304.223 279.805 302.576 280.138 300.952 280.104C299.523 280.069 298.21 279.747 297.173 279.149L277.693 267.275C277.693 267.275 277.486 267.148 277.44 267.114C275.7 265.998 275.424 264.226 276.634 262.707C276.634 261.81 278.845 259.969 279.813 259.417L301.839 246.415L301.862 246.427Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M301.067 247.163C302.68 246.231 304.799 245.806 306.746 245.955C307.645 246.024 308.451 246.277 309.188 246.519C309.476 246.611 310.962 247.428 311.204 247.566L329.348 258.623C329.497 258.703 329.866 258.945 329.97 259.037C331.467 260.165 331.559 261.856 330.235 263.271C330.235 263.984 327.723 265.906 326.952 266.355L307.034 278.182C306.758 278.343 305.675 278.93 305.352 279.034C304.016 279.632 302.438 279.931 300.905 279.885C299.546 279.839 298.291 279.54 297.311 278.965L277.809 267.079C277.751 267.045 277.601 266.953 277.544 266.918C275.804 265.791 275.654 263.984 277.071 262.523C277.071 261.81 279.444 259.969 280.216 259.52L301.055 247.152L301.067 247.163Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M300.272 247.9C301.885 246.968 304.004 246.565 305.917 246.726C306.804 246.807 307.61 247.083 308.336 247.336C308.555 247.416 310.133 248.302 310.317 248.417L328.345 259.405C328.507 259.497 328.841 259.716 328.967 259.831C330.43 260.981 330.384 262.684 328.875 264.042C328.875 264.583 326.18 266.516 325.604 266.849L306.688 278.148C306.377 278.332 305.444 278.815 305.087 278.942C303.797 279.482 302.299 279.747 300.848 279.701C299.558 279.655 298.36 279.356 297.427 278.827L277.901 266.93C277.832 266.884 277.693 266.803 277.636 266.769C275.908 265.63 275.873 263.8 277.486 262.374C277.486 261.833 280.02 259.992 280.608 259.658L300.272 247.923V247.9Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M299.477 248.648C301.078 247.727 303.198 247.336 305.099 247.52C305.986 247.612 306.781 247.9 307.495 248.164C307.633 248.222 309.326 249.2 309.453 249.269L327.366 260.188C327.55 260.291 327.838 260.487 327.977 260.613C329.394 261.775 329.221 263.49 327.527 264.801C327.527 265.158 324.648 267.114 324.267 267.333L306.354 278.102C306.009 278.309 305.225 278.7 304.822 278.838C303.578 279.333 302.15 279.563 300.79 279.506C299.569 279.448 298.429 279.172 297.553 278.666L278.004 266.757C277.924 266.711 277.809 266.642 277.739 266.585C276.011 265.423 276.104 263.57 277.924 262.19C277.924 261.833 280.631 259.981 281.011 259.762L299.489 248.659L299.477 248.648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M298.682 249.384C300.272 248.463 302.403 248.084 304.269 248.291C305.156 248.383 305.928 248.705 306.642 248.981C306.711 249.004 308.509 250.074 308.566 250.109L326.376 260.958C326.583 261.074 326.825 261.246 326.986 261.384C328.368 262.558 328.057 264.295 326.18 265.538C326.18 265.722 323.127 267.678 322.931 267.793L306.02 278.033C305.629 278.263 305.007 278.562 304.557 278.712C303.359 279.149 302 279.344 300.721 279.287C299.569 279.229 298.498 278.965 297.657 278.481L278.097 266.562C278.004 266.516 277.901 266.447 277.82 266.389C276.092 265.216 276.311 263.329 278.338 262.005C278.338 261.821 281.207 259.98 281.403 259.865L298.705 249.395L298.682 249.384Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.761 278.309L278.177 266.366C276.15 265.192 276.403 263.156 278.742 261.81L297.887 250.12C300.226 248.774 303.762 248.624 305.79 249.798L325.373 261.741C327.401 262.914 327.147 264.951 324.809 266.297L305.663 277.987C303.325 279.333 299.788 279.482 297.761 278.309Z",
    fill: "black"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M326.249 252.974H325.754C325.5 252.651 325.166 252.364 324.717 252.111L305.64 241.111C303.382 239.811 299.443 239.972 296.828 241.479L279.191 251.65C278.5 252.053 277.97 252.502 277.613 252.985H277.037V264.652H277.048C277.117 265.411 277.613 266.124 278.557 266.665L297.634 277.665C299.892 278.965 303.832 278.804 306.447 277.296L324.083 267.125C325.316 266.412 326.03 265.526 326.191 264.652H326.237V252.985L326.249 252.974Z",
    fill: "url(#paint44_linear_807_97)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M297.646 266.343L278.569 255.344C276.311 254.044 276.599 251.766 279.203 250.27L296.839 240.099C299.443 238.592 303.394 238.431 305.652 239.731L324.728 250.73C326.986 252.03 326.698 254.308 324.095 255.804L306.458 265.975C303.855 267.482 299.903 267.643 297.646 266.343Z",
    fill: "url(#paint45_linear_807_97)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M324.095 255.413L306.458 265.584C303.855 267.091 299.903 267.252 297.645 265.952L278.569 254.953C277.659 254.435 277.175 253.756 277.071 253.031C276.933 253.963 277.417 254.884 278.569 255.551L297.645 266.55C299.903 267.85 303.843 267.689 306.458 266.182L324.095 256.011C325.65 255.114 326.376 253.94 326.226 252.859C326.088 253.756 325.373 254.688 324.095 255.424V255.413Z",
    fill: "url(#paint46_radial_807_97)"
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M324.417 246.45H323.968C323.738 246.151 323.427 245.886 323.012 245.645L305.364 235.462C303.279 234.254 299.627 234.404 297.219 235.796L280.896 245.207C280.251 245.575 279.767 246.001 279.433 246.438H278.892V252.594H278.903C278.972 253.296 279.422 253.952 280.297 254.458L297.945 264.64C300.03 265.848 303.682 265.699 306.09 264.307L322.413 254.895C323.553 254.239 324.21 253.411 324.371 252.605H324.417V246.45Z",
    fill: "url(#paint47_linear_807_97)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M324.417 245.403H323.968C323.738 245.104 323.427 244.839 323.012 244.598L305.364 234.415C303.279 233.207 299.627 233.357 297.219 234.749L280.896 244.16C280.251 244.528 279.767 244.954 279.433 245.391H278.892V251.547H278.903C278.972 252.249 279.422 252.905 280.297 253.411L297.945 263.593C300.03 264.801 303.682 264.652 306.09 263.26L322.413 253.848C323.553 253.192 324.21 252.364 324.371 251.558H324.417V245.403Z",
    fill: "url(#paint48_linear_807_97)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M326.249 242.446H325.754C325.5 242.124 325.166 241.836 324.717 241.583L305.64 230.584C303.382 229.284 299.443 229.445 296.828 230.952L279.191 241.123C278.5 241.526 277.97 241.974 277.613 242.457H277.037V249.108H277.048C277.117 249.867 277.613 250.58 278.557 251.121L297.634 262.121C299.892 263.421 303.832 263.26 306.447 261.752L324.083 251.581C325.316 250.868 326.03 249.982 326.191 249.108H326.237V242.457L326.249 242.446Z",
    fill: "url(#paint49_linear_807_97)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M297.646 255.816L278.569 244.816C276.311 243.516 276.599 241.238 279.203 239.742L296.839 229.571C299.443 228.064 303.394 227.903 305.652 229.203L324.728 240.202C326.986 241.503 326.698 243.781 324.095 245.276L306.458 255.447C303.855 256.955 299.903 257.116 297.646 255.816Z",
    fill: "url(#paint50_linear_807_97)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M324.095 244.885L306.458 255.056C303.855 256.563 299.903 256.724 297.645 255.424L278.569 244.425C277.659 243.907 277.175 243.228 277.071 242.504C276.933 243.435 277.417 244.356 278.569 245.023L297.645 256.023C299.903 257.323 303.843 257.162 306.458 255.654L324.095 245.483C325.65 244.586 326.376 243.412 326.226 242.331C326.088 243.228 325.373 244.16 324.095 244.897V244.885Z",
    fill: "url(#paint51_radial_807_97)"
  }), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M324.417 235.922H323.968C323.738 235.623 323.427 235.359 323.012 235.117L305.364 224.934C303.279 223.726 299.627 223.876 297.219 225.268L280.896 234.68C280.251 235.048 279.767 235.474 279.433 235.911H278.892V242.066H278.903C278.972 242.768 279.422 243.424 280.297 243.93L297.945 254.113C300.03 255.321 303.682 255.171 306.09 253.779L322.413 244.367C323.553 243.712 324.21 242.883 324.371 242.078H324.417V235.922Z",
    fill: "url(#paint52_linear_807_97)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M324.417 234.875H323.968C323.738 234.576 323.427 234.312 323.012 234.07L305.364 223.887C303.279 222.679 299.627 222.829 297.219 224.221L280.896 233.633C280.251 234.001 279.767 234.427 279.433 234.864H278.892V241.019H278.903C278.972 241.721 279.422 242.377 280.297 242.883L297.945 253.066C300.03 254.274 303.682 254.124 306.09 252.732L322.413 243.32C323.553 242.665 324.21 241.836 324.371 241.031H324.417V234.875Z",
    fill: "url(#paint53_linear_807_97)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M326.249 231.918H325.754C325.5 231.596 325.166 231.308 324.717 231.055L305.64 220.056C303.382 218.756 299.443 218.917 296.828 220.424L279.191 230.595C278.5 230.998 277.97 231.447 277.613 231.93H277.037V238.58H277.048C277.117 239.339 277.613 240.053 278.557 240.593L297.634 251.593C299.892 252.893 303.832 252.732 306.447 251.225L324.083 241.054C325.316 240.34 326.03 239.454 326.191 238.58H326.237V231.93L326.249 231.918Z",
    fill: "url(#paint54_linear_807_97)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M297.646 245.288L278.569 234.288C276.311 232.988 276.599 230.71 279.203 229.215L296.839 219.044C299.443 217.536 303.394 217.375 305.652 218.675L324.728 229.675C326.986 230.975 326.698 233.253 324.095 234.749L306.458 244.92C303.855 246.427 299.903 246.588 297.646 245.288Z",
    fill: "url(#paint55_linear_807_97)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M324.095 234.357L306.458 244.528C303.855 246.036 299.903 246.197 297.645 244.897L278.569 233.897C277.659 233.379 277.175 232.701 277.071 231.976C276.933 232.908 277.417 233.828 278.569 234.496L297.645 245.495C299.903 246.795 303.843 246.634 306.458 245.127L324.095 234.956C325.65 234.058 326.376 232.885 326.226 231.803C326.088 232.701 325.373 233.633 324.095 234.369V234.357Z",
    fill: "url(#paint56_radial_807_97)"
  }), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M324.417 225.395H323.968C323.738 225.095 323.427 224.831 323.012 224.589L305.364 214.407C303.279 213.199 299.627 213.348 297.219 214.74L280.896 224.152C280.251 224.52 279.767 224.946 279.433 225.383H278.892V231.539H278.903C278.972 232.24 279.422 232.896 280.297 233.403L297.945 243.585C300.03 244.793 303.682 244.643 306.09 243.251L322.413 233.84C323.553 233.184 324.21 232.355 324.371 231.55H324.417V225.395Z",
    fill: "url(#paint57_linear_807_97)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M324.417 224.348H323.968C323.738 224.048 323.427 223.784 323.012 223.542L305.364 213.36C303.279 212.152 299.627 212.301 297.219 213.693L280.896 223.105C280.251 223.473 279.767 223.899 279.433 224.336H278.892V230.492H278.903C278.972 231.193 279.422 231.849 280.297 232.356L297.945 242.538C300.03 243.746 303.682 243.596 306.09 242.204L322.413 232.793C323.553 232.137 324.21 231.309 324.371 230.503H324.417V224.348Z",
    fill: "url(#paint58_linear_807_97)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M326.249 221.391H325.754C325.5 221.069 325.166 220.781 324.717 220.528L305.64 209.528C303.382 208.228 299.443 208.389 296.828 209.897L279.191 220.068C278.5 220.47 277.97 220.919 277.613 221.402H277.037V228.052H277.048C277.117 228.812 277.613 229.525 278.557 230.066L297.634 241.065C299.892 242.365 303.832 242.204 306.447 240.697L324.083 230.526C325.316 229.813 326.03 228.927 326.191 228.052H326.237V221.402L326.249 221.391Z",
    fill: "url(#paint59_linear_807_97)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M297.646 234.76L278.569 223.761C276.311 222.461 276.599 220.183 279.203 218.687L296.839 208.516C299.443 207.009 303.394 206.848 305.652 208.148L324.728 219.147C326.986 220.447 326.698 222.725 324.095 224.221L306.458 234.392C303.855 235.899 299.903 236.06 297.646 234.76Z",
    fill: "url(#paint60_linear_807_97)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M324.095 223.83L306.458 234.001C303.855 235.508 299.903 235.669 297.645 234.369L278.569 223.37C277.659 222.852 277.175 222.173 277.071 221.448C276.933 222.38 277.417 223.301 278.569 223.968L297.645 234.967C299.903 236.267 303.843 236.106 306.458 234.599L324.095 224.428C325.65 223.531 326.376 222.357 326.226 221.276C326.088 222.173 325.373 223.105 324.095 223.841V223.83Z",
    fill: "url(#paint61_radial_807_97)"
  }), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M324.417 214.867H323.968C323.738 214.568 323.427 214.303 323.012 214.062L305.364 203.879C303.279 202.671 299.627 202.821 297.219 204.213L280.896 213.624C280.251 213.993 279.767 214.418 279.433 214.856H278.892V221.011H278.903C278.972 221.713 279.422 222.369 280.297 222.875L297.945 233.057C300.03 234.265 303.682 234.116 306.09 232.724L322.413 223.312C323.553 222.656 324.21 221.828 324.371 221.023H324.417V214.867Z",
    fill: "url(#paint62_linear_807_97)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M324.417 213.82H323.968C323.738 213.521 323.427 213.256 323.012 213.015L305.364 202.832C303.279 201.624 299.627 201.774 297.219 203.166L280.896 212.577C280.251 212.946 279.767 213.371 279.433 213.809H278.892V219.964H278.903C278.972 220.666 279.422 221.322 280.297 221.828L297.945 232.01C300.03 233.218 303.682 233.069 306.09 231.677L322.413 222.265C323.553 221.609 324.21 220.781 324.371 219.976H324.417V213.82Z",
    fill: "url(#paint63_linear_807_97)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M326.249 210.863H325.754C325.5 210.541 325.166 210.253 324.717 210L305.64 199.001C303.382 197.701 299.443 197.862 296.828 199.369L279.191 209.54C278.5 209.943 277.97 210.391 277.613 210.875H277.037V217.525H277.048C277.117 218.284 277.613 218.998 278.557 219.538L297.634 230.538C299.892 231.838 303.832 231.677 306.447 230.169L324.083 219.999C325.316 219.285 326.03 218.399 326.191 217.525H326.237V210.875L326.249 210.863Z",
    fill: "url(#paint64_linear_807_97)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M297.646 224.233L278.569 213.233C276.311 211.933 276.599 209.655 279.203 208.159L296.839 197.988C299.443 196.481 303.394 196.32 305.652 197.62L324.728 208.62C326.986 209.92 326.698 212.198 324.095 213.694L306.458 223.864C303.855 225.372 299.903 225.533 297.646 224.233Z",
    fill: "url(#paint65_linear_807_97)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M324.095 213.302L306.458 223.473C303.855 224.98 299.903 225.142 297.645 223.841L278.569 212.842C277.659 212.324 277.175 211.645 277.071 210.921C276.933 211.853 277.417 212.773 278.569 213.44L297.645 224.44C299.903 225.74 303.843 225.579 306.458 224.072L324.095 213.901C325.65 213.003 326.376 211.83 326.226 210.748C326.088 211.645 325.373 212.577 324.095 213.314V213.302Z",
    fill: "url(#paint66_radial_807_97)"
  }), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M324.417 204.339H323.968C323.738 204.04 323.427 203.776 323.012 203.534L305.364 193.352C303.279 192.144 299.627 192.293 297.219 193.685L280.896 203.097C280.251 203.465 279.767 203.891 279.433 204.328H278.892V210.483H278.903C278.972 211.185 279.422 211.841 280.297 212.347L297.945 222.53C300.03 223.738 303.682 223.588 306.09 222.196L322.413 212.785C323.553 212.129 324.21 211.3 324.371 210.495H324.417V204.339Z",
    fill: "url(#paint67_linear_807_97)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M324.417 203.292H323.968C323.738 202.993 323.427 202.729 323.012 202.487L305.364 192.305C303.279 191.097 299.627 191.246 297.219 192.638L280.896 202.05C280.251 202.418 279.767 202.844 279.433 203.281H278.892V209.436H278.903C278.972 210.138 279.422 210.794 280.297 211.3L297.945 221.483C300.03 222.691 303.682 222.541 306.09 221.149L322.413 211.738C323.553 211.082 324.21 210.253 324.371 209.448H324.417V203.292Z",
    fill: "url(#paint68_linear_807_97)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M326.249 200.508H325.754C325.5 200.186 325.166 199.898 324.717 199.645L305.64 188.646C303.382 187.346 299.443 187.507 296.828 189.014L279.191 199.185C278.5 199.588 277.97 200.036 277.613 200.52H277.037V207.17H277.048C277.117 207.929 277.613 208.643 278.557 209.183L297.634 220.183C299.892 221.483 303.832 221.322 306.447 219.815L324.083 209.644C325.316 208.93 326.03 208.044 326.191 207.17H326.237V200.52L326.249 200.508Z",
    fill: "url(#paint69_linear_807_97)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M297.645 213.878L278.569 202.878C276.311 201.578 276.599 199.3 279.202 197.804L296.839 187.633C299.442 186.126 303.394 185.965 305.651 187.265L324.728 198.264C326.986 199.565 326.698 201.843 324.094 203.338L306.458 213.509C303.854 215.017 299.903 215.178 297.645 213.878Z",
    fill: "url(#paint70_linear_807_97)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M324.095 202.947L306.458 213.118C303.855 214.625 299.903 214.786 297.645 213.486L278.569 202.487C277.659 201.969 277.175 201.29 277.071 200.566C276.933 201.497 277.417 202.418 278.569 203.085L297.645 214.085C299.903 215.385 303.843 215.224 306.458 213.716L324.095 203.545C325.65 202.648 326.376 201.474 326.226 200.393C326.088 201.29 325.373 202.222 324.095 202.959V202.947Z",
    fill: "url(#paint71_radial_807_97)"
  }), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M312.287 196.757H291.482V200.876C291.482 204.213 296.136 206.928 301.885 206.928C307.633 206.928 312.287 204.224 312.287 200.876C312.287 200.853 312.287 200.819 312.287 200.796V196.757Z",
    fill: "url(#paint72_linear_807_97)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M301.885 202.855C307.63 202.855 312.287 200.146 312.287 196.803C312.287 193.461 307.63 190.751 301.885 190.751C296.14 190.751 291.482 193.461 291.482 196.803C291.482 200.146 296.14 202.855 301.885 202.855Z",
    fill: "url(#paint73_linear_807_97)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M295.342 196.826C295.342 198.932 298.268 200.635 301.885 200.635C305.502 200.635 308.428 198.932 308.428 196.826C308.428 194.721 305.502 193.018 301.885 193.018C298.268 193.018 295.342 194.721 295.342 196.826Z",
    fill: "#6B24D6"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M301.885 196.619C304.373 196.619 306.55 197.425 307.645 198.621C308.14 198.08 308.428 197.471 308.428 196.815C308.428 194.709 305.502 193.006 301.885 193.006C298.268 193.006 295.342 194.709 295.342 196.815C295.342 197.471 295.63 198.08 296.125 198.621C297.231 197.425 299.396 196.619 301.885 196.619Z",
    fill: "url(#paint74_linear_807_97)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M301.885 202.821C296.205 202.821 291.586 200.174 291.482 196.872C291.482 196.907 291.482 196.941 291.482 196.976C291.482 200.312 296.136 203.028 301.885 203.028C307.633 203.028 312.287 200.324 312.287 196.976C312.287 196.941 312.287 196.907 312.287 196.872C312.183 200.163 307.575 202.821 301.885 202.821Z",
    fill: "url(#paint75_radial_807_97)"
  }), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M290.25 268.184V278.01L294.512 275.456V265.63L290.25 268.184Z",
    fill: "url(#paint76_linear_807_97)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M290.261 268.184V278.01L279.11 271.705V261.891L290.261 268.184Z",
    fill: "url(#paint77_linear_807_97)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M281.172 271.198V264.456L288.199 268.357V275.099L281.172 271.198Z",
    fill: "#25054D"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M279.11 261.89L290.261 268.184L294.512 265.63L283.35 259.325L279.11 261.89Z",
    fill: "url(#paint78_linear_807_97)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M286.333 270.508C286.333 271.083 286.137 271.498 285.815 271.693L285.216 272.038C284.882 272.223 285.089 271.797 284.582 271.509C283.557 270.911 282.716 269.473 282.716 268.299C282.716 267.712 282.175 267.712 282.509 267.517C282.509 267.517 283.165 267.16 283.177 267.16C283.511 266.976 283.972 267.011 284.479 267.298C285.504 267.896 286.345 269.335 286.345 270.508H286.333Z",
    fill: "url(#paint79_linear_807_97)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M285.677 270.876C285.677 272.061 284.836 272.533 283.811 271.935C282.785 271.337 281.944 269.898 281.944 268.725C281.944 267.551 282.785 267.068 283.811 267.666C284.836 268.265 285.677 269.703 285.677 270.876Z",
    fill: "url(#paint80_linear_807_97)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M285.227 270.784C285.227 271.279 285.054 271.636 284.778 271.797L283.879 272.326C283.58 272.487 283.764 272.13 283.327 271.877C282.44 271.371 281.725 270.128 281.725 269.116C281.725 268.61 281.265 268.61 281.541 268.449L282.486 267.908C282.785 267.747 283.177 267.781 283.615 268.023C284.502 268.529 285.216 269.772 285.216 270.784H285.227Z",
    fill: "url(#paint81_linear_807_97)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M284.283 271.337C284.283 272.349 283.569 272.763 282.682 272.246C281.795 271.739 281.08 270.497 281.08 269.484C281.08 268.472 281.795 268.058 282.682 268.575C283.569 269.082 284.283 270.324 284.283 271.337Z",
    fill: "url(#paint82_linear_807_97)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M283.903 267.609C283.407 267.321 282.958 267.287 282.624 267.448C282.935 267.356 283.327 267.425 283.741 267.666C284.767 268.265 285.608 269.703 285.608 270.876C285.608 271.486 285.377 271.912 285.02 272.096C285.481 271.969 285.769 271.521 285.769 270.819C285.769 269.634 284.928 268.196 283.903 267.609Z",
    fill: "#E6E7E8"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M282.751 268.541C282.324 268.299 281.933 268.265 281.645 268.403C281.91 268.322 282.244 268.38 282.612 268.587C283.499 269.105 284.225 270.347 284.225 271.36C284.225 271.889 284.029 272.257 283.718 272.407C284.11 272.292 284.363 271.912 284.363 271.302C284.363 270.278 283.638 269.035 282.751 268.529V268.541Z",
    fill: "url(#paint83_radial_807_97)"
  }), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M283.523 271.072C283.523 271.659 283.108 271.889 282.601 271.601C282.094 271.302 281.679 270.589 281.679 270.013C281.679 269.438 282.094 269.197 282.601 269.484C283.108 269.783 283.523 270.497 283.523 271.072Z",
    fill: "#2AF6FF"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M230.601 72.0365H228.712L228.504 67.0546L225.958 66.0536L226.696 64.1897L229.875 65.4438C230.255 65.5934 230.509 65.9616 230.509 66.3758L230.589 72.048L230.601 72.0365Z",
    fill: "url(#paint84_linear_807_97)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M185.813 71.047H183.808V66.1111C183.808 65.6969 184.062 65.3287 184.442 65.1792L187.621 63.925L188.358 65.789L185.813 66.7899V71.047Z",
    fill: "url(#paint85_linear_807_97)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M275.078 278.01L273.074 277.63V273.304C273.074 272.867 273.35 272.487 273.765 272.349L282.75 269.404L283.384 271.313L275.09 274.04V278.021L275.078 278.01Z",
    fill: "url(#paint86_linear_807_97)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M374.113 176.841H372.108C372.108 154.325 361.107 132.855 340.303 114.768C340.084 114.573 339.957 114.297 339.957 114.009V109.671L334.704 106.76L336.294 105.518L341.754 108.705C341.892 108.877 341.962 109.096 341.962 109.326V113.549C362.996 131.969 374.113 153.841 374.113 176.83V176.841Z",
    fill: "url(#paint87_linear_807_97)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M358.204 194.088V203.914L362.467 201.359V191.534L358.204 194.088Z",
    fill: "url(#paint88_linear_807_97)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M358.216 194.088V203.914L347.053 197.609V187.794L358.216 194.088Z",
    fill: "url(#paint89_linear_807_97)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M349.115 197.102V190.372L356.154 194.272V201.014L349.115 197.102Z",
    fill: "#25054D"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M347.053 187.794L358.216 194.088L362.467 191.534L351.292 185.229L347.053 187.794Z",
    fill: "url(#paint90_linear_807_97)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M354.276 196.412C354.276 196.987 354.08 197.401 353.758 197.597L353.159 197.942C352.825 198.126 353.032 197.701 352.525 197.413C351.5 196.815 350.659 195.376 350.659 194.203C350.659 193.616 350.118 193.616 350.452 193.421C350.452 193.421 351.108 193.064 351.12 193.064C351.454 192.88 351.915 192.914 352.421 193.213C353.447 193.812 354.288 195.25 354.288 196.423L354.276 196.412Z",
    fill: "url(#paint91_linear_807_97)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M353.631 196.78C353.631 197.965 352.79 198.437 351.765 197.839C350.74 197.24 349.899 195.802 349.899 194.629C349.899 193.455 350.74 192.972 351.765 193.57C352.79 194.168 353.631 195.607 353.631 196.78Z",
    fill: "url(#paint92_linear_807_97)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M353.17 196.7C353.17 197.194 352.998 197.551 352.721 197.712C352.721 197.712 351.823 198.241 351.823 198.253C351.535 198.414 351.719 198.046 351.281 197.793C350.394 197.286 349.68 196.044 349.68 195.031C349.68 194.525 349.219 194.525 349.496 194.364C349.496 194.364 350.44 193.823 350.452 193.823C350.74 193.662 351.131 193.697 351.569 193.95C352.456 194.456 353.17 195.699 353.17 196.711V196.7Z",
    fill: "url(#paint93_linear_807_97)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M352.226 197.252C352.226 198.264 351.511 198.679 350.624 198.161C349.737 197.655 349.023 196.412 349.023 195.4C349.023 194.387 349.737 193.973 350.624 194.491C351.511 194.997 352.226 196.239 352.226 197.252Z",
    fill: "url(#paint94_linear_807_97)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M351.846 193.524C351.35 193.236 350.901 193.202 350.567 193.363C350.878 193.271 351.27 193.34 351.684 193.582C352.71 194.18 353.55 195.618 353.55 196.792C353.55 197.401 353.32 197.827 352.963 198.011C353.424 197.885 353.712 197.436 353.712 196.734C353.712 195.549 352.871 194.111 351.846 193.524Z",
    fill: "#E6E7E8"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M350.694 194.445C350.267 194.203 349.876 194.168 349.588 194.306C349.853 194.226 350.187 194.283 350.555 194.491C351.442 195.008 352.168 196.251 352.168 197.263C352.168 197.793 351.972 198.161 351.661 198.31C352.053 198.195 352.306 197.804 352.306 197.206C352.306 196.182 351.581 194.939 350.694 194.433V194.445Z",
    fill: "url(#paint95_radial_807_97)"
  }), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M351.477 196.987C351.477 197.574 351.062 197.804 350.555 197.516C350.048 197.217 349.634 196.504 349.634 195.929C349.634 195.353 350.048 195.112 350.555 195.399C351.062 195.699 351.477 196.412 351.477 196.987Z",
    fill: "#2AF6FF"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M375.507 184.112C374.263 183.388 373.076 183.019 372.005 182.95C372.005 182.881 372.005 182.812 372.005 182.732C372.005 172.147 364.517 159.249 355.29 153.933C347.86 149.653 341.581 151.575 339.393 157.995C338.828 157.558 338.241 157.155 337.642 156.81C331.548 153.3 326.617 156.108 326.617 163.092C326.617 170.076 331.548 178.578 337.642 182.087C340.683 183.848 371.89 201.831 375.495 203.914C380.265 206.663 384.135 204.466 384.135 199.001C384.135 193.536 380.265 186.874 375.495 184.124L375.507 184.112Z",
    fill: "url(#paint96_linear_807_97)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M379.389 201.854C378.778 201.854 377.972 201.59 377.131 201.106L339.278 179.28C334.174 176.335 329.877 168.925 329.877 163.092C329.877 161.389 330.246 158.536 332.711 158.536C333.667 158.536 334.819 158.904 336.04 159.617C336.455 159.859 336.916 160.169 337.446 160.572C339.208 161.907 341.754 161.124 342.468 159.042C343.402 156.281 345.199 154.877 347.802 154.877C349.542 154.877 351.569 155.521 353.677 156.729C361.845 161.435 368.745 173.309 368.779 182.674V182.962C368.779 184.665 370.093 186.069 371.798 186.184C372.408 186.23 373.134 186.483 373.894 186.92C377.638 189.071 380.91 194.721 380.91 199.001C380.91 200.094 380.691 201.003 380.299 201.475C380.138 201.682 379.907 201.866 379.389 201.866V201.854Z",
    fill: "url(#paint97_linear_807_97)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M343.01 158.351C343.263 157.604 343.586 156.971 343.955 156.43C343.332 157.086 342.837 157.949 342.469 159.03C342.388 159.26 342.284 159.479 342.157 159.675C342.526 159.329 342.826 158.881 343.01 158.351Z",
    fill: "url(#paint98_linear_807_97)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M379.919 201.175C379.308 201.175 378.502 200.911 377.661 200.427L339.807 178.601C334.704 175.656 330.407 168.246 330.407 162.413C330.407 161.446 330.534 160.1 331.087 159.122C330.062 160.043 329.866 161.861 329.866 163.092C329.866 168.925 334.174 176.346 339.266 179.28L377.12 201.106C377.961 201.589 378.767 201.854 379.378 201.854C379.907 201.854 380.126 201.67 380.288 201.463C380.38 201.348 380.46 201.198 380.541 201.037C380.391 201.118 380.207 201.175 379.919 201.175Z",
    fill: "url(#paint99_linear_807_97)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M401 189.221C401 183.756 397.129 177.094 392.36 174.344C391.116 173.619 389.93 173.251 388.858 173.182C388.858 173.113 388.858 173.044 388.858 172.964C388.858 162.378 381.371 149.481 372.143 144.165C366.959 141.174 362.444 141.576 359.264 143.693L353.931 146.731C350.912 145.166 348.217 145.178 346.328 146.489L330.35 155.763C332.297 154.911 334.843 155.187 337.642 156.81C338.241 157.155 338.817 157.558 339.393 157.995C341.57 151.575 347.86 149.653 355.29 153.933C364.529 159.26 372.005 172.158 372.005 182.732C372.005 182.812 372.005 182.87 372.005 182.95C373.076 183.019 374.263 183.399 375.507 184.113C380.276 186.862 384.147 193.524 384.147 198.989C384.147 201.302 383.456 203.028 382.292 204.04L398.212 194.928C399.94 194.099 401.023 192.12 401.023 189.232L401 189.221Z",
    fill: "url(#paint100_linear_807_97)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M364.167 156.236C371.016 153.425 375.536 148.634 374.262 145.537C372.987 142.44 366.401 142.208 359.552 145.019C352.702 147.831 348.182 152.621 349.457 155.718C350.731 158.816 357.317 159.047 364.167 156.236Z",
    fill: "url(#paint101_radial_807_97)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M392.095 181.259C393.075 183.008 389.55 186.828 384.227 189.773C378.905 192.719 380.46 190.935 379.493 189.186C378.514 187.438 375.38 186.379 380.702 183.422C386.025 180.477 391.128 179.51 392.095 181.259Z",
    fill: "url(#paint102_radial_807_97)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M337.377 157.247C337.976 157.592 338.552 157.995 339.128 158.432C339.255 158.064 339.393 157.707 339.554 157.362C339.116 157.04 338.667 156.741 338.218 156.476C334.37 154.256 330.995 154.566 329.025 156.844C331.041 155.314 334.036 155.326 337.388 157.247H337.377Z",
    fill: "url(#paint103_radial_807_97)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M376.06 183.779C374.816 183.054 373.629 182.686 372.558 182.617C372.558 182.548 372.558 182.479 372.558 182.398C372.558 171.813 365.07 158.915 355.843 153.6C350.175 150.332 345.164 150.689 342.146 153.899C345.21 151.425 349.83 151.391 355.002 154.371C364.241 159.698 371.717 172.595 371.717 183.169C371.717 183.25 371.717 183.307 371.717 183.388C372.788 183.457 373.975 183.836 375.219 184.55C379.988 187.3 383.859 193.961 383.859 199.427C383.859 201.382 383.352 202.913 382.499 203.96C383.859 202.993 384.688 201.175 384.688 198.644C384.688 193.179 380.818 186.517 376.048 183.767L376.06 183.779Z",
    fill: "url(#paint104_radial_807_97)"
  }), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M348.055 240.363L346.051 239.777V197.62C346.051 197.194 346.316 196.815 346.719 196.677L350.29 195.388L350.97 197.275L348.067 198.322V240.363H348.055Z",
    fill: "url(#paint105_linear_807_97)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M35.2618 213.36C52.6432 213.36 66.7336 206.184 66.7336 197.332C66.7336 188.481 52.6432 181.305 35.2618 181.305C17.8804 181.305 3.79004 188.481 3.79004 197.332C3.79004 206.184 17.8804 213.36 35.2618 213.36Z",
    fill: "url(#paint106_radial_807_97)"
  }), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9533 190.475H6.10547V198.311C6.10547 206.48 17.4869 213.095 31.5294 213.095C45.5719 213.095 56.9533 206.48 56.9533 198.311C56.9533 198.241 56.9533 198.172 56.9533 198.103V190.475Z",
    fill: "url(#paint107_linear_807_97)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5294 205.363C45.5706 205.363 56.9533 198.744 56.9533 190.579C56.9533 182.413 45.5706 175.794 31.5294 175.794C17.4881 175.794 6.10547 182.413 6.10547 190.579C6.10547 198.744 17.4881 205.363 31.5294 205.363Z",
    fill: "url(#paint108_linear_807_97)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M31.5294 205.306C17.6366 205.306 6.35886 198.828 6.11694 190.786C6.11694 190.878 6.11694 190.958 6.11694 191.051C6.11694 199.219 17.4984 205.835 31.5409 205.835C45.5834 205.835 56.9648 199.219 56.9648 191.051C56.9648 190.958 56.9648 190.878 56.9648 190.786C56.7229 198.828 45.4451 205.306 31.5524 205.306H31.5294Z",
    fill: "url(#paint109_radial_807_97)"
  }), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2023 182.628H7.85645V189.094C7.85645 189.163 7.85645 189.221 7.85645 189.29C7.85645 196.895 18.4545 203.062 31.5294 203.062C44.6042 203.062 55.2023 196.895 55.2023 189.29C55.2023 189.221 55.2023 189.163 55.2023 189.094V182.628Z",
    fill: "url(#paint110_linear_807_97)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2023 181.501H7.85645V187.967C7.85645 188.036 7.85645 188.094 7.85645 188.163C7.85645 195.768 18.4545 201.935 31.5294 201.935C44.6042 201.935 55.2023 195.768 55.2023 188.163C55.2023 188.094 55.2023 188.036 55.2023 187.967V181.501Z",
    fill: "url(#paint111_linear_807_97)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9533 176.576H6.10547V184.412C6.10547 192.581 17.4869 199.196 31.5294 199.196C45.5719 199.196 56.9533 192.581 56.9533 184.412C56.9533 184.343 56.9533 184.274 56.9533 184.205V176.576Z",
    fill: "url(#paint112_linear_807_97)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5294 191.465C45.5706 191.465 56.9533 184.845 56.9533 176.68C56.9533 168.515 45.5706 161.895 31.5294 161.895C17.4881 161.895 6.10547 168.515 6.10547 176.68C6.10547 184.845 17.4881 191.465 31.5294 191.465Z",
    fill: "url(#paint113_linear_807_97)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M31.5294 191.407C17.6366 191.407 6.35886 184.929 6.11694 176.887C6.11694 176.979 6.11694 177.06 6.11694 177.152C6.11694 185.321 17.4984 191.936 31.5409 191.936C45.5834 191.936 56.9648 185.321 56.9648 177.152C56.9648 177.06 56.9648 176.979 56.9648 176.887C56.7229 184.929 45.4451 191.407 31.5524 191.407H31.5294Z",
    fill: "url(#paint114_radial_807_97)"
  }), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2023 168.73H7.85645V175.196C7.85645 175.265 7.85645 175.322 7.85645 175.38C7.85645 182.985 18.4545 189.152 31.5294 189.152C44.6042 189.152 55.2023 182.985 55.2023 175.38C55.2023 175.311 55.2023 175.253 55.2023 175.196V168.73Z",
    fill: "url(#paint115_linear_807_97)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2023 167.614H7.85645V174.08C7.85645 174.149 7.85645 174.206 7.85645 174.275C7.85645 181.88 18.4545 188.047 31.5294 188.047C44.6042 188.047 55.2023 181.88 55.2023 174.275C55.2023 174.206 55.2023 174.149 55.2023 174.08V167.614Z",
    fill: "url(#paint116_linear_807_97)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9533 163.069H6.10547V170.904C6.10547 179.073 17.4869 185.689 31.5294 185.689C45.5719 185.689 56.9533 179.073 56.9533 170.904C56.9533 170.835 56.9533 170.766 56.9533 170.697V163.069Z",
    fill: "url(#paint117_linear_807_97)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5294 177.957C45.5706 177.957 56.9533 171.338 56.9533 163.172C56.9533 155.007 45.5706 148.388 31.5294 148.388C17.4881 148.388 6.10547 155.007 6.10547 163.172C6.10547 171.338 17.4881 177.957 31.5294 177.957Z",
    fill: "url(#paint118_linear_807_97)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M31.5294 177.9C17.6366 177.9 6.35886 171.422 6.11694 163.38C6.11694 163.472 6.11694 163.552 6.11694 163.644C6.11694 171.813 17.4984 178.429 31.5409 178.429C45.5834 178.429 56.9648 171.813 56.9648 163.644C56.9648 163.552 56.9648 163.472 56.9648 163.38C56.7229 171.422 45.4451 177.9 31.5524 177.9H31.5294Z",
    fill: "url(#paint119_radial_807_97)"
  }), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2023 155.222H7.85645V161.688C7.85645 161.757 7.85645 161.815 7.85645 161.872C7.85645 169.477 18.4545 175.644 31.5294 175.644C44.6042 175.644 55.2023 169.477 55.2023 161.872C55.2023 161.803 55.2023 161.746 55.2023 161.688V155.222Z",
    fill: "url(#paint120_linear_807_97)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2023 154.094H7.85645V160.561C7.85645 160.63 7.85645 160.687 7.85645 160.756C7.85645 168.361 18.4545 174.528 31.5294 174.528C44.6042 174.528 55.2023 168.361 55.2023 160.756C55.2023 160.687 55.2023 160.63 55.2023 160.561V154.094Z",
    fill: "url(#paint121_linear_807_97)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9533 149.412H6.10547V157.247C6.10547 165.416 17.4869 172.032 31.5294 172.032C45.5719 172.032 56.9533 165.416 56.9533 157.247C56.9533 157.178 56.9533 157.109 56.9533 157.04V149.412Z",
    fill: "url(#paint122_linear_807_97)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5294 164.288C45.5706 164.288 56.9533 157.669 56.9533 149.504C56.9533 141.338 45.5706 134.719 31.5294 134.719C17.4881 134.719 6.10547 141.338 6.10547 149.504C6.10547 157.669 17.4881 164.288 31.5294 164.288Z",
    fill: "url(#paint123_linear_807_97)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M31.5294 164.242C17.6366 164.242 6.35886 157.765 6.11694 149.722C6.11694 149.814 6.11694 149.895 6.11694 149.987C6.11694 158.156 17.4984 164.772 31.5409 164.772C45.5834 164.772 56.9648 158.156 56.9648 149.987C56.9648 149.895 56.9648 149.814 56.9648 149.722C56.7229 157.765 45.4451 164.242 31.5524 164.242H31.5294Z",
    fill: "url(#paint124_radial_807_97)"
  }), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2023 141.553H7.85645V148.019C7.85645 148.089 7.85645 148.146 7.85645 148.215C7.85645 155.82 18.4545 161.987 31.5294 161.987C44.6042 161.987 55.2023 155.82 55.2023 148.215C55.2023 148.146 55.2023 148.089 55.2023 148.019V141.553Z",
    fill: "url(#paint125_linear_807_97)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2023 140.437H7.85645V146.903C7.85645 146.972 7.85645 147.03 7.85645 147.099C7.85645 154.704 18.4545 160.871 31.5294 160.871C44.6042 160.871 55.2023 154.704 55.2023 147.099C55.2023 147.03 55.2023 146.972 55.2023 146.903V140.437Z",
    fill: "url(#paint126_linear_807_97)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9533 135.743H6.10547V143.578C6.10547 151.747 17.4869 158.363 31.5294 158.363C45.5719 158.363 56.9533 151.747 56.9533 143.578C56.9533 143.509 56.9533 143.44 56.9533 143.371V135.743Z",
    fill: "url(#paint127_linear_807_97)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5294 150.631C45.5706 150.631 56.9533 144.012 56.9533 135.847C56.9533 127.681 45.5706 121.062 31.5294 121.062C17.4881 121.062 6.10547 127.681 6.10547 135.847C6.10547 144.012 17.4881 150.631 31.5294 150.631Z",
    fill: "url(#paint128_linear_807_97)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M31.5294 150.574C17.6366 150.574 6.35886 144.096 6.11694 136.054C6.11694 136.146 6.11694 136.226 6.11694 136.318C6.11694 144.487 17.4984 151.103 31.5409 151.103C45.5834 151.103 56.9648 144.487 56.9648 136.318C56.9648 136.226 56.9648 136.146 56.9648 136.054C56.7229 144.096 45.4451 150.574 31.5524 150.574H31.5294Z",
    fill: "url(#paint129_radial_807_97)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M33.4648 141.346C40.565 141.346 46.3208 138.415 46.3208 134.8C46.3208 131.184 40.565 128.253 33.4648 128.253C26.3647 128.253 20.6089 131.184 20.6089 134.8C20.6089 138.415 26.3647 141.346 33.4648 141.346Z",
    fill: "url(#paint130_radial_807_97)"
  }), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7014 130.945H21.3577V134.972C21.3577 138.24 25.9079 140.886 31.5295 140.886C37.1511 140.886 41.7014 138.24 41.7014 134.972C41.7014 134.949 41.7014 134.915 41.7014 134.892V130.945Z",
    fill: "url(#paint131_linear_807_97)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3577 130.991C21.3577 134.259 25.9079 136.905 31.5295 136.905C37.1511 136.905 41.7014 134.259 41.7014 130.991C41.7014 127.724 37.1511 125.077 31.5295 125.077C25.9079 125.077 21.3577 127.724 21.3577 130.991Z",
    fill: "url(#paint132_linear_807_97)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5295 134.742C35.0668 134.742 37.9344 133.073 37.9344 131.014C37.9344 128.956 35.0668 127.286 31.5295 127.286C27.9921 127.286 25.1245 128.956 25.1245 131.014C25.1245 133.073 27.9921 134.742 31.5295 134.742Z",
    fill: "#6B24D6"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5295 130.819C33.9717 130.819 36.0913 131.613 37.1626 132.775C37.6464 132.245 37.9229 131.647 37.9229 131.014C37.9229 128.955 35.0545 127.286 31.518 127.286C27.9814 127.286 25.113 128.955 25.113 131.014C25.113 131.647 25.3895 132.257 25.8733 132.775C26.9562 131.613 29.0758 130.819 31.5065 130.819H31.5295Z",
    fill: "url(#paint133_linear_807_97)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M31.5295 136.882C25.9771 136.882 21.4613 134.293 21.3577 131.072C21.3577 131.106 21.3577 131.141 21.3577 131.175C21.3577 134.443 25.9079 137.089 31.5295 137.089C37.1511 137.089 41.7014 134.443 41.7014 131.175C41.7014 131.141 41.7014 131.106 41.7014 131.072C41.6093 134.293 37.0935 136.882 31.5295 136.882Z",
    fill: "url(#paint134_radial_807_97)"
  }), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0982 209.862C34.0982 211.415 32.8425 212.669 31.2874 212.669C29.7322 212.669 28.4766 211.415 28.4766 209.862C28.4766 208.309 29.7322 207.055 31.2874 207.055C32.8425 207.055 34.0982 208.309 34.0982 209.862Z",
    fill: "url(#paint135_linear_807_97)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5453 209.862C33.5453 211.105 32.5315 212.117 31.2874 212.117C30.0433 212.117 29.0295 211.105 29.0295 209.862C29.0295 208.619 30.0433 207.607 31.2874 207.607C32.5315 207.607 33.5453 208.619 33.5453 209.862Z",
    fill: "url(#paint136_linear_807_97)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2874 211.243C32.0126 211.243 32.6006 210.656 32.6006 209.931C32.6006 209.207 32.0126 208.62 31.2874 208.62C30.5621 208.62 29.9741 209.207 29.9741 209.931C29.9741 210.656 30.5621 211.243 31.2874 211.243Z",
    fill: "#43E8E1"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M261.865 83.3926C241.971 72.1516 222.514 52.9718 206.214 28.5339L205.995 28.4073C189.695 34.0451 170.238 30.789 150.343 19.0763L149.583 18.6276L150.654 55.7561C154.433 113.319 174.085 138.366 205.718 191.89L206.49 192.339C238.123 175.311 257.787 172.929 261.554 119.716L262.626 83.8183L261.865 83.3926Z",
    fill: "url(#paint137_linear_807_97)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M268.547 77.6052C248.652 66.3643 229.195 47.1844 212.884 22.7465L212.665 22.62C196.364 28.2577 176.908 25.0016 157.013 13.2889L156.253 12.8402L149.779 18.7541L150.332 19.0762C170.226 30.7774 189.683 34.0335 205.983 28.4073L206.202 28.5338C222.503 52.9717 241.959 72.1516 261.865 83.3926L262.626 83.8183L261.554 119.716C259.089 154.44 249.862 167.522 234.944 177.14C253.571 166.152 265.471 152.955 268.247 113.917L269.318 78.0194L268.558 77.5937L268.547 77.6052Z",
    fill: "url(#paint138_linear_807_97)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M269.307 78.031L268.547 77.6053C248.652 66.3643 229.195 47.1845 212.883 22.7466L212.665 22.62L205.972 28.4073L206.191 28.5339C222.491 52.9718 241.948 72.1516 261.854 83.3926L262.614 83.8183L269.307 78.031Z",
    fill: "url(#paint139_linear_807_97)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M262.626 83.8182L261.554 119.716C259.089 154.44 249.862 167.521 234.944 177.14C253.571 166.152 265.471 152.955 268.247 113.917L269.319 78.0194L262.626 83.8067V83.8182Z",
    fill: "url(#paint140_linear_807_97)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M259.792 84.8307C240.335 73.8429 221.316 55.0888 205.373 31.1916L205.154 31.0651C189.211 36.5762 170.192 33.3892 150.735 21.9411L149.986 21.5039L143.65 27.2912L144.18 27.6019C163.637 39.0499 182.656 42.2255 198.599 36.7258L198.818 36.8524C214.761 60.7495 233.78 79.5036 253.237 90.4915L253.986 90.9057L252.938 125.998C250.53 159.951 241.499 172.734 226.926 182.145C245.139 171.399 256.774 158.49 259.481 120.326L260.529 85.2334L259.78 84.8077L259.792 84.8307Z",
    fill: "url(#paint141_linear_807_97)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M260.541 85.245L259.792 84.8193C240.335 73.8314 221.316 55.0773 205.373 31.1802L205.154 31.0536L198.611 36.7143L198.83 36.8409C214.773 60.738 233.792 79.4922 253.249 90.48L253.997 90.8942L260.541 85.2335V85.245Z",
    fill: "url(#paint142_linear_807_97)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M253.997 90.9057L252.949 125.998C250.542 159.951 241.51 172.733 226.938 182.145C245.15 171.399 256.785 158.49 259.492 120.325L260.541 85.2334L253.997 90.8942V90.9057Z",
    fill: "url(#paint143_linear_807_97)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M262.637 82.8403C242.743 71.5994 223.286 52.4195 206.974 27.9816L206.755 27.8551C190.455 33.4928 170.998 30.2367 151.104 18.524L150.343 18.0753L150.401 19.9277C170.111 31.3873 189.372 34.5513 205.534 28.9596L205.753 29.0862C222.053 53.5241 241.51 72.7039 261.416 83.9449L262.176 84.3706L261.105 120.268C259.147 147.951 252.868 161.861 242.858 171.249C253.583 161.849 260.287 147.951 262.338 119.152L263.409 83.2546L262.649 82.8288L262.637 82.8403Z",
    fill: "url(#paint144_radial_807_97)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M212.388 215.304C242.443 215.304 266.807 204.935 266.807 192.143C266.807 179.352 242.443 168.983 212.388 168.983C182.333 168.983 157.969 179.352 157.969 192.143C157.969 204.935 182.333 215.304 212.388 215.304Z",
    fill: "url(#paint145_radial_807_97)"
  }), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M249.148 94.9212C229.253 83.6802 209.796 64.5003 193.496 40.0625L193.277 39.9359C176.977 45.5736 157.52 42.3176 137.626 30.6048L136.865 30.1561L137.937 67.2847C141.715 124.847 161.368 149.895 193.001 203.419L193.772 203.868C225.405 186.839 245.07 184.458 248.836 131.244L249.908 95.3469L249.148 94.9212Z",
    fill: "url(#paint146_linear_807_97)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M255.84 89.1338C235.946 77.8928 216.489 58.713 200.177 34.2751L199.958 34.1485C183.658 39.7863 164.201 36.5302 144.307 24.8175L143.547 24.3688L137.073 30.2827L137.625 30.6048C157.52 42.306 176.977 45.5621 193.277 39.9359L193.496 40.0624C209.796 64.5003 229.253 83.6801 249.159 94.9211L249.919 95.3468L248.848 131.244C246.383 165.968 237.155 179.05 222.237 188.669C240.865 177.681 252.765 164.484 255.541 125.445L256.612 89.548L255.852 89.1223L255.84 89.1338Z",
    fill: "url(#paint147_linear_807_97)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M256.601 89.5595L255.841 89.1338C235.946 77.8929 216.489 58.713 200.177 34.2751L199.959 34.1486L193.266 39.9359L193.485 40.0624C209.785 64.5003 229.242 83.6802 249.148 94.9211L249.908 95.3469L256.601 89.5595Z",
    fill: "url(#paint148_linear_807_97)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M249.908 95.3469L248.837 131.244C246.371 165.968 237.144 179.05 222.226 188.669C240.853 177.681 252.753 164.484 255.529 125.446L256.601 89.5481L249.908 95.3354V95.3469Z",
    fill: "url(#paint149_linear_807_97)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M189.453 179.062C164.893 138.378 152.544 117.909 149.56 73.2446L148.88 49.8077C164.651 56.9297 179.765 59.1963 193.381 56.4925C206.997 74.9015 222.111 90.0658 237.881 101.134L237.202 123.789C234.218 165.013 221.869 171.238 197.309 183.606C196.019 184.251 194.717 184.918 193.381 185.585C192.045 183.365 190.731 181.19 189.441 179.062H189.453Z",
    fill: "url(#paint150_linear_807_97)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M193.381 56.481C206.997 74.8899 222.111 90.0543 237.881 101.123L237.202 123.777C234.218 165.002 221.869 171.226 197.309 183.595C196.019 184.239 194.717 184.906 193.381 185.574V56.481Z",
    fill: "url(#paint151_linear_807_97)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M249.931 94.3574C230.036 83.1165 210.58 63.9366 194.268 39.4987L194.049 39.3722C177.748 45.0099 158.292 41.7538 138.397 30.0411L137.637 29.5924L137.695 31.4448C157.405 42.9044 176.666 46.0684 192.828 40.4767L193.047 40.6033C209.347 65.0412 228.804 84.221 248.71 95.462L249.47 95.8877L248.399 131.785C246.44 159.468 240.162 173.378 230.151 182.766C240.876 173.366 247.581 159.468 249.631 130.669L250.703 94.7716L249.942 94.3459L249.931 94.3574Z",
    fill: "url(#paint152_radial_807_97)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M189.453 179.062C164.893 138.378 152.544 117.909 149.56 73.2446L148.88 49.8077C164.651 56.9297 179.765 59.1963 193.381 56.4925C206.997 74.9015 222.111 90.0658 237.881 101.134L237.202 123.789C234.218 165.013 221.869 171.238 197.309 183.606C196.019 184.251 194.717 184.918 193.381 185.585C192.045 183.365 190.731 181.19 189.441 179.062H189.453Z",
    fill: "url(#paint153_radial_807_97)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M193.381 56.4809C179.765 59.1847 164.639 56.9181 148.88 49.7961L148.926 51.2343C164.317 57.9881 179.073 60.1282 192.39 57.4819C206.006 75.8908 221.12 91.0552 236.891 102.124L236.211 124.778C234.541 147.812 229.956 159.916 221.938 168.269C230.566 159.882 235.474 147.755 237.213 123.777L237.893 101.123C222.122 90.0542 207.009 74.8899 193.392 56.4809H193.381Z",
    fill: "url(#paint154_radial_807_97)"
  }), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M201.548 287.525C158.154 287.525 116.349 277.998 83.8402 260.717C83.5177 260.544 83.3103 260.211 83.3103 259.842C83.3103 259.474 83.5061 259.129 83.8287 258.957L165.492 213.97V190.947C165.492 190.59 165.688 190.257 165.987 190.084L198.138 172.4L199.152 174.137L167.496 191.522V214.556C167.496 214.925 167.3 215.258 166.978 215.431L86.4321 259.808C118.411 276.399 159.213 285.523 201.56 285.523C226.949 285.523 251.371 282.359 274.145 276.111L274.675 278.044C251.728 284.338 227.122 287.536 201.56 287.536L201.548 287.525Z",
    fill: "url(#paint155_linear_807_97)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.3,
    d: "M201.548 262.742C158.154 262.742 116.349 253.215 83.8402 235.934C83.5177 235.761 83.3103 235.428 83.3103 235.059C83.3103 234.691 83.5061 234.346 83.8287 234.173L165.492 189.187V166.164C165.492 165.807 165.688 165.473 165.987 165.301L201.157 146.271L202.17 148.008L167.496 166.751V189.785C167.496 190.153 167.3 190.487 166.978 190.659L86.4321 235.036C118.411 251.627 159.213 260.751 201.56 260.751C226.949 260.751 251.371 257.587 274.145 251.34L274.675 253.273C251.728 259.566 227.122 262.765 201.56 262.765L201.548 262.742Z",
    fill: "url(#paint156_radial_807_97)"
  }), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M165.1 274.903L165.711 274.558C165.711 274.558 167.934 273.258 168.003 273.246C169.351 272.522 171.01 272.13 172.668 272.176C172.91 272.176 173.141 272.199 173.36 272.222C174.454 272.314 175.652 272.706 176.458 273.177L188.036 279.851L199.601 286.524C200.638 287.122 201.502 288.123 201.767 289.113C201.836 289.377 201.894 289.642 201.905 289.918C201.986 291.448 201.064 292.909 199.36 293.887L198.749 294.233C198.749 294.233 196.526 295.533 196.457 295.544C195.109 296.269 193.45 296.66 191.791 296.614C191.549 296.614 191.319 296.591 191.1 296.568C190.006 296.476 188.808 296.085 188.001 295.613L176.424 288.94L164.858 282.267C163.821 281.669 162.957 280.668 162.692 279.678C162.623 279.413 162.566 279.149 162.554 278.873C162.474 277.342 163.395 275.881 165.1 274.903Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M165.204 275.087L165.803 274.765C165.906 274.708 167.934 273.534 168.061 273.511C169.408 272.821 171.044 272.487 172.645 272.568C172.876 272.579 173.095 272.602 173.314 272.625C174.293 272.729 175.606 273.189 176.332 273.615L187.702 280.173L199.037 286.719C199.97 287.26 200.961 288.307 201.226 289.193C201.306 289.446 201.375 289.699 201.41 289.964C201.583 291.437 200.719 292.886 199.025 293.864L198.426 294.187C198.323 294.244 196.295 295.418 196.169 295.441C194.821 296.131 193.185 296.465 191.584 296.384C191.353 296.373 191.134 296.35 190.916 296.327C189.936 296.223 188.623 295.763 187.897 295.337L176.528 288.779L165.192 282.232C164.259 281.692 163.268 280.645 163.003 279.759C162.923 279.505 162.854 279.252 162.819 278.988C162.646 277.515 163.51 276.065 165.204 275.087Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M165.307 275.26L165.906 274.949C166.068 274.857 167.945 273.787 168.141 273.753C169.489 273.108 171.102 272.821 172.645 272.947C172.864 272.97 173.083 273.005 173.302 273.028C174.178 273.131 175.594 273.672 176.24 274.052L187.402 280.495L198.519 286.915C199.348 287.387 200.477 288.491 200.742 289.262C200.823 289.504 200.915 289.745 200.961 289.998C201.214 291.414 200.419 292.852 198.726 293.83L198.127 294.14C197.966 294.233 196.088 295.303 195.892 295.337C194.544 295.981 192.932 296.269 191.388 296.142C191.169 296.119 190.95 296.085 190.731 296.062C189.856 295.958 188.439 295.418 187.794 295.038L176.631 288.595L165.515 282.175C164.685 281.703 163.556 280.598 163.291 279.828C163.211 279.586 163.119 279.344 163.073 279.103C162.819 277.687 163.614 276.249 165.307 275.271V275.26Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M165.411 275.444L165.999 275.156C166.217 275.03 167.945 274.063 168.199 274.017C169.547 273.419 171.148 273.177 172.622 273.338C172.841 273.362 173.049 273.408 173.256 273.442C174.016 273.546 175.537 274.178 176.113 274.501L187.068 280.817L197.966 287.111C198.691 287.525 199.959 288.675 200.212 289.343C200.304 289.573 200.419 289.791 200.477 290.033C200.811 291.391 200.074 292.817 198.392 293.795L197.804 294.083C197.585 294.21 195.858 295.176 195.604 295.222C194.256 295.82 192.655 296.062 191.181 295.901C190.962 295.878 190.754 295.832 190.547 295.797C189.787 295.694 188.266 295.061 187.69 294.739L176.735 288.422L165.837 282.129C165.111 281.715 163.844 280.564 163.591 279.897C163.499 279.667 163.384 279.448 163.326 279.206C162.992 277.849 163.729 276.422 165.411 275.444Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M165.515 275.617L166.102 275.34C166.367 275.179 167.946 274.328 168.28 274.259C169.627 273.707 171.206 273.511 172.634 273.718C172.841 273.753 173.037 273.81 173.245 273.833C173.89 273.937 175.525 274.65 176.009 274.926L186.757 281.128L197.436 287.295C198.058 287.651 199.463 288.848 199.705 289.412C199.797 289.642 199.936 289.837 200.005 290.068C200.431 291.379 199.751 292.783 198.081 293.761L197.494 294.037C197.229 294.198 195.639 295.05 195.316 295.119C193.968 295.671 192.39 295.866 190.962 295.659C190.754 295.625 190.559 295.567 190.351 295.544C189.706 295.441 188.07 294.727 187.587 294.451L176.839 288.25L166.16 282.083C165.538 281.726 164.133 280.529 163.891 279.966C163.798 279.736 163.66 279.54 163.591 279.31C163.165 277.998 163.845 276.595 165.515 275.628V275.617Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M165.618 275.801L166.194 275.547C166.517 275.363 167.945 274.604 168.337 274.523C169.685 274.017 171.24 273.856 172.611 274.109C172.818 274.144 173.002 274.213 173.198 274.247C173.74 274.339 175.479 275.145 175.882 275.375L186.423 281.461L196.883 287.49C197.401 287.789 199.06 288.986 199.175 289.481C199.325 289.676 199.429 289.883 199.521 290.091C200.039 291.345 199.417 292.748 197.747 293.703L197.171 293.956C196.848 294.141 195.42 294.9 195.028 294.98C193.68 295.487 192.125 295.636 190.754 295.395C190.547 295.36 190.363 295.291 190.167 295.257C189.625 295.165 187.886 294.359 187.483 294.129L176.942 288.043L166.482 282.014C165.964 281.714 164.305 280.518 164.19 280.023C164.04 279.828 163.936 279.62 163.844 279.413C163.326 278.159 163.948 276.756 165.618 275.801Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M165.722 275.973L166.287 275.743C166.667 275.524 167.945 274.869 168.406 274.777C169.754 274.316 171.286 274.201 172.599 274.489C172.795 274.535 172.979 274.604 173.164 274.65C173.59 274.742 175.445 275.628 175.767 275.812L186.1 281.772L196.341 287.674C196.756 287.916 198.565 289.147 198.657 289.55C198.818 289.734 198.945 289.918 199.048 290.125C199.659 291.322 199.083 292.714 197.424 293.669L196.86 293.899C196.48 294.118 195.201 294.773 194.74 294.865C193.392 295.326 191.86 295.429 190.547 295.153C190.351 295.107 190.167 295.038 189.982 294.992C189.556 294.9 187.702 294.014 187.379 293.83L177.046 287.87L166.805 281.968C166.39 281.726 164.582 280.495 164.489 280.092C164.328 279.908 164.201 279.724 164.098 279.517C163.487 278.32 164.063 276.928 165.722 275.973Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M165.826 276.157L166.39 275.939C166.828 275.686 167.957 275.133 168.475 275.03C169.823 274.616 171.332 274.547 172.588 274.88C172.772 274.926 172.945 275.018 173.129 275.053C173.452 275.122 175.41 276.111 175.652 276.261L185.778 282.106L195.8 287.882C196.111 288.066 198.081 289.343 198.15 289.642C198.323 289.803 198.461 289.987 198.576 290.171C199.279 291.31 198.761 292.691 197.102 293.646L196.537 293.864C196.1 294.118 194.971 294.67 194.452 294.773C193.105 295.188 191.595 295.245 190.34 294.923C190.155 294.877 189.983 294.785 189.798 294.75C189.476 294.681 187.517 293.692 187.276 293.542L177.15 287.697L167.128 281.922C166.817 281.738 164.847 280.46 164.778 280.161C164.605 280 164.467 279.816 164.351 279.632C163.649 278.493 164.167 277.112 165.826 276.157Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M165.93 276.33L166.483 276.134C166.966 275.858 167.957 275.398 168.545 275.283C169.892 274.915 171.378 274.892 172.588 275.26C172.772 275.317 172.934 275.409 173.106 275.455C173.314 275.513 175.387 276.606 175.549 276.698L185.467 282.416L195.27 288.066C195.478 288.181 197.597 289.504 197.643 289.699C197.828 289.849 197.989 290.022 198.116 290.194C198.91 291.276 198.45 292.645 196.802 293.6L196.249 293.795C195.766 294.072 194.775 294.532 194.187 294.647C192.84 295.015 191.354 295.027 190.144 294.67C189.96 294.612 189.798 294.52 189.626 294.474C189.418 294.417 187.345 293.324 187.183 293.232L177.265 287.513L167.473 281.864C167.266 281.749 165.146 280.426 165.1 280.23C164.916 280.081 164.755 279.908 164.628 279.736C163.833 278.654 164.294 277.285 165.941 276.33H165.93Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M166.033 276.514L166.586 276.33C167.127 276.019 167.968 275.674 168.625 275.536C169.973 275.214 171.447 275.248 172.588 275.651C172.761 275.709 172.933 275.789 173.083 275.858C173.187 275.858 175.364 277.089 175.445 277.135L185.156 282.739L194.729 288.261C194.832 288.319 197.102 289.676 197.125 289.78C197.332 289.918 197.493 290.068 197.632 290.229C198.53 291.253 198.104 292.61 196.468 293.565L195.915 293.749C195.374 294.06 194.533 294.405 193.876 294.543C192.528 294.865 191.054 294.831 189.913 294.428C189.741 294.371 189.568 294.29 189.418 294.221C189.314 294.221 187.137 292.99 187.057 292.944L177.345 287.341L167.773 281.818C167.669 281.761 165.4 280.403 165.377 280.299C165.169 280.161 165.008 280.012 164.87 279.851C163.971 278.827 164.397 277.469 166.033 276.514Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.245 293.956L177.461 287.157L165.676 280.357C164.04 279.413 164.248 277.768 166.137 276.687L166.678 276.525C168.568 275.444 171.413 275.317 173.049 276.261L184.833 283.061L196.618 289.86C198.254 290.804 198.046 292.449 196.157 293.531L195.616 293.692C193.727 294.773 190.881 294.9 189.245 293.956Z",
    fill: "black"
  }))), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M192.39 293.508L170.387 280.817C167.911 279.39 165.895 275.547 165.895 272.245V210.219C165.895 208.539 164.512 208.171 165.353 207.561C165.388 207.538 167.312 206.663 167.358 206.652C168.256 206.307 169.224 206.157 170.399 206.825L192.402 219.515C194.878 220.942 196.894 224.785 196.894 228.087V290.114C196.894 291.874 196.33 293.117 195.42 293.692C195.362 293.726 193.035 294.831 192.978 294.854C192.171 295.119 193.484 294.129 192.402 293.508H192.39Z",
    fill: "url(#paint157_linear_807_97)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M190.685 290.781L168.683 278.09C166.206 276.664 164.19 272.821 164.19 269.519V211.001C164.19 207.699 166.206 206.18 168.683 207.607L190.685 220.298C193.162 221.724 195.178 225.567 195.178 228.869V287.387C195.178 290.689 193.162 292.208 190.685 290.781Z",
    fill: "url(#paint158_radial_807_97)"
  }), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M190.294 294.497L168.291 281.807C165.814 280.38 163.798 276.537 163.798 273.235V211.208C163.798 207.906 165.814 206.387 168.291 207.814L190.294 220.505C192.77 221.931 194.786 225.774 194.786 229.076V291.103C194.786 294.405 192.77 295.924 190.294 294.497Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M164.409 273.626V211.53C164.409 208.631 166.171 207.308 168.349 208.562L190.225 221.184C192.402 222.438 194.164 225.809 194.164 228.697V290.793C194.164 293.692 192.402 295.015 190.225 293.761L168.349 281.139C166.171 279.885 164.409 276.526 164.409 273.626Z",
    fill: "url(#paint159_linear_807_97)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M165.284 270.474V212.186C165.284 209.759 166.759 208.643 168.579 209.701L189.994 222.047C191.814 223.094 193.289 225.912 193.289 228.34V286.627C193.289 289.055 191.814 290.171 189.994 289.113L168.579 276.767C166.759 275.72 165.284 272.901 165.284 270.474Z",
    fill: "url(#paint160_linear_807_97)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M168.832 210.345C167.116 209.356 165.722 210.15 165.722 212.117V271.06C165.722 273.028 167.116 275.421 168.832 276.411L189.752 288.468C191.469 289.458 192.863 288.664 192.863 286.697V227.753C192.863 225.786 191.469 223.393 189.752 222.403L168.832 210.345Z",
    fill: "url(#paint161_linear_807_97)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M195.374 242.619V238.672C195.374 238.166 195.685 237.579 196.065 237.361C196.445 237.142 196.756 237.372 196.756 237.878V241.825C196.756 242.331 196.445 242.918 196.065 243.136C195.685 243.355 195.374 243.125 195.374 242.619Z",
    fill: "url(#paint162_linear_807_97)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M195.788 243.067C195.593 243.067 195.523 242.826 195.523 242.618V238.672C195.523 238.223 195.8 237.683 196.134 237.487C196.203 237.441 196.272 237.429 196.33 237.429C196.526 237.429 196.595 237.671 196.595 237.878V241.825C196.595 242.273 196.318 242.814 195.984 243.01C195.915 243.056 195.846 243.067 195.788 243.067Z",
    fill: "url(#paint163_linear_807_97)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M195.719 242.722V238.776C195.719 238.327 195.996 237.786 196.33 237.591C196.387 237.556 196.457 237.533 196.503 237.533C196.457 237.475 196.399 237.429 196.318 237.429C196.261 237.429 196.192 237.452 196.123 237.487C195.788 237.683 195.512 238.223 195.512 238.672V242.618C195.512 242.826 195.581 243.067 195.777 243.067H195.8C195.742 242.975 195.719 242.837 195.719 242.711V242.722Z",
    fill: "url(#paint164_radial_807_97)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M189.752 222.403L168.832 210.345C167.116 209.356 165.722 210.15 165.722 212.117V271.06C165.722 273.028 167.116 275.421 168.832 276.411L189.752 288.468C191.469 289.458 192.863 288.664 192.863 286.697V227.753C192.863 225.786 191.469 223.393 189.752 222.403ZM192.586 286.697C192.586 287.306 192.448 287.813 192.171 288.146C191.918 288.457 191.572 288.618 191.146 288.618C190.766 288.618 190.328 288.48 189.89 288.227L168.971 276.169C167.335 275.225 165.999 272.924 165.999 271.049V212.106C165.999 210.921 166.552 210.184 167.439 210.184C167.819 210.184 168.256 210.322 168.694 210.575L189.614 222.633C191.25 223.577 192.586 225.878 192.586 227.753V286.697Z",
    fill: "#BCBEC0"
  }))), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M180.191 285.454C180.191 285.995 180.006 286.374 179.707 286.558C179.707 286.558 179.154 286.881 179.142 286.881C178.831 287.053 179.027 286.662 178.555 286.386C177.599 285.834 176.815 284.487 176.815 283.394C176.815 282.854 176.308 282.842 176.62 282.669C176.62 282.669 177.23 282.336 177.242 282.336C177.553 282.163 177.979 282.198 178.451 282.474C179.407 283.026 180.191 284.372 180.191 285.465V285.454Z",
    fill: "url(#paint165_linear_807_97)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M179.592 285.788C179.592 286.892 178.808 287.329 177.852 286.777C176.896 286.225 176.113 284.879 176.113 283.786C176.113 282.693 176.896 282.244 177.852 282.796C178.808 283.348 179.592 284.695 179.592 285.788Z",
    fill: "url(#paint166_linear_807_97)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M179.165 285.707C179.165 286.167 179.004 286.489 178.751 286.65C178.751 286.65 177.921 287.145 177.91 287.145C177.645 287.295 177.818 286.95 177.403 286.719C176.585 286.248 175.917 285.097 175.917 284.154C175.917 283.682 175.491 283.682 175.744 283.532L176.631 283.026C176.896 282.877 177.265 282.911 177.668 283.141C178.486 283.613 179.154 284.764 179.154 285.707H179.165Z",
    fill: "url(#paint167_linear_807_97)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M178.29 286.225C178.29 287.168 177.622 287.548 176.804 287.076C175.986 286.604 175.318 285.454 175.318 284.51C175.318 283.567 175.986 283.187 176.804 283.659C177.622 284.131 178.29 285.281 178.29 286.225Z",
    fill: "url(#paint168_linear_807_97)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M177.933 282.75C177.472 282.485 177.057 282.451 176.746 282.6C177.034 282.52 177.391 282.577 177.783 282.808C178.739 283.36 179.523 284.706 179.523 285.799C179.523 286.374 179.315 286.766 178.97 286.938C179.396 286.823 179.672 286.397 179.672 285.742C179.672 284.637 178.889 283.302 177.933 282.75Z",
    fill: "#E6E7E8"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M176.861 283.613C176.47 283.383 176.101 283.348 175.836 283.486C176.09 283.417 176.401 283.463 176.735 283.659C177.564 284.131 178.232 285.293 178.232 286.236C178.232 286.731 178.048 287.065 177.76 287.214C178.129 287.111 178.359 286.743 178.359 286.19C178.359 285.247 177.691 284.085 176.861 283.613Z",
    fill: "url(#paint169_radial_807_97)"
  }), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M177.587 285.972C177.587 286.512 177.207 286.731 176.723 286.466C176.251 286.19 175.859 285.523 175.859 284.982C175.859 284.441 176.24 284.223 176.723 284.487C177.196 284.763 177.587 285.431 177.587 285.972Z",
    fill: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M165.837 233.334C179.02 233.334 189.706 222.66 189.706 209.494C189.706 196.328 179.02 185.654 165.837 185.654C152.655 185.654 141.969 196.328 141.969 209.494C141.969 222.66 152.655 233.334 165.837 233.334Z",
    fill: "url(#paint170_radial_807_97)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M318.75 42.9618L323.933 45.9187V44.3885L318.75 41.4315V42.9618Z",
    fill: "url(#paint171_linear_807_97)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M320.915 55.4799L315.766 52.5115V54.0417L320.915 57.0102V55.4799Z",
    fill: "url(#paint172_linear_807_97)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M320.639 47.3339V45.8037L314.89 42.5476V44.0779L320.639 47.3339Z",
    fill: "url(#paint173_linear_807_97)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M314.591 48.588V50.1183L317.517 51.7981V50.2678L314.591 48.588Z",
    fill: "url(#paint174_linear_807_97)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M310.179 50.8661V49.3359L305.421 46.6436V48.1738L310.179 50.8661Z",
    fill: "url(#paint175_linear_807_97)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M323.127 53.501L319.049 51.1538V52.6841L323.127 55.0312V53.501Z",
    fill: "url(#paint176_linear_807_97)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M317.263 47.0348V48.565L319.683 49.9342V48.4155L317.263 47.0348Z",
    fill: "url(#paint177_linear_807_97)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M325.454 45.2629V46.7932L326.767 47.5526V46.0338L325.454 45.2629Z",
    fill: "url(#paint178_linear_807_97)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M315.731 47.6906V46.1604L310.812 43.3645V44.8947L315.731 47.6906Z",
    fill: "url(#paint179_linear_807_97)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M322.171 46.6781V48.2083L329.428 52.3504V50.8316L322.171 46.6781Z",
    fill: "url(#paint180_linear_807_97)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M313.082 49.2439V47.7136L306.907 44.262V45.7922L313.082 49.2439Z",
    fill: "url(#paint181_linear_807_97)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M308.393 35.5062V37.0365L313.232 39.7978V38.2791L308.393 35.5062Z",
    fill: "url(#paint182_linear_807_97)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M317.217 40.5572L314.764 39.142V40.6722L317.217 42.0874V40.5572Z",
    fill: "url(#paint183_linear_807_97)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M314.257 51.6486L311.699 50.1989V51.7291L314.257 53.1673V51.6486Z",
    fill: "url(#paint184_linear_807_97)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M328.069 57.8846L334.67 61.716V60.1857L328.069 56.3544V57.8846Z",
    fill: "url(#paint185_linear_807_97)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M303.889 45.7807L301.551 44.446V45.9763L303.889 47.3109V45.7807Z",
    fill: "url(#paint186_linear_807_97)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M296.781 29.0861V30.6163L307.161 36.5302V34.9999L296.781 29.0861Z",
    fill: "url(#paint187_linear_807_97)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M329.601 55.5949L332.032 57.0101V55.4799L329.601 54.0647V55.5949Z",
    fill: "url(#paint188_linear_807_97)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M330.949 53.2248L342.353 59.7715V58.2412L330.949 51.7061V53.2248Z",
    fill: "url(#paint189_linear_807_97)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M321.215 50.8087L328.092 54.7206V53.1903L321.215 49.2784V50.8087Z",
    fill: "url(#paint190_linear_807_97)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M328.299 46.9082V48.4269L333.783 51.5565V50.0377L328.299 46.9082Z",
    fill: "url(#paint191_linear_807_97)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M305.375 43.4106L301.551 41.2705V42.8008L305.375 44.9293V43.4106Z",
    fill: "url(#paint192_linear_807_97)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M326.56 55.4914L324.648 54.3868V55.9171L326.56 57.0216V55.4914Z",
    fill: "url(#paint193_linear_807_97)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M309.28 42.4901L301.551 38.095V39.6252L309.28 44.0204V42.4901Z",
    fill: "url(#paint194_linear_807_97)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M322.332 60.876L328.53 64.4083V62.878L322.332 59.3573V60.876Z",
    fill: "url(#paint195_linear_807_97)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M313.358 41.6732L301.551 34.9194V36.4497L313.358 43.2035V41.6732Z",
    fill: "url(#paint196_linear_807_97)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M320.915 68.0902L315.766 65.1217V66.652L320.915 69.6204V68.0902Z",
    fill: "url(#paint197_linear_807_97)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M320.639 59.9442V58.4139L314.89 55.1578V56.6881L320.639 59.9442Z",
    fill: "url(#paint198_linear_807_97)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M314.591 61.1982V62.7285L317.517 64.4083V62.8896L314.591 61.1982Z",
    fill: "url(#paint199_linear_807_97)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M310.179 63.4764V61.9462L305.421 59.2654V60.7956L310.179 63.4764Z",
    fill: "url(#paint200_linear_807_97)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M323.127 66.1227L319.049 63.764V65.2943L323.127 67.6414V66.1227Z",
    fill: "url(#paint201_linear_807_97)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M317.263 59.645V61.1753L319.683 62.5559V61.0257L317.263 59.645Z",
    fill: "url(#paint202_linear_807_97)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M315.731 60.3008V58.7821L310.812 55.9747V57.505L315.731 60.3008Z",
    fill: "url(#paint203_linear_807_97)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M313.082 61.8541V60.3354L306.907 56.8722V58.4024L313.082 61.8541Z",
    fill: "url(#paint204_linear_807_97)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M314.257 64.2588L311.699 62.8091V64.3393L314.257 65.789V64.2588Z",
    fill: "url(#paint205_linear_807_97)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M328.069 70.4948L334.67 74.3377V72.8074L328.069 68.9761V70.4948Z",
    fill: "url(#paint206_linear_807_97)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M303.889 58.4024L301.551 57.0563V58.5865L303.889 59.9212V58.4024Z",
    fill: "url(#paint207_linear_807_97)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M329.601 68.2052L332.032 69.6204V68.1016L329.601 66.6749V68.2052Z",
    fill: "url(#paint208_linear_807_97)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M321.215 63.4189L328.092 67.3308V65.8121L321.215 61.9001V63.4189Z",
    fill: "url(#paint209_linear_807_97)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M305.375 56.0208L301.551 53.8807V55.411L305.375 57.551V56.0208Z",
    fill: "url(#paint210_linear_807_97)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M326.56 68.1016L324.647 66.9971V68.5273L326.56 69.6319V68.1016Z",
    fill: "url(#paint211_linear_807_97)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M309.28 55.1118L301.551 50.7052V52.2354L309.28 56.6306V55.1118Z",
    fill: "url(#paint212_linear_807_97)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M313.761 67.0431V68.5733L316.181 69.954V68.4238L313.761 67.0431Z",
    fill: "url(#paint213_linear_807_97)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M312.229 67.7104V66.1802L307.31 63.3728V64.903L312.229 67.7104Z",
    fill: "url(#paint214_linear_807_97)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M326.087 75.6032L328.53 77.0299V75.4997L326.087 74.073V75.6032Z",
    fill: "url(#paint215_linear_807_97)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M317.713 70.817L324.59 74.7404V73.2101L317.713 69.2982V70.817Z",
    fill: "url(#paint216_linear_807_97)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M305.778 62.5099L298.049 58.1147V59.6335L305.778 64.0286V62.5099Z",
    fill: "url(#paint217_linear_807_97)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M313.358 54.2834L301.551 47.5411V49.0599L313.358 55.8137V54.2834Z",
    fill: "url(#paint218_linear_807_97)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M168.867 233.61L178.255 239.029C178.831 239.362 179.304 240.168 179.304 240.824V247.175C179.304 247.83 178.831 248.107 178.255 247.773L172.392 244.39L169.454 246.059V242.699L168.867 242.365C168.291 242.032 167.819 241.226 167.819 240.57V234.219C167.819 233.564 168.291 233.287 168.867 233.621V233.61Z",
    fill: "url(#paint219_linear_807_97)"
  }), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M171.643 238.948C171.954 239.477 171.954 240.041 171.643 240.214C171.332 240.386 170.837 240.099 170.537 239.581C170.226 239.052 170.226 238.488 170.537 238.315C170.848 238.143 171.344 238.43 171.643 238.948Z",
    fill: "white"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M174.189 240.409C174.5 240.939 174.5 241.502 174.189 241.675C173.878 241.848 173.383 241.56 173.083 241.042C172.772 240.513 172.772 239.949 173.083 239.777C173.394 239.604 173.89 239.892 174.189 240.409Z",
    fill: "white"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M176.723 241.882C177.034 242.411 177.034 242.975 176.723 243.148C176.412 243.32 175.917 243.033 175.618 242.515C175.307 241.986 175.307 241.422 175.618 241.249C175.929 241.077 176.424 241.364 176.723 241.882Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M168.867 258.197L181.354 265.4C181.93 265.733 182.403 266.539 182.403 267.194V273.546C182.403 274.201 181.93 274.478 181.354 274.144L172.392 268.978L169.454 270.646V267.286L168.867 266.953C168.291 266.619 167.819 265.814 167.819 265.158V258.807C167.819 258.151 168.291 257.875 168.867 258.209V258.197Z",
    fill: "url(#paint220_linear_807_97)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M189.003 231.562L169.086 220.079C168.372 219.665 167.796 219.998 167.796 220.815V228.639C167.796 229.456 168.372 230.446 169.086 230.86L184.66 239.846L188.278 246.07V241.928L189.003 242.342C189.718 242.757 190.294 242.423 190.294 241.606V233.782C190.294 232.965 189.718 231.976 189.003 231.562Z",
    fill: "url(#paint221_linear_807_97)"
  }), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M178.878 232.839L170.802 228.328V229.214L178.878 233.725V232.839Z",
    fill: "white"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M178.463 228.375L170.802 224.117V224.992L178.463 229.249V228.375Z",
    fill: "white"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M175.433 228.743L170.802 226.223V227.097L175.433 229.617V228.743Z",
    fill: "white"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M176.297 229.237V230.123L182.633 233.771V232.885L176.297 229.237Z",
    fill: "white"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M179.753 233.345V234.219L180.87 234.864V233.978L179.753 233.345Z",
    fill: "white"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M179.327 229.744L187.322 234.357V233.483L179.327 228.869V229.744Z",
    fill: "white"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M183.497 234.265L187.321 236.463V235.589L183.497 233.391V234.265Z",
    fill: "white"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M181.734 235.358L187.321 238.58V237.694L181.734 234.484V235.358Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M189.003 256.609L173.164 247.382C172.45 246.968 171.874 247.301 171.874 248.118V255.942C171.874 256.759 172.45 257.748 173.164 258.151L184.66 264.882L188.278 271.106V266.964L189.003 267.378C189.718 267.793 190.294 267.459 190.294 266.642V258.818C190.294 258.001 189.718 257.012 189.003 256.598V256.609Z",
    fill: "url(#paint222_linear_807_97)"
  }), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M178.877 257.898L174.88 255.643V256.517L178.877 258.772V257.898Z",
    fill: "white"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M178.463 253.422L174.88 251.42V252.295L178.463 254.297V253.422Z",
    fill: "white"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M176.17 254.251L174.88 253.537V254.412L176.17 255.125V254.251Z",
    fill: "white"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M177.034 254.745V255.631L182.633 258.818V257.944L177.034 254.745Z",
    fill: "white"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M179.753 258.393V259.267L180.87 259.911V259.037L179.753 258.393Z",
    fill: "white"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M179.327 254.803L187.321 259.405V258.531L179.327 253.917V254.803Z",
    fill: "white"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M183.497 259.313L187.321 261.522V260.636L183.497 258.439V259.313Z",
    fill: "white"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M181.734 260.406L187.321 263.628V262.753L181.734 259.532V260.406Z",
    fill: "white"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M173.544 263.731L169.961 261.729V262.604L173.544 264.606V263.731Z",
    fill: "white"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M171.252 264.548L169.961 263.835V264.709L171.252 265.434V264.548Z",
    fill: "white"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M172.116 265.054V265.929L177.714 269.116V268.241L172.116 265.054Z",
    fill: "white"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M174.408 265.1L179.903 268.287V267.413L174.408 264.226V265.1Z",
    fill: "white"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M178.578 269.622L179.903 270.393V269.519L178.578 268.736V269.622Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M101.719 30.7199L87.8837 38.7048C86.9967 39.211 86.2825 40.4421 86.2825 41.4546V50.0033C86.2825 51.0158 86.9967 51.4185 87.8837 50.9122L101.719 42.9273C102.606 42.4211 103.32 41.19 103.32 40.1775V31.6288C103.32 30.6163 102.606 30.2136 101.719 30.7199ZM102.468 40.6722C102.468 41.144 102.134 41.7192 101.719 41.9609L87.8837 49.9457C87.469 50.1874 87.1349 49.9918 87.1349 49.52V40.9714C87.1349 40.4996 87.469 39.9244 87.8837 39.6827L101.719 31.6979C102.134 31.4562 102.468 31.6518 102.468 32.1236V40.6722ZM97.5142 35.6903C96.3507 36.3691 95.3369 37.6923 94.807 39.096C94.2771 38.3136 93.2749 38.141 92.0999 38.8198C90.3835 39.8093 88.9896 42.214 88.9896 44.1814C88.9896 46.1489 90.3835 46.9428 92.0999 45.9533C93.2634 45.2745 94.2771 43.9513 94.807 42.5476C95.3369 43.33 96.3392 43.5026 97.5142 42.8238C99.2306 41.8343 100.624 39.4296 100.624 37.4622C100.624 35.4947 99.2306 34.7008 97.5142 35.6903Z",
    fill: "url(#paint223_linear_807_97)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M111.499 41.5121L68.6573 66.4793C67.9891 66.859 67.4592 67.7909 67.4592 68.5503V74.096C67.4592 74.8554 68.0007 75.166 68.6573 74.7863L111.499 49.8192C112.167 49.4395 112.697 48.5075 112.697 47.7482V42.2025C112.697 41.4431 112.156 41.1325 111.499 41.5121ZM112.063 48.1164C112.063 48.473 111.81 48.9102 111.499 49.0828L68.6573 74.05C68.3462 74.2341 68.0928 74.0845 68.0928 73.7278V68.1821C68.0928 67.8254 68.3462 67.3882 68.6573 67.2157L111.499 42.2485C111.81 42.0644 112.063 42.214 112.063 42.5707V48.1164Z",
    fill: "url(#paint224_linear_807_97)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M111.499 51.545L68.6573 76.5121C67.9891 76.8918 67.4592 77.8238 67.4592 78.5831V84.1288C67.4592 84.8882 68.0007 85.1989 68.6573 84.8192L111.499 59.852C112.167 59.4723 112.697 58.5404 112.697 57.781V52.2353C112.697 51.476 112.156 51.1653 111.499 51.545ZM112.063 58.1492C112.063 58.5059 111.81 58.9431 111.499 59.1157L68.6573 84.0828C68.3462 84.2669 68.0928 84.1173 68.0928 83.7607V78.215C68.0928 77.8583 68.3462 77.4211 68.6573 77.2485L111.499 52.2813C111.81 52.0972 112.063 52.2468 112.063 52.6035V58.1492Z",
    fill: "url(#paint225_linear_807_97)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M77.5159 45.2284L83.4946 41.7767V40.5571L77.5159 44.0088V45.2284Z",
    fill: "url(#paint226_linear_807_97)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M85.6604 44.9523L77.0898 49.8882C76.6751 50.1298 76.341 49.9342 76.341 49.4625V42.8468L91.6737 34.0105V35.9089L92.5261 35.4142V31.5828C92.5261 30.5703 91.8119 30.1676 90.9249 30.6739L77.0898 38.6587C76.2027 39.165 75.4885 40.3961 75.4885 41.4086V49.9572C75.4885 50.9697 76.2027 51.3724 77.0898 50.8662L85.6604 45.9303V44.9523Z",
    fill: "url(#paint227_linear_807_97)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3179 73.8658L76.6635 74.3836L76.8593 75.212L77.0206 74.2455L77.4007 73.233L78.2647 73.3021L77.873 74.3491L77.2625 75.3731L78.0689 74.6597L78.8292 74.2225V75.3961L78.0919 75.8218L77.3316 75.9944L77.9882 76.3741L78.3108 76.8573L77.4353 77.9503L77.0782 77.4326L76.8478 76.5466L76.698 77.5591L76.3179 78.5716L75.4424 78.4911L75.834 77.4556L76.41 76.5582L75.7188 77.2025L74.947 77.6512V76.4546L75.7419 75.9944L76.4791 75.8448L75.8225 75.5342L75.4539 74.9589L76.3294 73.8658H76.3179Z",
    fill: "white"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4211 70.9204L81.7667 71.4382L81.9626 72.2666L82.1238 71.3001L82.504 70.2876L83.368 70.3566L82.9763 71.4036L82.3658 72.4276L83.1721 71.7143L83.9324 71.2771V72.4507L83.1952 72.8764L82.4349 73.0489L83.0915 73.4286L83.414 73.9119L82.5385 75.0049L82.1814 74.4871L81.951 73.6012L81.8013 74.6137L81.4211 75.6262L80.5456 75.5457L80.9373 74.5102L81.5133 73.6127L80.8221 74.257L80.0503 74.7057V73.5092L80.8452 73.0489L81.5824 72.8994L80.9258 72.5887L80.5572 72.0134L81.4327 70.9204H81.4211Z",
    fill: "white"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5127 67.9864L86.8583 68.5042L87.0541 69.3326L87.2154 68.3661L87.5955 67.3536L88.4595 67.4227L88.0678 68.4697L87.4573 69.4937L88.2637 68.7803L89.024 68.3431V69.5167L88.2867 69.9424L87.5264 70.115L88.183 70.4947L88.5056 70.9779L87.6301 72.0709L87.273 71.5532L87.0426 70.6672L86.8928 71.6797L86.5127 72.6922L85.6372 72.6117L86.0289 71.5762L86.6048 70.6788L85.9137 71.3231L85.1418 71.7718V70.5752L85.9367 70.115L86.674 69.9654L86.0173 69.6548L85.6487 69.0795L86.5242 67.9864H86.5127Z",
    fill: "white"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6045 65.0526L91.9501 65.5704L92.1459 66.3988L92.3072 65.4323L92.6873 64.4198L93.5513 64.4888L93.1596 65.5358L92.5491 66.5598L93.3555 65.8465L94.1158 65.4093V66.5828L93.3785 67.0086L92.6182 67.1811L93.2748 67.5608L93.5974 68.0441L92.7219 69.1371L92.3648 68.6193L92.1344 67.7334L91.9846 68.7459L91.6045 69.7584L90.729 69.6779L91.1207 68.6424L91.6966 67.7449L91.0055 68.3892L90.2336 68.838V67.6414L91.0285 67.1811L91.7658 67.0316L91.1091 66.7209L90.7405 66.1456L91.616 65.0526H91.6045Z",
    fill: "white"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6963 62.1072L97.0419 62.6249L97.2377 63.4533L97.399 62.4869L97.7791 61.4744L98.6431 61.5434L98.2514 62.5904L97.6409 63.6144L98.4473 62.9011L99.2076 62.4638V63.6374L98.4703 64.0631L97.71 64.2357L98.3666 64.6154L98.6892 65.0986L97.8137 66.1917L97.4566 65.6739L97.2262 64.788L97.0764 65.8005L96.6963 66.813L95.8208 66.7324L96.2125 65.6969L96.7884 64.7995L96.0973 65.4438L95.3254 65.8925V64.6959L96.1203 64.2357L96.8576 64.0861L96.2009 63.7755L95.8323 63.2002L96.7078 62.1072H96.6963Z",
    fill: "white"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M101.788 59.1732L102.133 59.691L102.329 60.5194L102.491 59.5529L102.871 58.5404L103.735 58.6094L103.343 59.6564L102.732 60.6804L103.539 59.9671L104.299 59.5299V60.7035L103.562 61.1292L102.802 61.3017L103.458 61.6814L103.781 62.1647L102.905 63.2577L102.548 62.7399L102.318 61.854L102.168 62.8665L101.788 63.879L100.912 63.7985L101.304 62.763L101.88 61.8655L101.189 62.5098L100.417 62.9586V61.762L101.212 61.3017L101.949 61.1522L101.292 60.8415L100.924 60.2662L101.799 59.1732H101.788Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3179 63.8215L76.6635 64.3393L76.8593 65.1677L77.0206 64.2012L77.4007 63.1887L78.2647 63.2578L77.873 64.3048L77.2625 65.3288L78.0689 64.6154L78.8292 64.1782V65.3518L78.0919 65.7775L77.3316 65.9501L77.9882 66.3298L78.3108 66.813L77.4353 67.906L77.0782 67.3883L76.8478 66.5023L76.698 67.5148L76.3179 68.5273L75.4424 68.4468L75.834 67.4113L76.41 66.5138L75.7188 67.1582L74.947 67.6069V66.4103L75.7419 65.9501L76.4791 65.8005L75.8225 65.4898L75.4539 64.9146L76.3294 63.8215H76.3179Z",
    fill: "white"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4211 60.8761L81.7667 61.3938L81.9626 62.2223L82.1238 61.2558L82.504 60.2433L83.368 60.3123L82.9763 61.3593L82.3658 62.3833L83.1721 61.67L83.9324 61.2328V62.4063L83.1952 62.832L82.4349 63.0046L83.0915 63.3843L83.414 63.8675L82.5385 64.9606L82.1814 64.4428L81.951 63.5569L81.8013 64.5694L81.4211 65.5819L80.5456 65.5013L80.9373 64.4658L81.5133 63.5684L80.8221 64.2127L80.0503 64.6614V63.4649L80.8452 63.0046L81.5824 62.8551L80.9258 62.5444L80.5572 61.9691L81.4327 60.8761H81.4211Z",
    fill: "white"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5127 57.9421L86.8583 58.4599L87.0541 59.2883L87.2154 58.3218L87.5955 57.3093L88.4595 57.3784L88.0678 58.4254L87.4573 59.4494L88.2637 58.736L89.024 58.2988V59.4724L88.2867 59.8981L87.5264 60.0707L88.183 60.4504L88.5056 60.9336L87.6301 62.0266L87.273 61.5089L87.0426 60.6229L86.8928 61.6354L86.5127 62.6479L85.6372 62.5674L86.0289 61.5319L86.6048 60.6344L85.9137 61.2788L85.1418 61.7275V60.5309L85.9367 60.0707L86.674 59.9211L86.0173 59.6104L85.6487 59.0352L86.5242 57.9421H86.5127Z",
    fill: "white"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6045 55.0083L91.9501 55.526L92.1459 56.3545L92.3072 55.388L92.6873 54.3755L93.5513 54.4445L93.1596 55.4915L92.5491 56.5155L93.3555 55.8022L94.1158 55.365V56.5385L93.3785 56.9642L92.6182 57.1368L93.2748 57.5165L93.5974 57.9998L92.7219 59.0928L92.3648 58.575L92.1344 57.6891L91.9846 58.7016L91.6045 59.7141L90.729 59.6336L91.1207 58.598L91.6966 57.7006L91.0055 58.3449L90.2336 58.7936V57.5971L91.0285 57.1368L91.7658 56.9873L91.1091 56.6766L90.7405 56.1013L91.616 55.0083H91.6045Z",
    fill: "white"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6963 52.0743L97.0419 52.5921L97.2377 53.4205L97.399 52.454L97.7791 51.4415L98.6431 51.5106L98.2514 52.5576L97.6409 53.5816L98.4473 52.8682L99.2076 52.431V53.6046L98.4703 54.0303L97.71 54.2029L98.3666 54.5826L98.6892 55.0658L97.8137 56.1588L97.4566 55.6411L97.2262 54.7551L97.0764 55.7676L96.6963 56.7801L95.8208 56.6996L96.2125 55.6641L96.7884 54.7666L96.0973 55.411L95.3254 55.8597V54.6631L96.1203 54.2029L96.8576 54.0533L96.2009 53.7426L95.8323 53.1674L96.7078 52.0743H96.6963Z",
    fill: "white"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M101.788 49.1289L102.133 49.6467L102.329 50.4751L102.491 49.5086L102.871 48.4961L103.735 48.5651L103.343 49.6121L102.732 50.6361L103.539 49.9228L104.299 49.4856V50.6591L103.562 51.0849L102.802 51.2574L103.458 51.6371L103.781 52.1204L102.905 53.2134L102.548 52.6956L102.318 51.8097L102.168 52.8222L101.788 53.8347L100.912 53.7542L101.304 52.7186L101.88 51.8212L101.189 52.4655L100.417 52.9142V51.7177L101.212 51.2574L101.949 51.1079L101.292 50.7972L100.924 50.2219L101.799 49.1289H101.788Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M359.61 173.09L359.495 173.021V169.615C359.495 167.441 357.951 164.783 356.05 163.69L353.677 162.321C351.776 161.228 350.233 162.102 350.233 164.277V167.683L350.118 167.614C349.231 167.107 348.516 167.51 348.516 168.522V176.565C348.516 177.577 349.231 178.82 350.118 179.326L359.61 184.803C360.497 185.309 361.211 184.906 361.211 183.894V175.852C361.211 174.839 360.497 173.596 359.61 173.09ZM355.451 177.106V179.74L354.265 179.062V176.427C353.792 175.898 353.458 175.161 353.458 174.517C353.458 173.631 354.08 173.274 354.852 173.723C355.624 174.172 356.246 175.242 356.246 176.128C356.246 176.772 355.923 177.129 355.44 177.106H355.451ZM357.49 171.871L352.226 168.833V166.118C352.226 164.875 353.101 164.38 354.184 165.002L355.532 165.784C356.615 166.405 357.49 167.924 357.49 169.155V171.871Z",
    fill: "url(#paint228_linear_807_97)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M338.54 184.389C330.822 189.048 328.345 199.07 333.011 206.779C337.676 214.487 347.71 216.961 355.428 212.301C363.146 207.642 365.623 197.62 360.958 189.911C356.292 182.203 346.259 179.729 338.54 184.389Z",
    fill: "url(#paint229_radial_807_97)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.83,
    d: "M339.6 194.997C332.85 199.07 330.684 207.849 334.762 214.591C338.84 221.333 347.629 223.496 354.38 219.423C361.13 215.35 363.296 206.572 359.218 199.829C355.14 193.087 346.351 190.924 339.6 194.997Z",
    fill: "url(#paint230_radial_807_97)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.65,
    d: "M340.648 204.892C334.866 208.389 333.011 215.903 336.501 221.678C339.992 227.454 347.526 229.307 353.309 225.82C359.091 222.323 360.946 214.809 357.456 209.034C353.954 203.258 346.431 201.405 340.648 204.892Z",
    fill: "url(#paint231_radial_807_97)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M342.757 214.798C338.898 217.122 337.665 222.139 339.992 225.993C342.319 229.847 347.341 231.078 351.201 228.754C355.06 226.43 356.292 221.414 353.965 217.559C351.638 213.705 346.616 212.474 342.757 214.798Z",
    fill: "url(#paint232_radial_807_97)"
  }), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M176.804 284.464C143.501 281.634 112.109 273.131 86.4206 259.808L127.995 236.912V234.622L83.8287 258.957C83.5061 259.141 83.3103 259.474 83.3103 259.842C83.3103 260.211 83.5177 260.544 83.8402 260.717C110.117 274.696 142.464 283.579 176.816 286.489V284.464H176.804Z",
    fill: "url(#paint233_linear_807_97)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.3,
    d: "M159.144 300.975C125.841 298.145 94.4499 289.642 68.761 276.318L66.1575 275.467C65.835 275.651 65.6392 275.985 65.6392 276.353C65.6392 276.721 65.8465 277.055 66.1691 277.227C92.4455 291.207 124.793 300.089 159.144 303V300.975Z",
    fill: "url(#paint234_radial_807_97)"
  }), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M192.528 168.81L159.018 186.425C158.672 186.586 158.442 186.943 158.442 187.334V210.276L77.0781 254.607C55.9049 241.951 40.6644 226.58 32.1398 209.724L30.1584 210.299C38.9019 227.765 54.6378 243.619 76.5367 256.621C76.698 256.713 76.8707 256.759 77.0551 256.759C77.2163 256.759 77.3776 256.724 77.5274 256.644L159.928 211.76C160.25 211.588 160.458 211.243 160.458 210.875V187.955L193.392 170.616L192.528 168.799V168.81Z",
    fill: "url(#paint235_linear_807_97)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M196.468 204.201C217.31 204.201 234.206 187.326 234.206 166.509C234.206 145.692 217.31 128.817 196.468 128.817C175.626 128.817 158.729 145.692 158.729 166.509C158.729 187.326 175.626 204.201 196.468 204.201Z",
    fill: "url(#paint236_radial_807_97)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M102.871 217.697L106.338 223.554L196.595 170.616L193.127 164.76L102.871 217.697Z",
    fill: "black"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M111.245 213.348L193.231 165.266L196.203 170.283L114.217 218.365L111.245 213.348Z",
    fill: "url(#paint237_linear_807_97)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M119.609 208.999L193.335 165.761L195.811 169.949L122.085 213.187L119.609 208.999Z",
    fill: "url(#paint238_linear_807_97)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M127.972 204.65L193.438 166.256L195.42 169.615L129.965 208.01L127.972 204.65Z",
    fill: "url(#paint239_linear_807_97)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M136.335 200.301L193.542 166.762L195.028 169.282L137.833 202.821L136.335 200.301Z",
    fill: "url(#paint240_linear_807_97)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M202.988 207.826C223.831 207.826 240.727 190.95 240.727 170.133C240.727 149.316 223.831 132.441 202.988 132.441C182.146 132.441 165.25 149.316 165.25 170.133C165.25 190.95 182.146 207.826 202.988 207.826Z",
    fill: "url(#paint241_radial_807_97)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M109.402 221.31L112.87 227.167L203.115 174.241L199.659 168.384L109.402 221.31Z",
    fill: "black"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M117.766 216.973L199.763 168.879L202.735 173.907L120.738 221.989L117.766 216.973Z",
    fill: "url(#paint242_linear_807_97)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M126.14 212.623L199.866 169.385L202.343 173.573L128.617 216.811L126.14 212.623Z",
    fill: "url(#paint243_linear_807_97)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M134.504 208.274L199.958 169.88L201.951 173.24L136.485 211.622L134.504 208.274Z",
    fill: "url(#paint244_linear_807_97)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M142.867 203.925L200.062 170.375L201.56 172.906L144.365 206.445L142.867 203.925Z",
    fill: "url(#paint245_linear_807_97)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M181.527 149.285C170.768 155.786 167.312 169.765 173.821 180.511C180.329 191.258 194.326 194.709 205.085 188.209C215.844 181.708 219.3 167.729 212.792 156.982C206.283 146.236 192.287 142.784 181.527 149.285Z",
    fill: "url(#paint246_radial_807_97)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M204.322 195.19C216.777 193.437 225.451 181.932 223.697 169.492C221.942 157.052 210.422 148.389 197.967 150.141C185.512 151.894 176.838 163.399 178.593 175.839C180.348 188.279 191.867 196.942 204.322 195.19Z",
    fill: "url(#paint247_radial_807_97)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M25.3317 200.543C17.6135 205.202 15.1368 215.224 19.8022 222.932C24.4677 230.641 34.5013 233.115 42.2195 228.455C49.9377 223.795 52.4144 213.774 47.749 206.065C43.0835 198.356 33.0498 195.883 25.3317 200.543Z",
    fill: "url(#paint248_radial_807_97)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.83,
    d: "M47.1672 234.392C53.6414 229.89 55.2352 220.998 50.7272 214.531C46.2191 208.065 37.3163 206.473 30.8421 210.976C24.368 215.478 22.7741 224.37 27.2822 230.836C31.7902 237.303 40.693 238.895 47.1672 234.392Z",
    fill: "url(#paint249_radial_807_97)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.65,
    d: "M38.7175 219.527C32.9346 223.024 31.08 230.538 34.5704 236.313C38.0724 242.089 45.5948 243.942 51.3776 240.455C57.1605 236.969 59.0152 229.445 55.5247 223.669C52.0343 217.893 44.5004 216.041 38.7175 219.527Z",
    fill: "url(#paint250_radial_807_97)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M46.7466 229.157C42.8876 231.481 41.655 236.498 43.9819 240.352C46.3089 244.206 51.3315 245.437 55.1906 243.113C59.0497 240.789 60.2823 235.773 57.9553 231.918C55.6283 228.064 50.6057 226.833 46.7466 229.157Z",
    fill: "url(#paint251_radial_807_97)"
  }), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0643 98.7985C75.9722 98.856 75.88 98.902 75.7879 98.9481C66.3417 104.551 58.0591 110.718 51.009 117.311H53.9696C60.5704 111.363 68.1964 105.782 76.8131 100.674C76.9513 100.593 77.1011 100.513 77.2509 100.421L76.0643 98.787V98.7985Z",
    fill: "url(#paint252_linear_807_97)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(366.499 223.094) scale(35.8953 35.8515)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_807_97",
    x1: 350.187,
    y1: 241.997,
    x2: 297.196,
    y2: 266.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#6E41D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(333.299 278.286) scale(37.8997 37.8534)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC3DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B5328C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#7E2361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#51163E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2D0C23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#14050F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#050104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_807_97",
    x1: 229.334,
    y1: 76.1786,
    x2: 278.576,
    y2: 85.4855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#6E41D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_807_97",
    x1: 143.097,
    y1: 46.0454,
    x2: 70.2431,
    y2: 173.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#6840CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#389BDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#20C9E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#35A0DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#4E71D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#624DD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#7032CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#7922C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.3796 109.901) scale(27.6011 27.5674)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC3DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B5328C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#7E2361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#51163E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2D0C23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#14050F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#050104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108.619 126.239) scale(27.6011 27.5674)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC3DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B5328C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#7E2361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#51163E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2D0C23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#14050F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#050104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(368.929 123.42) rotate(180) scale(27.6011 27.5674)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC3DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B5328C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#7E2361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#51163E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2D0C23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#14050F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#050104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(299.016 139.195) rotate(180) scale(27.6011 27.5674)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC3DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B5328C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#7E2361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#51163E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2D0C23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#14050F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#050104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(269.318 58.1033) rotate(-180) scale(27.6011 27.5674)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC3DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B5328C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#7E2361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#51163E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2D0C23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#14050F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#050104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_807_97",
    x1: 258.156,
    y1: 92.7696,
    x2: 349.933,
    y2: 92.7696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A07BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A782BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B28FC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#C3A5D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CCB2DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#DAC8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#EEE6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#EBDFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DDC7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D4B9E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_807_97",
    x1: 256.198,
    y1: 90.365,
    x2: 344.496,
    y2: 90.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_807_97",
    x1: 257.188,
    y1: 90.3649,
    x2: 343.505,
    y2: 90.3649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D065F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F27BD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(315.562 121.81) rotate(-22.3154) scale(16.0902 10.6103)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972A74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8A266A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#601A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3D112F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#22091A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0F040B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#030102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(285.568 77.4729) rotate(-18.9585) scale(12.336 7.27121)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972A74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8A266A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#601A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3D112F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#22091A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0F040B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#030102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_807_97",
    x1: 539.111,
    y1: 238.587,
    x2: 519.506,
    y2: 192.154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D065F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_807_97",
    x1: 293.706,
    y1: 70.1036,
    x2: 316.211,
    y2: 105.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_807_97",
    x1: 369.171,
    y1: 114.02,
    x2: 275.449,
    y2: 8.04353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A27CC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#AB87CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#BB9AD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3ECF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_807_97",
    x1: 358.734,
    y1: 117.369,
    x2: 293.046,
    y2: 18.1738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A0C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4299A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_807_97",
    x1: 290.019,
    y1: 23.2757,
    x2: 348.905,
    y2: 92.7715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#741BBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#55148B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#3B0D60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#25083D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#150422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#09020F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#020003"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_807_97",
    x1: 357.456,
    y1: 95.8646,
    x2: 312.389,
    y2: 23.7554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A07BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A782BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B28FC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#C3A5D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CCB2DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#DAC8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#EEE6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#EBDFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DDC7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D4B9E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(344.577 51.5909) scale(7.67211 7.66273)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(375.41 38.1317) rotate(67.6354) scale(3.59038 2.37171)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972A74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8A266A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#601A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3D112F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#22091A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0F040B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#030102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_807_97",
    x1: 332.481,
    y1: 107.129,
    x2: 335.103,
    y2: 102.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#838091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#A4A1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#B7B4C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9B98A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_807_97",
    x1: 335.154,
    y1: 106.772,
    x2: 332.842,
    y2: 102.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEBF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_807_97",
    x1: 333.621,
    y1: 107.359,
    x2: 335.864,
    y2: 103.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#838091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A4A1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#B7B4C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#9B98A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_807_97",
    x1: 336.086,
    y1: 107.152,
    x2: 334.109,
    y2: 103.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEBF2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(334.67 105.403) rotate(180) scale(1.62428 1.62229)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(292.948 26.8495) scale(20.3437 20.3189)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC3DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#BC3491"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#8B266B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#601A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#3D112F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#22091A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#0F040B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#030102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_807_97",
    x1: 117.777,
    y1: 92.7811,
    x2: 65.766,
    y2: 92.7811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A07BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A782BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B28FC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#C3A5D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CCB2DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#DAC8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#EEE6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#EBDFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DDC7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D4B9E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_807_97",
    x1: 102.975,
    y1: 95.0017,
    x2: 79.4073,
    y2: 81.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A27CC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#AB87CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#BB9AD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3ECF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_807_97",
    x1: 90.4643,
    y1: 88.8462,
    x2: 85.8532,
    y2: 81.0864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(89.0665 97.8936) rotate(-157.685) scale(10.124 6.67604)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972A74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8A266A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#601A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3D112F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#22091A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0F040B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#030102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_807_97",
    x1: 169.731,
    y1: -16.8903,
    x2: 42.3767,
    y2: 93.8558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A27CC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#AB87CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#BB9AD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3ECF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_807_97",
    x1: 173.221,
    y1: 74.6253,
    x2: 30.9645,
    y2: 37.1119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A0C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4299A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_807_97",
    x1: 35.3884,
    y1: 106.542,
    x2: 97.9224,
    y2: 6.48938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A07BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A782BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B28FC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#C3A5D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CCB2DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#DAC8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#EEE6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#EBDFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DDC7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D4B9E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.9906 45.1825) rotate(180) scale(10.6672 10.6542)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.2562 42.469) rotate(112.365) scale(6.40975 4.23412)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972A74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8A266A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#601A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3D112F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#22091A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0F040B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#030102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.0389 44.1239) scale(34.2134 34.1716)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC3DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#BC3491"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#8B266B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#601A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#3D112F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#22091A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#0F040B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#030102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_807_97",
    x1: 79.843,
    y1: 100.57,
    x2: 77.0259,
    y2: 95.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#838091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#A4A1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#B7B4C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9B98A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_807_97",
    x1: 76.9746,
    y1: 100.179,
    x2: 79.4583,
    y2: 95.8849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEBF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_807_97",
    x1: 78.6221,
    y1: 100.812,
    x2: 76.2074,
    y2: 96.6215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#838091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A4A1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#B7B4C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#9B98A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_807_97",
    x1: 75.9609,
    y1: 100.593,
    x2: 78.0996,
    y2: 96.9093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEBF2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(77.493 98.7065) scale(1.73947 1.73735)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_807_97",
    x1: 277.048,
    y1: 259.382,
    x2: 326.249,
    y2: 259.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#B086CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#B188CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#B791CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#DAC6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EFE5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E2D1ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_807_97",
    x1: 312.702,
    y1: 224.543,
    x2: 295.804,
    y2: 268.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(301.643 260.142) scale(18.1435 18.1213)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_807_97",
    x1: 278.88,
    y1: 250.051,
    x2: 324.417,
    y2: 250.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_807_97",
    x1: 278.88,
    y1: 249.004,
    x2: 324.417,
    y2: 249.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#6E41D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2AF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#37D2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4F92E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#625FD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#703BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#7825CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_807_97",
    x1: 0.000225395,
    y1: 246.346,
    x2: 1.15219,
    y2: 246.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#B086CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#B188CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#B791CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#DAC6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EFE5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E2D1ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_807_97",
    x1: 312.702,
    y1: 214.016,
    x2: 295.804,
    y2: 257.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(301.643 249.614) scale(18.1435 18.1213)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_807_97",
    x1: 0.000258441,
    y1: 239.524,
    x2: 1.15223,
    y2: 239.524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_807_97",
    x1: 0.000258441,
    y1: 238.477,
    x2: 1.15223,
    y2: 238.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#6E41D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2AF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#37D2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4F92E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#625FD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#703BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#7825CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_807_97",
    x1: 0.000225395,
    y1: 235.819,
    x2: 1.15219,
    y2: 235.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#B086CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#B188CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#B791CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#DAC6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EFE5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E2D1ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_807_97",
    x1: 312.702,
    y1: 203.488,
    x2: 295.804,
    y2: 247.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(301.643 239.086) scale(18.1435 18.1213)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_807_97",
    x1: 0.000258441,
    y1: 228.996,
    x2: 1.15223,
    y2: 228.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_807_97",
    x1: 0.000258441,
    y1: 227.949,
    x2: 1.15223,
    y2: 227.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#6E41D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2AF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#37D2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4F92E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#625FD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#703BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#7825CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_807_97",
    x1: 0.000225395,
    y1: 225.291,
    x2: 1.15219,
    y2: 225.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#B086CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#B188CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#B791CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#DAC6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EFE5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E2D1ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_807_97",
    x1: 312.702,
    y1: 192.96,
    x2: 295.804,
    y2: 236.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(301.643 228.559) scale(18.1435 18.1213)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_807_97",
    x1: 0.000258441,
    y1: 218.468,
    x2: 1.15223,
    y2: 218.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_807_97",
    x1: 0.000258441,
    y1: 217.421,
    x2: 1.15223,
    y2: 217.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#6E41D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2AF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#37D2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4F92E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#625FD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#703BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#7825CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_807_97",
    x1: 0.000225395,
    y1: 214.763,
    x2: 1.15219,
    y2: 214.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#B086CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#B188CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#B791CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#DAC6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EFE5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E2D1ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_807_97",
    x1: 312.702,
    y1: 182.433,
    x2: 295.804,
    y2: 226.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(301.643 218.02) scale(18.1435 18.1213)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_807_97",
    x1: 0.000258441,
    y1: 207.941,
    x2: 1.15223,
    y2: 207.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_807_97",
    x1: 0.000258441,
    y1: 206.894,
    x2: 1.15223,
    y2: 206.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#6E41D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2AF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#37D2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4F92E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#625FD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#703BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#7825CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_807_97",
    x1: 0.000225395,
    y1: 204.397,
    x2: 1.15219,
    y2: 204.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#B086CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#B188CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#B791CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#DAC6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EFE5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E2D1ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_807_97",
    x1: 312.702,
    y1: 172.078,
    x2: 295.804,
    y2: 215.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(301.643 207.664) scale(18.1435 18.1213)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_807_97",
    x1: 291.586,
    y1: 201.843,
    x2: 312.057,
    y2: 201.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E9DBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_807_97",
    x1: 314.107,
    y1: 183.71,
    x2: 297.644,
    y2: 201.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_807_97",
    x1: 309.488,
    y1: 195.825,
    x2: 293.418,
    y2: 195.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E9DBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(298.544 202.015) scale(7.6721 7.66274)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_807_97",
    x1: 291.31,
    y1: 272.13,
    x2: 305.349,
    y2: 267.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_807_97",
    x1: 266.462,
    y1: 274.029,
    x2: 303.712,
    y2: 265.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_807_97",
    x1: 291.805,
    y1: 254.239,
    x2: 285.734,
    y2: 265.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_807_97",
    x1: 285.815,
    y1: 271.659,
    x2: 283.009,
    y2: 266.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#838091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#A4A1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#B7B4C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9B98A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_807_97",
    x1: 282.958,
    y1: 271.268,
    x2: 285.442,
    y2: 266.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEBF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_807_97",
    x1: 284.594,
    y1: 271.9,
    x2: 282.179,
    y2: 267.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#838091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A4A1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#B7B4C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#9B98A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_807_97",
    x1: 281.944,
    y1: 271.682,
    x2: 284.072,
    y2: 267.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEBF2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(283.476 269.795) scale(1.73947 1.73734)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_807_97",
    x1: 231.292,
    y1: 71.91,
    x2: 227.072,
    y2: 64.7029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#6E41D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_807_97",
    x1: 182.552,
    y1: 71.0815,
    x2: 187.936,
    y2: 64.6664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#6E41D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_807_97",
    x1: 273.604,
    y1: 277.469,
    x2: 281.38,
    y2: 268.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#6E41D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_807_97",
    x1: 372.039,
    y1: 174.586,
    x2: 341.184,
    y2: 103.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#6E41D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_807_97",
    x1: 359.264,
    y1: 198.046,
    x2: 373.304,
    y2: 193.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_807_97",
    x1: 334.405,
    y1: 199.933,
    x2: 371.655,
    y2: 191.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_807_97",
    x1: 359.759,
    y1: 180.143,
    x2: 353.689,
    y2: 191.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_807_97",
    x1: 353.769,
    y1: 197.563,
    x2: 350.952,
    y2: 192.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#838091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#A4A1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#B7B4C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9B98A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_807_97",
    x1: 350.901,
    y1: 197.183,
    x2: 353.385,
    y2: 192.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEBF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_807_97",
    x1: 352.548,
    y1: 197.804,
    x2: 350.134,
    y2: 193.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#838091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A4A1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#B7B4C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#9B98A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_807_97",
    x1: 349.887,
    y1: 197.586,
    x2: 352.026,
    y2: 193.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEBF2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(351.419 195.71) scale(1.73946 1.73734)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_807_97",
    x1: 381.843,
    y1: 165.094,
    x2: 312.272,
    y2: 205.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF9DD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B998D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A98BD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#A588D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#B086CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#B188CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#BC97D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_807_97",
    x1: 374.182,
    y1: 220.183,
    x2: 327.344,
    y2: 123.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A0C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4299A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_807_97",
    x1: 345.418,
    y1: 156.672,
    x2: 339.316,
    y2: 160.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_807_97",
    x1: 373.56,
    y1: 169.949,
    x2: 322.076,
    y2: 199.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_807_97",
    x1: 349.956,
    y1: 144.211,
    x2: 384.798,
    y2: 202.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF9DD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C2A2D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#CCB2DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#D4BDE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#D2BBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CEB4DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F9F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E9DBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#8A6AC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#9B7DCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#A588D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E3CEF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#D7BDE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#C19FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#B48CCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#B086CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#B188CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#BC97D5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint101_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(366.755 162.405) rotate(-22.3154) scale(13.4065 6.02769)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972A74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8A266A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#601A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3D112F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#22091A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0F040B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#030102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint102_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(385.005 185.29) rotate(-29.0003) scale(9.47796 3.12571)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B61B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#38488A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#273260"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#19203D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#0E1222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#06080F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#010103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(334.958 157.696) scale(3.9167 3.9119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint104_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(360.935 168.315) scale(23.9494 23.9201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_807_97",
    x1: 345.533,
    y1: 239.984,
    x2: 348.831,
    y2: 194.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#6E41D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint106_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.287 205.593) scale(31.4411 15.9675)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#5F5C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_807_97",
    x1: 6.34738,
    y1: 201.785,
    x2: 56.3889,
    y2: 201.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E9DBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_807_97",
    x1: 61.3884,
    y1: 158.605,
    x2: 21.1567,
    y2: 201.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint109_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.3734 203.327) scale(18.754 18.7311)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_807_97",
    x1: 8.07532,
    y1: 192.834,
    x2: 54.6839,
    y2: 192.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#270551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#2D085D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#380B72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_807_97",
    x1: 8.07532,
    y1: 191.718,
    x2: 54.6839,
    y2: 191.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#6E41D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2AF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#37D2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4F92E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#625FD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#703BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#7825CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_807_97",
    x1: 6.34738,
    y1: 187.886,
    x2: 56.3889,
    y2: 187.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E9DBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_807_97",
    x1: 61.3884,
    y1: 144.706,
    x2: 21.1568,
    y2: 187.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint114_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.3734 189.428) scale(18.754 18.7311)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_807_97",
    x1: -63.1508,
    y1: 178.935,
    x2: -61.9989,
    y2: 178.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#270551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#2D085D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#380B72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_807_97",
    x1: 8.07532,
    y1: 177.819,
    x2: 54.6839,
    y2: 177.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#6E41D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2AF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#37D2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4F92E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#625FD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#703BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#7825CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_807_97",
    x1: 6.34738,
    y1: 174.379,
    x2: 56.3889,
    y2: 174.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E9DBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_807_97",
    x1: 61.3884,
    y1: 131.198,
    x2: 21.1568,
    y2: 174.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint119_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.3734 175.921) scale(18.754 18.7311)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_807_97",
    x1: -63.1508,
    y1: 165.428,
    x2: -61.9989,
    y2: 165.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#270551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#2D085D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#380B72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_807_97",
    x1: 8.07532,
    y1: 164.311,
    x2: 54.6839,
    y2: 164.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#6E41D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2AF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#37D2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4F92E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#625FD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#703BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#7825CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_807_97",
    x1: 6.34738,
    y1: 160.722,
    x2: 56.3889,
    y2: 160.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E9DBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_807_97",
    x1: 61.3884,
    y1: 117.53,
    x2: 21.1568,
    y2: 160.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint124_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.3734 162.252) scale(18.754 18.7311)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_807_97",
    x1: -63.1508,
    y1: 151.77,
    x2: -61.9989,
    y2: 151.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#270551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#2D085D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#380B72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_807_97",
    x1: 8.07532,
    y1: 150.643,
    x2: 54.6839,
    y2: 150.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#6E41D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2AF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#37D2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4F92E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#625FD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#703BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#7825CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_807_97",
    x1: 6.34738,
    y1: 147.053,
    x2: 56.3889,
    y2: 147.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E9DBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_807_97",
    x1: 61.3884,
    y1: 103.873,
    x2: 21.1568,
    y2: 147.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint129_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.3734 148.595) scale(18.754 18.7311)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint130_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.4928 143.284) scale(12.8456 6.52367)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#5F5C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_807_97",
    x1: 21.4498,
    y1: 135.927,
    x2: 41.4825,
    y2: 135.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E9DBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_807_97",
    x1: 43.4754,
    y1: 118.197,
    x2: 27.3805,
    y2: 135.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_807_97",
    x1: 38.9712,
    y1: 130.036,
    x2: 23.2468,
    y2: 130.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E9DBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint134_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.2695 136.088) scale(7.49931 7.49015)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_807_97",
    x1: 29.9972,
    y1: 212.094,
    x2: 33.7572,
    y2: 205.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEBF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_807_97",
    x1: 29.5825,
    y1: 212.784,
    x2: 32.6181,
    y2: 207.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEBF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_807_97",
    x1: 139.837,
    y1: 126.412,
    x2: 345.994,
    y2: 14.6196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A27CC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#AB87CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#BB9AD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3ECF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_807_97",
    x1: 100.67,
    y1: 78.3071,
    x2: 219.142,
    y2: 99.1125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A27CC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#AB87CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#BB9AD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3ECF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_807_97",
    x1: 183.877,
    y1: 1.40367,
    x2: 296.146,
    y2: 115.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A27CC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#AB87CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#BB9AD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3ECF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_807_97",
    x1: 245.404,
    y1: 123.777,
    x2: 343.7,
    y2: 179.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A27CC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#AB87CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#BB9AD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3ECF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_807_97",
    x1: 95.6479,
    y1: 85.5211,
    x2: 211.481,
    y2: 105.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_807_97",
    x1: 177,
    y1: 10.3205,
    x2: 286.784,
    y2: 121.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_807_97",
    x1: 237.167,
    y1: 129.979,
    x2: 333.276,
    y2: 184.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint144_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(206.87 94.6681) scale(67.3671 67.2848)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint145_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(212.388 187.304) scale(54.419 23.3716)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#343132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#7B797A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#B4B2B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_807_97",
    x1: 127.131,
    y1: 137.929,
    x2: 333.276,
    y2: 26.1482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A27CC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#AB87CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#BB9AD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3ECF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_807_97",
    x1: 87.9526,
    y1: 89.8356,
    x2: 206.424,
    y2: 110.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A27CC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#AB87CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#BB9AD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3ECF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_807_97",
    x1: 171.171,
    y1: 12.9322,
    x2: 283.44,
    y2: 127.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A27CC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#AB87CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#BB9AD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3ECF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_807_97",
    x1: 232.697,
    y1: 135.306,
    x2: 330.982,
    y2: 191.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A27CC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#AB87CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#BB9AD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3ECF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_807_97",
    x1: 143.42,
    y1: 152.323,
    x2: 227.833,
    y2: 65.1336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#6E41D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_807_97",
    x1: 269.376,
    y1: 120.74,
    x2: 176.24,
    y2: 121.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#6E41D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint152_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(194.164 106.197) scale(67.3671 67.2848)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint153_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(221.201 41.8574) scale(107.121 106.991)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#4B61B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#4154A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#2A3667"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#171F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#0A0E1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#020307"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint154_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(193.381 109.038) scale(52.426 52.362)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_807_97",
    x1: 208.414,
    y1: 308.419,
    x2: 127.272,
    y2: 197.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#6E41D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint156_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(228.032 247.865) scale(38.614 38.5668)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC3DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B5328C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#7E2361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#51163E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2D0C23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#14050F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#050104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_807_97",
    x1: 157.843,
    y1: 209.425,
    x2: 187.532,
    y2: 260.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A07BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A782BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B28FC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#C3A5D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CCB2DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#DAC8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#EEE6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#EBDFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DDC7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D4B9E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint158_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(194.268 225.395) scale(31.7713 31.7324)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF8AFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_807_97",
    x1: 198.668,
    y1: 292.058,
    x2: 152.509,
    y2: 194.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A27CC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#AB87CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#BB9AD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3ECF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_807_97",
    x1: 165.284,
    y1: 249.407,
    x2: 193.3,
    y2: 249.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_807_97",
    x1: 219.888,
    y1: 333.616,
    x2: 149.907,
    y2: 188.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A0C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4299A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_807_97",
    x1: 3722.55,
    y1: -9729.45,
    x2: 3720.05,
    y2: -9722.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#290E52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F001F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_807_97",
    x1: 197.355,
    y1: 240.306,
    x2: 193.899,
    y2: 240.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D065F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F27BD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint164_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(195.616 238.833) scale(2.02746 2.02498)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#711F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#6B1D51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#5C1946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#421232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#1F0818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_807_97",
    x1: 179.73,
    y1: 286.524,
    x2: 177.108,
    y2: 281.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#838091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#A4A1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#B7B4C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9B98A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_807_97",
    x1: 177.057,
    y1: 286.156,
    x2: 179.369,
    y2: 282.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEBF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_807_97",
    x1: 178.589,
    y1: 286.742,
    x2: 176.347,
    y2: 282.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#838091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A4A1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#B7B4C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#9B98A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_807_97",
    x1: 176.113,
    y1: 286.547,
    x2: 178.102,
    y2: 283.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9D9EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D4D1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEBF2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint169_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(177.541 284.787) scale(1.62428 1.62229)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint170_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(165.837 209.494) scale(23.8688 23.8396)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC3DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#BC3491"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#8B266B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#601A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#3D112F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#22091A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#0F040B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#030102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_807_97",
    x1: 295.03,
    y1: 21.6419,
    x2: 343.848,
    y2: 62.6261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_807_97",
    x1: 288.326,
    y1: 29.6268,
    x2: 337.143,
    y2: 70.6111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_807_97",
    x1: 292.934,
    y1: 24.1386,
    x2: 341.751,
    y2: 65.1228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_807_97",
    x1: 289.639,
    y1: 28.0735,
    x2: 338.456,
    y2: 69.0464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_807_97",
    x1: 286.932,
    y1: 31.2836,
    x2: 335.749,
    y2: 72.2678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_807_97",
    x1: 290.284,
    y1: 27.3027,
    x2: 339.102,
    y2: 68.2755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_807_97",
    x1: 291.471,
    y1: 25.876,
    x2: 340.288,
    y2: 66.8603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_807_97",
    x1: 295.652,
    y1: 20.9056,
    x2: 344.469,
    y2: 61.8789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_807_97",
    x1: 290.791,
    y1: 26.6929,
    x2: 339.608,
    y2: 67.6769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_807_97",
    x1: 293.994,
    y1: 22.8845,
    x2: 342.811,
    y2: 63.8571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_807_97",
    x1: 288.833,
    y1: 29.0286,
    x2: 337.65,
    y2: 70.0126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_807_97",
    x1: 293.648,
    y1: 23.2873,
    x2: 342.465,
    y2: 64.2716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_807_97",
    x1: 294.328,
    y1: 22.4818,
    x2: 343.145,
    y2: 63.4546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_807_97",
    x1: 287.635,
    y1: 30.4553,
    x2: 336.452,
    y2: 71.4395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_807_97",
    x1: 291.598,
    y1: 25.738,
    x2: 340.415,
    y2: 66.7105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_807_97",
    x1: 286.264,
    y1: 32.089,
    x2: 335.069,
    y2: 73.0732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_807_97",
    x1: 292.392,
    y1: 24.783,
    x2: 341.21,
    y2: 65.7672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_807_97",
    x1: 293.095,
    y1: 23.9431,
    x2: 341.912,
    y2: 64.9276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_807_97",
    x1: 295.411,
    y1: 21.1932,
    x2: 344.228,
    y2: 62.1774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_807_97",
    x1: 292.289,
    y1: 24.9096,
    x2: 341.106,
    y2: 65.8823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_807_97",
    x1: 296.298,
    y1: 20.1347,
    x2: 345.115,
    y2: 61.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_807_97",
    x1: 287.934,
    y1: 30.0986,
    x2: 336.751,
    y2: 71.0829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_807_97",
    x1: 290.86,
    y1: 26.6123,
    x2: 339.678,
    y2: 67.5851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_807_97",
    x1: 289.743,
    y1: 27.9355,
    x2: 338.56,
    y2: 68.9199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_807_97",
    x1: 287.75,
    y1: 30.3172,
    x2: 336.567,
    y2: 71.3014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_807_97",
    x1: 291.574,
    y1: 25.761,
    x2: 340.392,
    y2: 66.7452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_807_97",
    x1: 295.549,
    y1: 40.7759,
    x2: 326.7,
    y2: 77.2287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_807_97",
    x1: 300.076,
    y1: 36.8984,
    x2: 331.227,
    y2: 73.3628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_807_97",
    x1: 296.493,
    y1: 39.9704,
    x2: 327.645,
    y2: 76.4234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_807_97",
    x1: 292.427,
    y1: 43.4337,
    x2: 323.59,
    y2: 79.8866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_807_97",
    x1: 297.956,
    y1: 38.7163,
    x2: 329.108,
    y2: 75.1693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_807_97",
    x1: 298.728,
    y1: 38.049,
    x2: 329.879,
    y2: 74.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_807_97",
    x1: 297.185,
    y1: 39.3722,
    x2: 328.347,
    y2: 75.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_807_97",
    x1: 294.696,
    y1: 41.5007,
    x2: 325.848,
    y2: 77.9535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_807_97",
    x1: 293.971,
    y1: 42.1105,
    x2: 325.133,
    y2: 78.5749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_807_97",
    x1: 300.952,
    y1: 36.1506,
    x2: 332.103,
    y2: 72.6033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_807_97",
    x1: 290.929,
    y1: 44.7223,
    x2: 322.081,
    y2: 81.1751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_807_97",
    x1: 302.368,
    y1: 34.9425,
    x2: 333.52,
    y2: 71.3956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_807_97",
    x1: 300.56,
    y1: 36.4958,
    x2: 331.711,
    y2: 72.9486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_807_97",
    x1: 292.726,
    y1: 43.1805,
    x2: 323.878,
    y2: 79.6335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_807_97",
    x1: 299.281,
    y1: 37.5772,
    x2: 330.432,
    y2: 74.0417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_807_97",
    x1: 294.869,
    y1: 41.3511,
    x2: 326.02,
    y2: 77.8041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_807_97",
    x1: 293.049,
    y1: 42.9044,
    x2: 324.2,
    y2: 79.3573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_807_97",
    x1: 291.505,
    y1: 44.2275,
    x2: 322.656,
    y2: 80.6805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_807_97",
    x1: 296.689,
    y1: 39.7978,
    x2: 327.841,
    y2: 76.2506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_807_97",
    x1: 294.869,
    y1: 41.3511,
    x2: 326.032,
    y2: 77.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_807_97",
    x1: 289.178,
    y1: 46.2064,
    x2: 320.341,
    y2: 82.6593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_807_97",
    x1: 297.035,
    y1: 39.4987,
    x2: 328.186,
    y2: 75.9631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_807_97",
    x1: 166.344,
    y1: 232.793,
    x2: 189.417,
    y2: 262.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#6C18B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#450E7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#2E0759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_807_97",
    x1: 166.678,
    y1: 256.724,
    x2: 194.007,
    y2: 291.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#6C18B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#450E7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#2E0759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_807_97",
    x1: 166.505,
    y1: 217.812,
    x2: 199.029,
    y2: 252.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#6C18B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#450E7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#2E0759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_807_97",
    x1: 170.307,
    y1: 245.886,
    x2: 198.436,
    y2: 275.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#6C18B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#450E7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#2E0759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_807_97",
    x1: 86.2825,
    y1: 40.8103,
    x2: 103.309,
    y2: 40.8103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_807_97",
    x1: 67.4477,
    y1: 58.1492,
    x2: 112.709,
    y2: 58.1492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_807_97",
    x1: 67.4477,
    y1: 68.1821,
    x2: 112.709,
    y2: 68.1821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_807_97",
    x1: 77.5159,
    y1: 42.8928,
    x2: 83.4946,
    y2: 42.8928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_807_97",
    x1: 75.5,
    y1: 40.7758,
    x2: 92.5377,
    y2: 40.7758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A56EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_807_97",
    x1: 346.616,
    y1: 161.665,
    x2: 371.778,
    y2: 198.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#6C18B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#450E7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#2E0759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25054D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint229_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(346.941 197.958) rotate(-121.181) scale(16.3088 16.318)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#A8B3DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#4B61B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#40539E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#313F79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#232E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#181F3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0F1426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#080B14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#030408"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#000101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint230_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(346.95 206.826) rotate(-121.181) scale(14.2716 14.2797)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#A8B3DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#4B61B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#40539E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#313F79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#232E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#181F3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0F1426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#080B14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#030408"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#000101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint231_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(346.937 214.967) rotate(-121.181) scale(12.2345 12.2414)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#A8B3DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#4B61B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#40539E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#313F79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#232E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#181F3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0F1426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#080B14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#030408"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#000101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint232_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(346.946 221.388) rotate(-121.181) scale(8.16014 8.16477)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#A8B3DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#4B61B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#40539E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#313F79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#232E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#181F3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0F1426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#080B14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#030408"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#000101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_807_97",
    x1: 148.235,
    y1: 297.052,
    x2: 101.908,
    y2: 233.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#6E41D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint234_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.386 289.228) scale(46.816 46.7588)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC3DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B5328C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#7E2361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#51163E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#2D0C23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#14050F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#050104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_807_97",
    x1: 211.398,
    y1: 194.778,
    x2: 27.0143,
    y2: 238.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#6E41D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint236_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(196.456 166.509) scale(37.7385 37.6923)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#DC3DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A22B9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3C0D78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2C0A58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#1E073C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#130426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#0A0214"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#040108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#000001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_807_97",
    x1: 194.936,
    y1: 167.821,
    x2: 113.911,
    y2: 215.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#072C35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#06262E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_807_97",
    x1: 194.775,
    y1: 167.901,
    x2: 121.912,
    y2: 210.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E586A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#06262E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_807_97",
    x1: 194.59,
    y1: 167.97,
    x2: 129.901,
    y2: 205.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14849F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#05262E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_807_97",
    x1: 194.429,
    y1: 168.051,
    x2: 137.914,
    y2: 201.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BB0D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#1487A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#05262E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint241_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(202.988 170.133) scale(37.7385 37.6923)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3C0D78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2C0A58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#1E073C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#130426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#0A0214"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#040108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#000001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_807_97",
    x1: 201.468,
    y1: 171.445,
    x2: 120.431,
    y2: 218.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#072C35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#06262E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_807_97",
    x1: 201.295,
    y1: 171.514,
    x2: 128.443,
    y2: 214.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E586A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#06262E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_807_97",
    x1: 201.122,
    y1: 171.594,
    x2: 136.433,
    y2: 209.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14849F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#05262E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_807_97",
    x1: 200.961,
    y1: 171.675,
    x2: 144.434,
    y2: 204.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BB0D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#1487A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#05262E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint246_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(193.268 168.362) rotate(-121.181) scale(22.754 22.7669)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#43E8E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#45BED4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#4B61B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#40539E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#313F79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#232E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#181F3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0F1426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#080B14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#030408"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#000101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint247_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(201.108 172.262) rotate(-121.181) scale(22.754 22.7669)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#A8B3DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#4B61B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#40539E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#313F79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#232E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#181F3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0F1426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#080B14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#030408"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#000101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint248_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.7349 214.094) rotate(-121.181) scale(16.3088 16.318)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#A8B3DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#4B61B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#40539E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#313F79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#232E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#181F3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0F1426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#080B14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#030408"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#000101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint249_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.0004 221.345) rotate(-121.181) scale(14.2716 14.2797)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#A8B3DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#4B61B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#40539E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#313F79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#232E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#181F3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0F1426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#080B14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#030408"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#000101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint250_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.0069 229.606) rotate(-121.181) scale(12.2345 12.2414)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#A8B3DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#4B61B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#40539E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#313F79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#232E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#181F3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0F1426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#080B14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#030408"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#000101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint251_radial_807_97",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.9319 235.749) rotate(-121.181) scale(8.16014 8.16478)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#A8B3DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#4B61B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#40539E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#313F79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#232E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#181F3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0F1426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#080B14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#030408"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#000101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_807_97",
    x1: 50.5367,
    y1: 119.313,
    x2: 77.4674,
    y2: 98.0186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#6E41D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AF6FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_807_97"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 401,
    height: 303,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.5a9ef8f1531dcb2e04ef7efe60b768ba.svg";
export { ForwardRef as ReactComponent };